export const LoginIllust = () => (
  <svg
    width="872"
    height="573"
    viewBox="0 0 872 573"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M870.409 321.04L435.798 70.0801L1.18646 321.04L435.798 571.999L870.409 321.04Z"
      fill="#E5EBF9"
      stroke="#4D5055"
      strokeWidth="0.745794"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M870.409 280.954L435.798 29.9941L1.18646 280.954L435.798 531.914L870.409 280.954Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="1.67804"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M870.409 280.954V293.26L435.798 544.219V531.914L870.409 280.954Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="1.67804"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.00006 280.954V293.26L435.798 544.219V531.914L1.00006 280.954Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="1.67804"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <mask
      id="mask0_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="29"
      width="870"
      height="503"
    >
      <path
        d="M870.409 280.954L435.798 29.9941L1.18643 280.954L435.798 531.914L870.409 280.954Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_918_8688)">
      <g opacity="0.6">
        <path
          d="M435.798 531.915L870.409 280.955"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M402.424 512.524L837.035 261.564"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M369.049 493.134L803.661 242.174"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M335.862 473.556L770.473 222.783"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M302.487 454.166L737.099 203.206"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M269.113 434.775L703.725 183.815"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M235.925 415.385L670.537 164.425"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M202.551 395.994L637.162 145.034"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M169.177 376.603L603.788 125.644"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M135.989 357.214L570.6 106.254"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M102.615 337.635L537.226 86.6758"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M69.2403 318.245L503.852 67.2852"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.0525 298.854L470.664 47.8945"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.67816 279.464L437.29 28.5039"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M435.798 531.915L1.00009 280.955"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M468.986 512.524L34.3744 261.564"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M502.36 493.134L67.7486 242.174"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M535.734 473.556L101.123 222.783"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M568.922 454.166L134.311 203.206"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M602.297 434.775L167.685 183.815"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M635.671 415.385L201.059 164.425"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M668.859 395.994L234.247 145.034"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M702.233 376.603L267.621 125.644"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M735.607 357.214L300.996 106.254"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M768.795 337.635L334.184 86.6758"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M802.169 318.245L367.558 67.2852"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M835.544 298.854L400.932 47.8945"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M868.918 279.464L434.12 28.5039"
          stroke="#4D5055"
          strokeWidth="0.559346"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <g style={{ mixBlendMode: 'multiply', opacity: 0.5 }}>
      <path
        d="M529.395 350.499C535.921 354.228 535.921 360.38 529.395 364.296L505.716 378.093C499.19 381.822 488.563 381.822 482.037 378.093L300.623 273.123C294.097 269.394 294.097 263.241 300.623 259.325L324.302 245.528C330.827 241.799 341.455 241.799 347.981 245.528L529.395 350.499Z"
        fill="#C2ECDF"
      />
    </g>
    <path
      d="M526.971 215.697C524.361 136.83 466.003 40.0628 391.983 9.29878C375.016 2.58663 355.812 -0.769439 337.913 4.82402C329.149 7.0614 303.979 23.2824 295.775 27.5707C315.725 15.8245 340.709 18.6212 361.405 27.0114C427.781 54.7922 478.308 132.355 492.665 201.154C500.496 239.749 499.75 291.209 462.274 314.142C467.867 310.786 495.275 295.497 499.75 291.582C506.275 286.361 511.496 279.836 515.411 272.564C524.734 255.224 527.531 235.088 526.971 215.697Z"
      fill="#4D5055"
      stroke="#4D5055"
      strokeWidth="2.23738"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M379.304 35.9608C444.188 73.4369 496.58 164.237 496.394 238.817C496.207 313.396 443.442 343.414 378.558 305.938C313.674 268.462 261.282 177.662 261.469 103.082C261.655 28.5028 314.42 -1.51539 379.304 35.9608Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="2.23738"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M376.134 57.0302C432.069 89.2858 477.376 167.594 477.19 231.919C477.19 296.244 431.51 322.16 375.575 289.904C319.641 257.649 274.334 179.34 274.52 115.016C274.52 50.6909 320.2 24.7746 376.134 57.0302Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="2.05093"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <mask
      id="mask1_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="274"
      y="43"
      width="204"
      height="261"
    >
      <path
        d="M376.134 57.0311C432.069 89.2867 477.376 167.595 477.19 231.92C477.19 296.245 431.51 322.161 375.575 289.905C319.641 257.65 274.334 179.341 274.52 115.017C274.52 50.6919 320.2 24.7755 376.134 57.0311Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_918_8688)">
      <path
        d="M386.762 74.3688V87.7931V88.3525L386.948 88.9118L387.508 89.4712C387.694 89.4712 388.067 89.8441 388.44 90.0305V90.5899L382.474 87.0473V86.488C382.847 86.6744 383.219 86.8609 383.406 86.8609C383.592 86.8609 383.779 86.8609 383.965 86.8609V86.488C384.152 86.488 384.152 86.1151 384.152 85.7422V76.4198V75.8604V75.3011L383.965 74.9282L383.592 74.5553L383.033 74.1824C382.847 74.1824 382.66 74.1824 382.287 74.1824V73.623L386.576 73.9959L386.762 74.3688Z"
        fill="#4D5055"
      />
      <path
        d="M394.033 69.5221V74.9291L388.254 71.573V66.166L394.033 69.5221Z"
        fill="#4D5055"
      />
      <path
        d="M394.593 256.902C394.779 257.648 394.966 258.394 394.966 259.326C394.966 260.072 394.966 260.818 394.593 261.191C394.406 261.75 394.033 262.123 393.661 262.309C393.288 262.496 392.915 262.682 392.355 262.682C391.796 262.682 391.423 262.682 390.864 262.123C390.305 261.75 389.745 261.377 389.186 260.818C388.626 260.258 388.067 259.513 387.694 258.767C387.321 258.021 386.948 257.089 386.576 255.97C386.389 255.038 386.203 253.919 386.203 252.801C386.203 252.055 386.203 251.309 386.576 250.75C386.576 250.19 386.948 249.631 387.321 249.072C387.694 248.512 388.067 248.326 388.626 247.953C389.186 247.58 389.745 247.58 390.304 247.394C390.864 247.394 391.61 247.394 392.355 247.394C393.101 247.394 393.847 247.953 394.593 248.326V248.885C394.033 248.699 393.288 248.512 392.728 248.512C392.169 248.512 391.61 248.512 391.237 248.885C390.864 249.072 390.491 249.445 390.118 250.004C389.745 250.563 389.559 251.123 389.372 251.868C389.745 251.868 389.932 251.868 390.304 251.868C390.677 251.868 391.05 252.055 391.423 252.241C391.796 252.428 392.355 252.801 392.728 253.173C393.101 253.546 393.474 254.106 393.847 254.665C394.22 255.224 394.406 255.97 394.593 256.53V256.902ZM392.355 260.445C392.355 260.072 392.355 259.513 392.355 259.14C392.355 257.648 392.355 256.343 391.796 255.411C391.237 254.479 391.05 253.733 390.304 253.36C389.745 252.987 389.372 252.987 388.999 253.36C388.813 253.733 388.626 254.292 388.626 255.224C388.626 255.784 388.626 256.53 388.626 257.089C388.626 257.835 388.626 258.394 388.999 258.953C388.999 259.513 389.372 260.072 389.559 260.631C389.745 261.191 390.118 261.564 390.491 261.75C390.864 261.937 391.05 261.937 391.237 261.75C391.237 261.75 391.61 261.564 391.61 261.377C391.61 261.191 391.796 260.818 391.796 260.445"
        fill="#4D5055"
      />
      <path
        d="M393.474 266.411V272.004L387.694 268.648V263.055L393.474 266.411Z"
        fill="#4D5055"
      />
      <path
        d="M349.472 55.7246L351.896 61.8774L346.862 62.2503L344.438 56.0975L349.472 55.7246Z"
        fill="#4D5055"
      />
      <path
        d="M431.883 258.58L432.255 258.953L431.51 261.004H431.137L426.289 258.207L425.543 259.699C426.103 260.072 426.662 260.444 427.035 260.817C427.594 261.19 428.154 261.563 428.526 262.123C429.459 263.055 430.391 264.173 430.95 265.292C431.323 265.851 431.51 266.411 431.696 267.157C432.069 268.275 432.069 270.14 431.696 271.258C430.018 274.055 425.916 271.445 424.425 269.767C424.238 269.394 424.052 269.208 423.865 269.021V268.275C423.865 267.902 423.865 267.716 423.865 267.53C424.238 267.343 424.984 267.902 425.17 268.089L425.73 268.835L426.289 269.58L426.848 270.326L427.408 271.072L427.967 271.445C428.154 271.445 428.526 271.631 428.713 271.631C429.272 271.631 429.645 271.258 430.018 270.699C430.95 267.902 428.713 265.106 426.476 263.241C425.73 262.682 424.984 262.123 424.052 261.563V261.19L426.289 255.97L431.323 258.953H431.51V258.766L431.883 258.58Z"
        fill="#4D5055"
      />
      <path
        d="M434.679 275.733L437.103 281.886L432.069 282.446L429.645 276.106L434.679 275.733Z"
        fill="#4D5055"
      />
      <path
        d="M310.691 80.8945L315.166 85.5557L314.606 86.6744L310.318 81.8268L310.691 80.8945Z"
        fill="#4D5055"
      />
      <path
        d="M316.098 72.3184L320.2 77.5389L317.403 81.6408L313.115 76.4202L316.098 72.3184Z"
        fill="#4D5055"
      />
      <path
        d="M458.545 263.987L462.46 269.394L461.714 270.14L457.799 264.733L458.545 263.987Z"
        fill="#4D5055"
      />
      <path
        d="M464.325 256.53L468.426 261.751L465.63 265.853L461.341 260.632L464.325 256.53Z"
        fill="#4D5055"
      />
      <path
        d="M307.521 117.626V124.338L302.674 121.541V114.829L307.521 117.626Z"
        fill="#4D5055"
      />
      <path
        d="M479.054 216.63V223.342L474.02 220.545L474.206 213.833L479.054 216.63Z"
        fill="#4D5055"
      />
      <path
        d="M317.03 171.51L320.013 178.968L315.725 179.341L312.928 171.883L317.03 171.51Z"
        fill="#4D5055"
      />
      <path
        d="M465.816 158.644L468.799 166.288L464.511 166.474L461.714 159.016L465.816 158.644Z"
        fill="#4D5055"
      />
      <path
        d="M358.049 216.443V217.188L353.947 229.121L352.269 228.189L355.998 217.561C355.252 217.188 352.083 215.137 351.523 214.951C351.337 214.951 351.15 214.951 350.964 214.951H350.591C350.591 215.324 350.404 215.51 350.218 215.697L349.845 215.324L350.777 211.968L358.422 216.443H358.049Z"
        fill="#4D5055"
      />
      <path
        d="M346.489 224.834L351.523 230.987L349.099 234.343L344.065 228.19L346.489 224.834Z"
        fill="#4D5055"
      />
      <path
        d="M430.95 112.591V126.016V126.575L431.137 127.134L431.696 127.694C431.883 127.694 432.255 128.067 432.628 128.253V128.813L426.662 125.27V124.711C427.035 124.897 427.408 125.084 427.594 125.084C427.781 125.084 427.967 125.084 428.154 125.084V124.711C428.34 124.711 428.34 124.338 428.34 123.965V114.642V114.083V113.524L428.154 113.151L427.781 112.778L427.221 112.405C427.035 112.405 426.848 112.405 426.476 112.405V111.846L430.764 112.219L430.95 112.591Z"
        fill="#4D5055"
      />
      <path
        d="M432.628 103.642L437.662 109.794L435.239 113.337L430.205 106.998L432.628 103.642Z"
        fill="#4D5055"
      />
      <path
        d="M395.525 79.2166C396.084 79.5895 396.644 79.9624 397.203 80.5217C397.576 81.0811 397.949 81.454 398.322 82.0133C398.695 82.5726 398.881 83.132 398.881 83.6913C399.068 84.81 399.254 86.3016 398.695 87.2339C398.322 87.7932 397.949 88.3525 397.39 88.7254C396.83 89.0983 396.271 89.6577 395.712 90.0306C395.152 90.4035 394.406 90.7764 393.847 91.1493L397.949 93.5731H398.508C398.508 93.7596 398.881 93.7596 398.881 93.7596H399.254C399.254 93.3867 399.44 93.2002 399.627 93.0138L400 93.3867L399.254 96.5563L391.423 92.0815V91.7086C392.542 90.9628 393.474 90.217 394.406 89.4712C394.779 89.0983 395.152 88.7254 395.339 88.539C395.525 88.1661 395.898 87.7932 396.084 87.4203C396.084 87.0474 396.457 86.6745 396.457 86.3016C396.83 84.81 396.457 82.9455 395.339 81.8269C394.406 80.7082 392.542 80.1488 391.983 81.8269L391.61 81.454C391.61 80.8946 391.983 80.3353 392.169 79.9624C392.542 79.2166 393.288 78.6572 394.22 78.6572C394.593 78.6572 395.152 78.8437 395.712 79.2166H395.525Z"
        fill="#4D5055"
      />
      <path
        d="M353.388 67.8434V81.2677V81.827L353.574 82.3864L354.133 82.9457C354.32 82.9457 354.693 83.3186 355.066 83.505V84.0644L349.099 80.5219V79.9625C349.472 80.149 349.845 80.3354 350.032 80.3354C350.218 80.3354 350.404 80.3354 350.591 80.3354V79.9625C350.777 79.9625 350.777 79.5896 350.777 79.2167V69.8943V69.335V68.7756L350.591 68.2163L350.218 67.8434L349.659 67.4705C349.472 67.4705 349.286 67.4705 348.913 67.4705V66.9111L353.201 67.284L353.388 67.8434Z"
        fill="#4D5055"
      />
      <path
        d="M363.456 73.6236V87.0479V87.6073L363.642 88.1666L364.202 88.726C364.388 88.726 364.761 89.0989 365.134 89.2853V89.8447L359.168 86.3021V85.7428C359.54 85.9293 359.913 86.1157 360.1 86.1157C360.286 86.1157 360.473 86.1157 360.659 86.1157V85.7428C360.846 85.7428 360.846 85.3699 360.846 84.997V75.6746V75.1152V74.5559L360.659 73.9965L360.286 73.6236L359.727 73.2508C359.541 73.2508 359.354 73.2508 358.981 73.2508V72.6914L363.269 73.0643L363.456 73.6236Z"
        fill="#4D5055"
      />
      <path
        d="M458.172 162C460.969 163.491 462.647 167.22 461.341 170.017C460.223 171.882 458.358 172.814 456.494 173.933C456.68 173.933 461.155 176.543 461.155 176.543H461.528L461.901 176.356C461.901 176.356 462.087 175.984 462.274 175.797L462.647 176.17L461.901 179.34L454.07 174.865V174.492C456.121 173 458.545 171.695 459.104 169.085C459.477 167.593 459.104 165.729 457.985 164.424C457.053 163.305 455.189 162.746 454.629 164.424L454.256 164.051C454.629 162 456.494 160.695 458.358 162H458.172Z"
        fill="#4D5055"
      />
      <path
        d="M324.115 84.6238C324.115 84.8103 324.115 98.0481 324.115 98.0481V98.6074L324.302 99.1668L324.861 99.7261C325.048 99.7261 325.42 100.099 325.793 100.472V101.031L319.827 97.4887V96.9294C320.2 96.9294 320.573 97.3023 320.759 97.3023C320.946 97.3023 321.132 97.3023 321.319 97.3023V96.9294C321.505 96.9294 321.505 96.5565 321.505 96.1836V86.8612V86.3018V85.7425L321.319 85.3696L320.946 84.9967H320.386C320.2 84.6238 320.013 84.6238 319.641 84.6238V84.0645L323.929 84.4374L324.115 84.6238Z"
        fill="#4D5055"
      />
      <path
        d="M336.607 95.997C337.167 98.6072 337.726 104.946 334.183 105.319C328.59 104.201 327.285 95.997 328.59 91.3358C328.776 90.4035 329.149 89.8442 329.709 89.4713C331.2 88.1661 333.251 89.4713 334.37 90.7764C335.675 92.268 336.234 93.946 336.794 95.997H336.607ZM334.183 101.218C334.183 99.5395 334.183 96.5563 334.183 94.8783C334.183 93.946 334.183 93.2002 333.811 92.4544C333.811 91.8951 333.438 91.3358 333.251 90.9629C332.878 90.0306 331.76 89.8442 331.387 90.9629C330.641 93.2002 330.827 96.9292 331.014 99.353C331.2 100.845 331.387 102.15 331.946 103.268L332.692 104.014C333.997 104.574 333.997 102.15 334.183 101.031"
        fill="#4D5055"
      />
      <path
        d="M467.121 205.256C469.359 206.188 472.155 211.595 468.613 212.155C471.037 214.019 472.715 221.291 468.054 220.918C466.376 220.545 463.579 219.053 462.833 217.375V216.816C462.833 215.511 463.765 216.256 464.325 216.816C465.07 217.562 465.63 218.867 466.376 219.613C468.799 221.85 469.545 219.053 468.799 216.816C468.24 214.765 466.935 212.9 465.07 211.968V211.595C471.037 213.833 466.189 203.205 463.392 207.307L463.019 206.934C463.579 204.883 465.63 204.324 467.308 205.442L467.121 205.256Z"
        fill="#4D5055"
      />
      <path
        d="M318.335 122.1C319.081 125.083 318.895 129.931 314.979 130.676C313.488 130.863 311.996 130.676 310.505 129.744V128.998C311.064 129.185 311.437 129.371 311.996 129.371C312.369 129.371 312.928 129.371 313.115 129.371C313.488 129.371 313.674 129.185 314.047 128.998C314.233 128.998 314.42 128.625 314.606 128.252C314.606 127.88 314.979 127.693 315.166 127.134C315.166 126.761 315.539 126.202 315.539 125.829C315.166 125.829 314.793 125.829 314.606 125.829C313.674 125.829 312.928 125.083 312.183 124.337C311.81 123.964 311.437 123.405 311.064 122.845C309.945 121.167 309.572 118.557 310.132 116.506C310.318 115.947 310.691 115.574 311.064 115.388C311.437 115.201 311.81 115.015 312.369 115.015C315.352 115.574 317.59 118.744 318.335 121.727V122.1ZM315.912 123.591V123.032C315.912 122.286 315.912 121.354 315.912 120.422C315.912 119.676 315.539 118.744 315.352 118.184L314.793 117.252C314.793 117.066 314.42 116.879 314.047 116.693H313.488C312.928 116.693 312.928 117.252 312.742 117.998C312.555 119.489 312.742 122.1 313.115 123.218C313.488 124.337 314.047 125.269 315.166 125.456H315.725V125.083V124.524V123.778"
        fill="#4D5055"
      />
      <path
        d="M458.358 251.308L459.85 252.241V254.291L458.358 253.359V256.529L455.934 255.224V252.054L451.087 249.257V247.02L457.24 240.867L458.358 241.613V251.308ZM455.934 249.817V243.291L451.833 247.393L455.934 249.63"
        fill="#4D5055"
      />
      <path
        d="M328.59 177.661V178.221C328.59 179.153 328.59 180.085 327.658 180.272C326.726 180.644 325.607 180.272 324.488 179.712C322.81 178.78 321.319 177.288 320.573 175.424C320.013 173.932 319.827 171.695 321.691 171.136C322.064 171.136 322.437 171.136 322.81 171.136C322.437 170.576 322.064 170.017 321.691 169.458C320.759 167.78 319.454 164.796 321.691 163.491C322.064 163.491 322.437 163.491 322.997 163.491C324.115 163.678 325.607 164.61 326.353 165.542C327.844 166.847 329.336 169.644 327.844 171.322C327.658 171.322 327.285 171.508 327.099 171.695C326.726 171.695 326.353 171.695 325.98 171.695C326.726 172.814 327.471 173.746 328.031 174.865C328.217 175.237 328.404 175.61 328.59 175.983V176.916C328.777 176.916 328.963 177.661 328.963 177.661H328.59ZM326.166 178.78C326.166 178.221 326.166 177.475 326.166 176.916C326.166 175.983 325.607 175.237 325.048 174.305C324.675 173.746 324.302 173 323.742 172.254C322.251 173.373 322.624 175.797 323.183 177.288C323.183 177.661 323.556 178.034 323.742 178.407C324.115 178.966 324.675 179.339 325.234 179.339H325.793L326.166 178.78ZM322.81 165.915C322.81 166.288 322.81 166.474 322.81 166.847C322.81 167.22 322.81 167.593 323.183 167.966C323.183 168.339 323.556 168.712 323.929 169.271C324.302 169.83 324.675 170.203 325.048 170.949C325.42 170.949 325.607 170.39 325.793 170.017C326.166 168.898 326.166 167.593 325.793 166.474L325.234 165.542C324.488 164.61 322.81 164.051 322.81 165.915Z"
        fill="#4D5055"
      />
      <path
        d="M382.66 63.3679L383.033 68.9614L381.728 68.402L381.355 62.8086L382.66 63.3679Z"
        fill="#4D5055"
      />
      <path
        d="M400 269.581L400.373 275.361L399.254 274.801L398.695 269.021L400 269.581Z"
        fill="#4D5055"
      />
      <path
        d="M373.524 59.6395L374.456 65.6059L373.151 65.0465L372.219 59.2666L373.524 59.6395Z"
        fill="#4D5055"
      />
      <path
        d="M408.577 272.936L409.509 278.903L408.204 278.53L407.271 272.563L408.577 272.936Z"
        fill="#4D5055"
      />
      <path
        d="M364.575 57.2166L366.066 63.183L364.761 62.9965L363.269 56.8438L364.575 57.2166Z"
        fill="#4D5055"
      />
      <path
        d="M416.967 275.175L418.458 281.141L417.153 280.955L415.848 274.988L416.967 275.175Z"
        fill="#4D5055"
      />
      <path
        d="M355.812 55.9111L357.862 61.8775H356.557L354.693 55.9111H355.812Z"
        fill="#4D5055"
      />
      <path
        d="M425.17 276.107L427.035 282.26H425.916L424.052 276.107H425.17Z"
        fill="#4D5055"
      />
      <path
        d="M339.777 57.0303L342.574 62.9966L341.641 63.3695L338.845 57.4032L339.777 57.0303Z"
        fill="#4D5055"
      />
      <path
        d="M440.273 274.802L442.883 280.768L441.951 280.955L439.154 274.988L440.273 274.802Z"
        fill="#4D5055"
      />
      <path
        d="M332.692 59.4531L335.862 65.4195L334.743 65.7924L331.573 60.0125L332.692 59.4531Z"
        fill="#4D5055"
      />
      <path
        d="M446.985 272.19L450.154 278.157L449.222 278.53L446.053 272.75L446.985 272.19Z"
        fill="#4D5055"
      />
      <path
        d="M325.98 63.1826L329.522 68.7761L328.777 69.5219L325.234 63.742L325.98 63.1826Z"
        fill="#4D5055"
      />
      <path
        d="M453.138 268.649L456.68 274.243L455.748 274.989L452.205 269.209L453.138 268.649Z"
        fill="#4D5055"
      />
      <path
        d="M320.2 68.0303L323.929 73.4373L323.183 74.1831L319.454 68.7761L320.2 68.0303Z"
        fill="#4D5055"
      />
      <path
        d="M467.308 251.496L471.596 256.157L471.037 257.276L466.748 252.615L467.308 251.496Z"
        fill="#4D5055"
      />
      <path
        d="M307.335 88.7266L311.81 93.0149L311.437 94.32L306.962 90.0317L307.335 88.7266Z"
        fill="#4D5055"
      />
      <path
        d="M470.291 243.851L474.766 248.139L474.393 249.258L469.918 244.969L470.291 243.851Z"
        fill="#4D5055"
      />
      <path
        d="M304.911 97.4883L309.572 101.404L309.199 102.709L304.538 98.7934L304.911 97.4883Z"
        fill="#4D5055"
      />
      <path
        d="M472.528 235.46L477.189 239.189L476.817 240.494L472.342 236.765L472.528 235.46Z"
        fill="#4D5055"
      />
      <path
        d="M303.419 107.185L308.081 110.541L307.894 111.846L303.233 108.49L303.419 107.185Z"
        fill="#4D5055"
      />
      <path
        d="M473.833 226.138L478.495 229.494V230.985L473.647 227.629L473.833 226.138Z"
        fill="#4D5055"
      />
      <path
        d="M307.894 130.304L308.081 131.982L303.233 129.745V128.253L307.894 130.304Z"
        fill="#4D5055"
      />
      <path
        d="M478.495 208.239L478.681 209.917L473.833 207.68V206.188L478.495 208.239Z"
        fill="#4D5055"
      />
      <path
        d="M309.199 141.117L309.386 142.609L304.725 141.117L304.538 139.439L309.199 141.117Z"
        fill="#4D5055"
      />
      <path
        d="M477.003 196.867L477.189 198.545L472.715 197.053L472.342 195.375L477.003 196.867Z"
        fill="#4D5055"
      />
      <path
        d="M311.25 152.119L311.623 153.61L307.148 152.678L306.776 151.187L311.25 152.119Z"
        fill="#4D5055"
      />
      <path
        d="M474.579 185.306L474.952 186.984L470.477 186.052L470.104 184.374L474.579 185.306Z"
        fill="#4D5055"
      />
      <path
        d="M314.42 163.118L314.793 164.796L310.505 164.61L309.945 162.932L314.42 163.118Z"
        fill="#4D5055"
      />
      <path
        d="M471.223 173.559L471.783 175.237L467.494 174.865L466.935 173.187L471.223 173.559Z"
        fill="#4D5055"
      />
      <path
        d="M322.81 185.492L323.742 187.17L319.827 188.289L319.081 186.611L322.81 185.492Z"
        fill="#4D5055"
      />
      <path
        d="M461.901 149.881L462.647 151.559L458.918 152.491L458.172 150.813L461.901 149.881Z"
        fill="#4D5055"
      />
      <path
        d="M328.404 196.492L329.149 198.17L325.607 199.848L324.861 198.17L328.404 196.492Z"
        fill="#4D5055"
      />
      <path
        d="M456.121 138.32L457.053 139.812L453.511 141.49L452.578 139.812L456.121 138.32Z"
        fill="#4D5055"
      />
      <path
        d="M334.37 207.307L335.302 208.798L332.133 211.036L331.2 209.544L334.37 207.307Z"
        fill="#4D5055"
      />
      <path
        d="M449.595 127.134L450.527 128.625L447.358 130.863L446.426 129.371L449.595 127.134Z"
        fill="#4D5055"
      />
      <path
        d="M341.082 217.562L342.201 219.053L339.404 221.85L338.285 220.358L341.082 217.562Z"
        fill="#4D5055"
      />
      <path
        d="M442.324 116.32L443.442 117.812L440.646 120.609L439.527 119.117L442.324 116.32Z"
        fill="#4D5055"
      />
      <path
        d="M356.184 236.393L357.303 237.698L355.439 241.427L354.134 240.122L356.184 236.393Z"
        fill="#4D5055"
      />
      <path
        d="M426.476 96.5566L427.594 97.8618L425.73 101.777L424.425 100.472L426.476 96.5566Z"
        fill="#4D5055"
      />
      <path
        d="M364.202 244.783L365.507 245.902L364.015 250.19L362.71 249.072L364.202 244.783Z"
        fill="#4D5055"
      />
      <path
        d="M417.712 87.9795L419.018 89.0982L417.526 93.3865L416.221 92.2678L417.712 87.9795Z"
        fill="#4D5055"
      />
      <path
        d="M372.592 252.241L373.897 253.173L372.965 258.021L371.66 256.902L372.592 252.241Z"
        fill="#4D5055"
      />
      <path
        d="M408.763 79.9629L410.068 81.0816L409.136 85.7428L407.831 84.8105L408.763 79.9629Z"
        fill="#4D5055"
      />
      <path
        d="M381.355 258.767L382.474 259.699L382.101 264.919L380.796 263.987L381.355 258.767Z"
        fill="#4D5055"
      />
      <path
        d="M399.813 73.251L401.119 74.1832L400.559 79.2173L399.254 78.2851L399.813 73.251Z"
        fill="#4D5055"
      />
    </g>
    <path
      d="M391.796 283.378C335.862 251.122 290.555 172.814 290.741 108.489C290.741 77.5385 301.369 55.5376 318.522 44.5371C292.046 50.317 274.52 75.3011 274.334 115.015C274.334 179.339 319.454 257.648 375.389 289.903C404.475 306.684 430.764 307.802 449.222 295.87C432.815 299.412 413.051 295.497 391.61 283.191L391.796 283.378Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="2.05093"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M366.812 161.441L332.692 90.9639L377.812 152.492L366.812 161.441Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.745794"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M394.22 193.51L461.901 254.665L398.508 177.103L394.22 193.51Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.745794"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M403.915 183.068C403.542 174.865 400.186 166.847 395.339 160.322C391.61 155.474 387.135 150.999 381.355 148.575C378.372 147.457 375.016 146.897 371.846 148.016C370.728 148.389 366.439 150.999 365.32 151.745C368.677 149.881 372.778 150.253 376.321 151.745C382.101 154.169 386.576 158.457 390.305 163.491C397.017 172.254 404.475 192.018 393.101 199.849C395.898 198.171 400.559 196.12 402.051 192.95C403.542 190.153 404.102 186.611 403.915 183.441V183.068Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="1.11869"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M379.304 153.05C390.118 159.389 398.881 174.492 398.881 186.984C398.881 199.476 390.118 204.51 379.118 198.171C368.304 191.831 359.541 176.729 359.541 164.237C359.541 151.745 368.304 146.711 379.304 153.05Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="1.11869"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M387.694 180.645C387.694 176.917 386.016 173.188 383.779 170.204C382.101 167.967 380.05 165.916 377.44 164.797C376.134 164.238 374.829 164.052 373.338 164.424C372.592 164.424 370.727 165.916 369.982 166.289C371.473 165.357 373.338 165.543 375.016 166.289C381.728 168.899 389.745 182.696 382.847 188.29C384.152 187.544 386.203 186.612 386.948 185.12C387.694 183.815 387.881 182.324 387.881 180.832L387.694 180.645Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.745794"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M376.321 166.848C381.355 169.645 385.27 176.73 385.27 182.51C385.27 188.289 381.169 190.527 376.134 187.73C371.1 184.933 367.185 177.848 367.185 172.068C367.185 166.289 371.287 164.051 376.321 166.848Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.745794"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M376.134 173.374C377.999 174.493 379.491 177.103 379.491 179.154C379.491 181.205 377.999 182.137 376.134 181.018C374.27 179.9 372.778 177.289 372.778 175.239C372.778 173.188 374.27 172.255 376.134 173.374Z"
      fill="#4D5055"
    />
    <path
      d="M376.134 177.103L466.748 197.425"
      stroke="#4D5055"
      strokeWidth="2.05093"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M749.964 215.326L749.778 250.565L735.048 261.565L735.235 226.14L749.964 215.326Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="1.11869"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M608.45 226.14L608.263 261.565L593.347 250.565L593.534 215.326L608.45 226.14Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="1.11869"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M705.403 226.699C684.148 214.393 643.875 215.139 627.84 235.648C625.603 238.632 624.298 242.361 624.111 246.089V281.328C625.416 261.751 651.706 254.666 667.927 253.92C686.199 252.615 718.454 260.446 719.386 281.515V246.276C719.386 239.191 714.725 232.106 705.403 226.699Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="1.11869"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M578.991 256.344L578.804 291.583V271.26V236.021L578.991 256.344Z"
      fill="#57C9A7"
    />
    <path
      d="M765.066 256.344L764.88 291.583L741.014 293.261L741.201 258.022L765.066 256.344Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="1.11869"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M602.856 258.022L602.67 293.261L578.804 291.583L578.991 256.344L602.856 258.022Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="1.11869"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M740.269 259.7C740.082 260.073 739.709 260.445 739.523 260.818C739.336 261.191 739.15 261.378 738.963 261.751C738.777 262.123 738.404 262.496 738.031 262.869C737.845 263.242 737.658 263.429 737.285 263.802C736.726 264.547 735.98 265.293 735.421 266.039V301.278C735.98 300.532 736.726 299.786 737.285 299.04C737.285 299.04 737.285 299.04 737.472 298.854C737.472 298.667 737.845 298.481 738.031 298.294C738.404 297.922 738.591 297.549 738.963 297.176C739.15 296.803 739.336 296.616 739.523 296.244C739.709 295.871 740.082 295.498 740.269 295.125C740.269 295.125 740.269 294.938 740.455 294.752C740.641 294.379 740.828 294.006 741.014 293.633V258.395C741.014 258.954 740.455 259.513 740.269 260.073V259.7Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="1.11869"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M602.856 258.022V293.261C604.161 296.058 606.212 298.668 608.636 301.279V266.04C606.398 263.429 604.348 260.819 602.856 258.022Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="1.11869"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M725.539 291.397L725.353 326.822L706.335 318.246L706.521 282.82L725.539 291.397Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="1.11869"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M706.335 318.246V283.007C704.284 283.753 702.047 284.312 699.809 284.871C699.063 284.871 698.318 285.244 697.572 285.431C695.894 285.804 694.216 286.176 692.538 286.363V321.602C692.538 321.602 693.097 321.602 693.283 321.602C694.589 321.415 696.08 321.042 697.385 320.669C698.131 320.669 698.877 320.297 699.623 320.11C701.86 319.551 704.097 318.991 706.335 318.246Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="1.11869"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M644.993 284.871C644.807 284.871 644.62 284.871 644.434 284.871C642.196 284.312 639.959 283.753 637.722 283.007V318.246C638.467 318.432 639.213 318.805 640.146 318.991C641.451 319.364 642.942 319.737 644.434 320.11C644.62 320.11 644.807 320.11 644.993 320.11C645.925 320.297 646.858 320.483 647.976 320.856C649.281 321.042 650.4 321.415 651.705 321.602V286.363C649.654 285.99 647.417 285.431 645.18 285.058L644.993 284.871Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="1.11869"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M750.337 277.04L750.15 312.279L725.353 326.822L725.539 291.397L750.337 277.04Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="1.11869"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M637.722 282.82L637.535 318.246L618.704 326.822L618.891 291.397L637.722 282.82Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="1.11869"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M618.89 291.397L618.704 326.822L593.72 312.279L593.906 277.04L618.89 291.397Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="1.11869"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M692.538 286.176V321.415L689.741 335.398L689.927 299.973L692.538 286.176Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="1.11869"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M654.502 299.973V335.398L651.519 321.415L651.705 286.176L654.502 299.973Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="1.11869"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M725.539 291.397L706.521 282.82C702.046 284.125 697.385 285.244 692.538 286.176L689.741 299.973H654.502L651.519 286.176C646.671 285.43 642.01 284.312 637.535 282.82L618.704 291.397L593.72 277.04L608.449 266.04C606.026 263.429 604.161 260.819 602.669 258.022L578.804 256.344V235.835L602.483 234.157C603.975 231.36 605.839 228.75 608.263 226.14L593.347 215.139L618.145 200.783L637.162 209.359C641.637 208.054 646.298 206.935 651.146 206.003L653.943 192.206H689.182L692.165 206.003C697.012 206.749 701.674 207.868 706.148 209.359L724.98 200.783L749.964 215.139L735.234 226.14C737.658 228.75 739.523 231.36 741.014 234.157L764.88 235.835V256.344L741.201 258.022C739.709 260.819 737.845 263.429 735.421 266.04L750.337 277.04L725.539 291.397ZM638.281 265.667C656.926 276.481 687.131 276.481 705.589 265.667C724.047 254.853 724.047 237.327 705.403 226.699C686.758 215.885 656.553 215.885 638.095 226.699C619.636 237.513 619.636 255.039 638.281 265.667Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="1.11869"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M689.927 299.974L689.741 335.399H654.502V299.974H689.927Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="1.11869"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M622.806 337.075V354.042L615.721 359.263V342.296L622.806 337.075Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M554.939 342.296V359.263L547.854 354.042V337.075L554.939 342.296Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M601.551 342.483C591.11 336.516 570.973 336.889 563.702 347.703C562.956 349.008 562.583 350.313 562.583 351.805V368.772C564.075 351.059 607.144 351.619 608.263 368.772V351.805C608.263 348.449 606.026 344.906 601.551 342.296V342.483Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M540.955 356.839L540.768 373.806V363.924V346.957L540.955 356.839Z"
      fill="#57C9A7"
    />
    <path
      d="M630.077 356.84V373.807L618.518 374.552L618.704 357.586L630.077 356.84Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M552.328 357.586V374.552L540.768 373.807L540.955 356.84L552.328 357.586Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M618.145 358.331C618.145 358.517 617.958 358.704 617.772 358.89C617.772 358.89 617.585 359.263 617.399 359.263C617.399 359.449 617.212 359.636 617.026 359.822C617.026 359.822 616.84 360.009 616.653 360.195C616.28 360.568 616.094 360.941 615.721 361.314V378.281C616.094 377.908 616.28 377.535 616.653 377.162C616.653 377.162 616.653 376.976 616.84 376.789C616.84 376.603 617.212 376.416 617.212 376.23C617.212 376.23 617.399 375.857 617.585 375.857C617.585 375.67 617.772 375.484 617.958 375.298C617.958 375.298 617.958 375.298 617.958 375.111C617.958 374.925 618.145 374.738 618.331 374.552V357.585C618.331 357.771 618.145 358.144 617.958 358.331H618.145Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M552.328 357.585V374.552C552.888 375.857 553.82 377.162 555.125 378.467V361.5C554.006 360.195 553.074 358.89 552.328 357.585Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M611.06 373.618V390.585L601.924 386.483L602.11 369.517L611.06 373.618Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M601.924 386.483V369.517C600.991 369.889 599.873 370.076 598.754 370.449C598.381 370.449 598.008 370.449 597.635 370.635C596.889 370.635 596.144 371.008 595.211 371.195V388.161C595.211 388.161 595.398 388.161 595.584 388.161C596.33 388.161 596.889 387.975 597.635 387.789C598.008 387.789 598.381 387.789 598.754 387.602C599.873 387.416 600.805 387.043 601.924 386.67V386.483Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M572.465 370.449C572.465 370.449 572.278 370.449 572.092 370.449C570.973 370.262 569.854 369.889 568.922 369.517V386.483C569.295 386.483 569.668 386.67 570.041 386.856C570.787 387.043 571.346 387.229 572.092 387.416C572.092 387.416 572.278 387.416 572.465 387.416C572.837 387.416 573.397 387.602 573.77 387.789C574.329 387.789 574.888 387.975 575.634 388.161V371.195C574.516 371.195 573.583 370.822 572.465 370.449Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M622.992 366.721V383.688L611.06 390.586V373.619L622.992 366.721Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M569.109 369.517L568.922 386.483L559.973 390.585V373.618L569.109 369.517Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M559.973 373.619V390.586L548.04 383.688V366.721L559.973 373.619Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M595.398 371.01V387.977L593.906 394.689L594.093 377.722L595.398 371.01Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M577.126 377.722V394.689L575.634 387.977V371.01L577.126 377.722Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M611.06 373.619L601.924 369.518C599.873 370.263 597.635 370.636 595.211 371.196L593.906 377.908H576.939L575.448 371.196C573.21 370.823 570.973 370.263 568.736 369.518L559.786 373.619L547.854 366.721L554.939 361.5C553.82 360.195 552.888 358.89 552.142 357.585L540.768 356.839V346.957L552.142 346.212C552.888 344.906 553.82 343.601 554.939 342.296L547.854 337.076L559.786 330.177L568.922 334.279C570.973 333.533 573.21 333.16 575.634 332.601L576.939 325.889H593.906L595.398 332.601C597.635 332.974 599.873 333.533 602.11 334.279L611.06 330.177L622.992 337.076L615.907 342.296C617.026 343.601 617.958 344.906 618.704 346.212L630.077 346.957V356.839L618.704 357.585C617.958 358.89 617.026 360.195 615.907 361.5L622.992 366.721L611.06 373.619ZM569.295 361.314C578.245 366.534 592.788 366.534 601.551 361.314C610.5 356.093 610.314 347.703 601.551 342.669C592.601 337.448 578.058 337.448 569.295 342.669C560.346 347.89 560.532 356.28 569.295 361.314Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M594.093 377.721L593.906 394.688H577.126V377.721H594.093Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M564.448 288.225V298.852L559.973 302.208V291.581L564.448 288.225Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M521.564 291.581V302.208L517.09 298.852V288.225L521.564 291.581Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M551.023 291.58C544.311 287.851 531.633 288.037 527.158 294.936C526.785 295.682 526.598 296.614 526.412 297.36V307.987C527.531 296.8 554.379 296.987 555.312 307.987V297.36C555.312 295.122 554.006 293.071 551.023 291.393V291.58Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M512.801 300.716L512.615 311.344V305.191V294.377L512.801 300.716Z"
      fill="#57C9A7"
    />
    <path
      d="M569.109 300.716V311.343L561.837 311.903V301.089L569.109 300.716Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M519.886 301.089V311.903L512.615 311.343L512.801 300.716L519.886 301.089Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M561.651 301.649C561.651 301.649 561.651 301.836 561.464 302.022C561.464 302.022 561.464 302.209 561.464 302.395C561.464 302.395 561.464 302.581 561.278 302.768C561.278 302.768 561.278 302.768 561.091 302.954C561.091 303.141 560.718 303.327 560.532 303.7V314.328C560.532 314.141 560.905 313.955 561.091 313.582C561.091 313.582 561.091 313.582 561.091 313.396C561.091 313.396 561.091 313.209 561.278 313.023C561.278 313.023 561.278 312.836 561.464 312.65C561.464 312.65 561.464 312.463 561.651 312.277C561.651 312.277 561.651 312.09 561.837 311.904V301.276C561.837 301.276 561.837 301.649 561.651 301.836V301.649Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M519.886 301.09V311.717C520.259 312.65 520.819 313.395 521.564 314.141V303.514C520.819 302.768 520.259 301.836 519.886 301.09Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M557.176 311.345L556.99 321.972L551.396 319.362V308.734L557.176 311.345Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M551.396 319.362V308.734C550.837 308.921 550.091 309.107 549.345 309.294C549.159 309.294 548.972 309.294 548.599 309.294C548.04 309.294 547.667 309.48 547.108 309.667V320.294C547.108 320.294 547.108 320.294 547.294 320.294C547.667 320.294 548.04 320.294 548.599 320.108C548.786 320.108 548.972 320.108 549.345 320.108C550.091 320.108 550.65 319.735 551.396 319.548V319.362Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M532.751 309.294C532.751 309.294 532.751 309.294 532.565 309.294C531.819 309.294 531.26 308.921 530.514 308.734V319.362C530.7 319.362 530.887 319.362 531.26 319.548C531.633 319.548 532.192 319.735 532.565 319.921C532.565 319.921 532.565 319.921 532.751 319.921C533.124 319.921 533.311 319.921 533.684 320.108C534.056 320.108 534.429 320.108 534.802 320.294V309.667C534.243 309.667 533.497 309.48 532.751 309.294Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M564.634 306.87V317.498L556.99 321.972L557.176 311.345L564.634 306.87Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M530.514 308.734V319.362L524.734 321.972V311.345L530.514 308.734Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M524.734 311.345V321.972L517.276 317.498V306.87L524.734 311.345Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M547.108 309.666V320.294L546.362 324.582V313.954L547.108 309.666Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M535.548 313.954V324.582L534.802 320.294V309.666L535.548 313.954Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M557.176 311.344L551.396 308.734C550.091 309.107 548.599 309.48 547.108 309.666L546.176 313.768H535.548L534.616 309.666C533.124 309.48 531.819 309.107 530.327 308.734L524.548 311.344L516.903 307.056L521.378 303.7C520.632 302.954 520.073 302.022 519.7 301.276L512.428 300.717V294.564L519.7 294.005C520.073 293.072 520.632 292.327 521.378 291.581L516.903 288.225L524.361 283.937L530.141 286.547C531.446 286.174 532.938 285.801 534.429 285.615L535.362 281.513H545.989L546.921 285.615C548.413 285.801 549.718 286.174 551.21 286.547L556.99 283.937L564.634 288.225L560.159 291.581C560.905 292.327 561.464 293.259 561.837 294.005L569.109 294.564V300.717L561.837 301.276C561.464 302.208 560.905 302.954 560.159 303.7L564.634 307.056L557.176 311.344ZM530.7 303.514C536.294 306.87 545.43 306.87 551.023 303.514C556.617 300.158 556.617 294.937 551.023 291.767C545.43 288.411 536.294 288.411 530.7 291.767C525.107 295.123 525.107 300.344 530.7 303.514Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M546.362 313.954V324.582H535.548V313.954H546.362Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g style={{ mixBlendMode: 'multiply', opacity: 0.5 }}>
      <path
        d="M409.322 350.313C426.662 360.381 426.662 376.602 409.509 386.484C392.355 396.552 364.388 396.552 347.048 386.484C329.709 376.416 329.709 360.195 346.862 350.313C364.015 340.245 391.982 340.245 409.322 350.313Z"
        fill="#C2ECDF"
      />
    </g>
    <path
      d="M362.151 222.41C359.54 224.834 358.235 228.749 362.151 233.597C365.134 237.326 368.117 242.733 369.422 244.225C370.541 245.716 378.745 241.428 378.185 238.445C377.626 235.275 371.473 224.461 370.727 222.224C369.982 220.173 364.947 220.173 362.337 222.41H362.151Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M364.388 353.485V361.875C364.388 362.807 366.998 363.739 369.049 363.18C371.287 362.62 372.219 360.942 373.338 360.57C374.456 360.197 382.287 358.892 384.711 357.027C387.135 355.163 387.508 351.434 383.779 351.62C380.05 351.806 372.405 351.434 371.287 351.993C370.355 352.552 364.388 353.671 364.388 353.671V353.485Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M382.474 367.095V373.994C382.474 374.926 385.084 375.858 387.135 375.299C389.372 374.74 390.304 373.062 391.423 372.689C392.542 372.316 400.373 371.011 402.796 369.146C405.407 367.282 405.593 363.553 401.864 363.739C398.135 363.926 390.491 363.553 389.372 364.112C388.253 364.671 382.474 367.282 382.474 367.282V367.095Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M367.185 272.191C367.185 272.191 365.693 309.108 365.507 313.769C365.32 318.431 364.015 325.889 363.829 328.685C363.829 331.482 363.829 352.551 363.829 353.856C363.829 355.161 371.1 355.907 371.473 351.805C371.846 347.703 375.202 328.685 375.948 323.465C376.694 318.244 380.05 303.515 380.05 303.515L376.507 275.361L367.185 272.564V272.191Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M373.151 275.92C373.151 275.92 380.796 315.074 381.168 320.108C381.728 325.142 380.796 365.229 381.168 367.093C381.541 368.958 389.186 369.144 389.745 365.415C390.491 361.686 394.406 328.499 394.593 323.092C394.779 317.685 393.474 273.869 393.474 273.869C393.474 273.869 386.575 281.327 373.151 275.92Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M390.491 198.359C371.473 194.071 373.151 208.241 374.456 211.41C374.829 212.156 375.389 212.715 375.948 213.088C375.016 214.766 374.083 216.817 374.083 216.817V223.343L383.965 227.818L385.084 217.563C387.321 219.241 390.864 219.241 391.61 217.563C393.101 208.614 390.677 198.545 390.677 198.545L390.491 198.359Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M384.152 210.291C383.219 210.291 381.355 212.156 381.355 214.207C381.355 216.257 379.304 218.495 377.812 218.495C376.321 218.495 373.897 218.495 373.338 216.444C372.778 214.579 369.049 209.918 368.863 203.952C368.863 197.986 374.829 191.833 381.168 192.206C387.508 192.578 389.745 194.07 390.677 196.68C391.61 199.291 389.559 200.782 389.932 206.376C388.254 207.494 387.321 208.427 386.575 208.986C385.83 209.545 384.152 210.105 384.152 210.105V210.291Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M386.948 209.918C386.948 209.918 386.016 207.308 383.965 208.24C382.101 209.172 382.66 212.715 386.948 213.647"
      fill="white"
    />
    <path
      d="M386.948 209.918C386.948 209.918 386.016 207.308 383.965 208.24C382.101 209.172 382.66 212.715 386.948 213.647"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M366.626 272.565C369.422 277.04 383.033 285.057 394.033 274.43C394.033 270.887 394.22 247.022 394.593 242.174C394.966 237.327 390.864 229.869 385.457 227.258C380.236 224.648 374.643 221.665 372.219 220.919C370.354 220.173 363.269 222.597 362.337 231.174C361.405 239.75 366.998 250.005 366.253 255.412C365.507 260.819 366.253 272.565 366.253 272.565H366.626Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M394.779 242.174C394.966 239.191 393.661 235.275 391.237 232.105C391.796 233.597 391.982 235.275 391.982 236.58C391.61 241.428 391.237 265.293 391.423 268.836C382.474 277.412 371.846 273.87 366.625 269.768C366.625 271.446 366.625 272.565 366.625 272.565C369.422 277.04 383.033 285.057 394.033 274.429C394.033 270.887 394.22 247.021 394.593 242.174H394.779Z"
      fill="#C2ECDF"
    />
    <path
      d="M403.169 222.037C403.169 222.037 408.576 219.427 411 217.562C413.238 215.512 416.221 200.782 416.407 198.731C416.407 196.494 416.407 189.595 416.78 188.477C416.967 187.358 418.831 182.51 420.882 181.578C422.56 181.205 422.001 183.07 421.255 184.002C420.509 184.934 420.136 186.426 420.136 186.985C420.136 187.544 423.865 188.104 424.797 189.595C425.73 191.087 425.357 194.816 422.187 197.612C421.814 199.104 419.39 220.359 417.712 222.783C416.221 225.953 411.933 227.071 408.204 228.936L403.169 222.037Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M386.576 237.512C388.999 239.936 393.101 241.241 397.949 237.512C401.678 234.529 407.085 231.546 408.577 230.427C410.068 229.308 405.966 221.105 402.797 221.664C399.627 222.223 388.627 228.376 386.576 229.122C384.525 229.868 384.338 235.275 386.576 237.699V237.512Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M560.532 100.098L572.278 93.1992C572.278 93.1992 572.465 93.5721 572.651 93.7586L560.905 100.657C560.905 100.657 560.718 100.284 560.532 100.098Z"
      fill="white"
    />
    <mask
      id="mask2_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="560"
      y="93"
      width="13"
      height="8"
    >
      <path
        d="M560.532 100.099L572.278 93.2002C572.278 93.2002 572.465 93.5731 572.651 93.7595L560.905 100.658C560.905 100.658 560.718 100.285 560.532 100.099Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask2_918_8688)">
      <path
        d="M560.532 100.099L572.278 93.2002"
        stroke="#4D5055"
        strokeWidth="0.932243"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M560.718 100.285L572.465 93.3867C572.465 93.3867 572.465 93.5732 572.651 93.7596L560.905 100.658C560.905 100.658 560.905 100.472 560.718 100.285Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.932243"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M560.905 100.657L572.651 93.7588"
        stroke="#4D5055"
        strokeWidth="0.932243"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M560.532 100.098L572.278 93.1992C572.278 93.1992 572.465 93.5721 572.651 93.7586L560.905 100.657C560.905 100.657 560.718 100.284 560.532 100.098Z"
      stroke="#4D5055"
      strokeWidth="0.932243"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M521.564 25.1457L533.31 18.2471L572.278 93.3858L560.532 100.098L521.564 25.1457Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.932243"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M519.327 26.2644L531.073 19.3658C531.819 18.9929 532.565 18.62 533.311 18.2471L521.564 25.1457C520.819 25.5186 520.073 25.8915 519.327 26.2644Z"
      fill="white"
    />
    <mask
      id="mask3_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="519"
      y="18"
      width="15"
      height="9"
    >
      <path
        d="M519.327 26.2653L531.073 19.3667C531.819 18.9938 532.565 18.6209 533.311 18.248L521.564 25.1466C520.819 25.5195 520.073 25.8924 519.327 26.2653Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask3_918_8688)">
      <path
        d="M519.327 26.2653L531.073 19.3667C531.819 18.9938 532.565 18.6209 533.311 18.248L521.564 25.1466C520.819 25.5195 520.073 25.8924 519.327 26.2653Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.932243"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M519.327 26.2644L531.073 19.3658C531.819 18.9929 532.565 18.62 533.311 18.2471L521.564 25.1457C520.819 25.5186 520.073 25.8915 519.327 26.2644Z"
      stroke="#4D5055"
      strokeWidth="0.932243"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M560.905 100.656L572.651 93.7578C572.651 93.7578 588.686 115.386 604.534 137.2C611.619 146.709 617.585 154.726 622.433 161.252L610.687 168.151C605.839 161.625 599.872 153.608 592.787 144.099C576.753 122.471 560.905 100.656 560.905 100.656Z"
      fill="white"
    />
    <mask
      id="mask4_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="560"
      y="93"
      width="63"
      height="76"
    >
      <path
        d="M560.905 100.656L572.651 93.7578C572.651 93.7578 588.686 115.386 604.534 137.2C611.619 146.709 617.585 154.726 622.433 161.252L610.687 168.151C605.839 161.625 599.872 153.608 592.787 144.099C576.753 122.471 560.905 100.656 560.905 100.656Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask4_918_8688)">
      <path
        d="M618.517 156.032C614.415 150.625 609.941 144.285 604.534 137.2C588.499 115.572 572.651 93.7578 572.651 93.7578L560.905 100.656C560.905 100.656 576.939 122.284 592.787 144.099C598.008 151.184 602.669 157.523 606.771 162.93C608.076 164.795 609.381 166.473 610.687 168.151L622.433 161.252C621.128 159.574 619.823 157.896 618.517 156.032Z"
        fill="#C2ECDF"
        stroke="#4D5055"
        strokeWidth="0.932243"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M560.905 100.656L572.651 93.7578C572.651 93.7578 588.686 115.386 604.534 137.2C611.619 146.709 617.585 154.726 622.433 161.252L610.687 168.151C605.839 161.625 599.872 153.608 592.787 144.099C576.753 122.471 560.905 100.656 560.905 100.656Z"
      stroke="#4D5055"
      strokeWidth="0.932243"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M616.28 166.101L604.534 172.999C606.771 171.694 608.822 170.016 610.686 168.152L622.433 161.253C620.568 163.117 618.517 164.795 616.28 166.101Z"
      fill="white"
    />
    <mask
      id="mask5_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="604"
      y="161"
      width="19"
      height="12"
    >
      <path
        d="M616.28 166.1L604.534 172.998C606.771 171.693 608.822 170.015 610.686 168.151L622.433 161.252C620.568 163.116 618.517 164.794 616.28 166.1Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask5_918_8688)">
      <path
        d="M610.686 168.151L622.433 161.252C620.568 163.116 618.517 164.794 616.28 166.1L604.534 172.998C606.771 171.693 608.822 170.015 610.686 168.151Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.932243"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M616.28 166.101L604.534 172.999C606.771 171.694 608.822 170.016 610.686 168.152L622.433 161.253C620.568 163.117 618.517 164.795 616.28 166.101Z"
      stroke="#4D5055"
      strokeWidth="0.932243"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M521.564 25.1455L560.532 100.284C560.532 100.284 560.718 100.657 560.905 100.844C560.905 100.844 576.939 122.472 592.788 144.286C599.873 153.795 605.839 161.812 610.687 168.338C599.686 179.525 581.787 180.644 561.837 168.897C528.649 149.693 501.801 103.267 501.801 65.0455C501.801 44.7226 509.445 30.9254 521.564 25.332V25.1455Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.932243"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M572.651 37.6369L584.397 30.7383L572.651 87.7915L560.905 94.5037L572.651 37.6369Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.932243"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M566.498 33.1626C568.549 34.4677 570.6 35.9593 572.651 37.6374L584.397 30.7388C570.973 20.4841 553.074 11.5346 536.107 17.128L524.361 24.0266C538.904 19.1789 554.379 25.1453 566.498 33.1626Z"
      fill="#5B6474"
      stroke="#4D5055"
      strokeWidth="0.932243"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M562.21 30.5526C565.752 32.6035 569.295 35.0274 572.651 37.6376L561.091 94.6909L524.361 24.2133C534.802 20.6708 547.853 22.3489 562.21 30.739V30.5526Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.932243"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M633.806 124.895C632.128 90.402 613.484 56.2819 587.754 33.7217L576.007 40.6203C598.754 60.5703 614.975 88.3511 620.569 117.996C623.365 134.217 623.179 152.676 612.738 166.1L624.484 159.202C632.128 149.693 634.179 136.828 633.806 124.895Z"
      fill="#4D5055"
      stroke="#4D5055"
      strokeWidth="0.932243"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M576.007 40.4345C602.483 62.9948 622.246 101.776 622.06 134.405C622.06 148.015 618.517 158.643 612.551 165.914C599.313 148.015 579.177 120.794 563.702 99.7251L568.176 77.7242L575.821 40.248L576.007 40.4345Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.932243"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M475.139 372.687L482.037 368.771C482.037 368.771 482.037 368.958 482.224 369.144L475.325 373.06C475.325 373.06 475.325 372.873 475.139 372.687Z"
      fill="white"
    />
    <mask
      id="mask6_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="475"
      y="368"
      width="8"
      height="6"
    >
      <path
        d="M475.139 372.686L482.037 368.771C482.037 368.771 482.037 368.957 482.224 369.143L475.325 373.059C475.325 373.059 475.325 372.872 475.139 372.686Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask6_918_8688)">
      <path
        d="M475.139 372.686L482.037 368.771"
        stroke="#4D5055"
        strokeWidth="0.745794"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M475.139 372.686L482.037 368.771"
        stroke="#4D5055"
        strokeWidth="0.745794"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M475.325 372.872L482.224 368.957"
        stroke="#4D5055"
        strokeWidth="0.745794"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M475.139 372.687L482.037 368.771C482.037 368.771 482.037 368.958 482.224 369.144L475.325 373.06C475.325 373.06 475.325 372.873 475.139 372.687Z"
      stroke="#4D5055"
      strokeWidth="0.745794"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M452.578 329.058L459.29 325.143L482.037 368.772L475.138 372.687L452.578 329.058Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.745794"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M451.087 329.804L457.985 325.888C458.358 325.702 458.917 325.329 459.29 325.143L452.392 329.058C452.019 329.244 451.46 329.431 451.087 329.804Z"
      fill="white"
    />
    <mask
      id="mask7_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="451"
      y="325"
      width="9"
      height="5"
    >
      <path
        d="M451.087 329.804L457.985 325.888C458.358 325.702 458.917 325.329 459.29 325.143L452.392 329.058C452.019 329.244 451.46 329.431 451.087 329.804Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask7_918_8688)">
      <path
        d="M451.087 329.804L457.985 325.888C458.358 325.702 458.917 325.329 459.29 325.143L452.392 329.058C452.019 329.244 451.46 329.431 451.087 329.804Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.745794"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M451.087 329.804L457.985 325.888C458.358 325.702 458.917 325.329 459.29 325.143L452.392 329.058C452.019 329.244 451.46 329.431 451.087 329.804Z"
      stroke="#4D5055"
      strokeWidth="0.745794"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M475.325 373.061L482.224 369.146C482.224 369.146 491.546 381.824 500.868 394.316C504.97 399.91 508.513 404.571 511.31 408.3L504.411 412.215C501.614 408.486 498.072 403.825 493.97 398.231C484.647 385.553 475.325 373.061 475.325 373.061Z"
      fill="white"
    />
    <mask
      id="mask8_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="475"
      y="369"
      width="37"
      height="44"
    >
      <path
        d="M475.325 373.061L482.224 369.146C482.224 369.146 491.546 381.824 500.868 394.316C504.97 399.91 508.513 404.571 511.31 408.3L504.411 412.215C501.614 408.486 498.072 403.825 493.97 398.231C484.647 385.553 475.325 373.061 475.325 373.061Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask8_918_8688)">
      <path
        d="M508.886 405.13C506.462 401.96 503.852 398.418 500.868 394.13C491.546 381.451 482.224 368.959 482.224 368.959L475.325 372.874C475.325 372.874 484.647 385.553 493.97 398.045C496.953 402.147 499.75 405.876 501.987 409.045C502.733 410.164 503.479 411.096 504.224 412.215L511.123 408.3C510.377 407.367 509.631 406.249 508.886 405.13Z"
        fill="#C2ECDF"
        stroke="#4D5055"
        strokeWidth="0.745794"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M475.325 373.061L482.224 369.146C482.224 369.146 491.546 381.824 500.868 394.316C504.97 399.91 508.513 404.571 511.31 408.3L504.411 412.215C501.614 408.486 498.072 403.825 493.97 398.231C484.647 385.553 475.325 373.061 475.325 373.061Z"
      stroke="#4D5055"
      strokeWidth="0.745794"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M507.581 411.097L500.682 415.012C501.987 414.266 503.106 413.334 504.224 412.215L511.123 408.3C510.004 409.418 508.886 410.351 507.581 411.097Z"
      fill="white"
    />
    <mask
      id="mask9_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="500"
      y="408"
      width="12"
      height="8"
    >
      <path
        d="M507.581 411.098L500.682 415.013C501.987 414.267 503.106 413.335 504.224 412.216L511.123 408.301C510.004 409.419 508.886 410.352 507.581 411.098Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask9_918_8688)">
      <path
        d="M504.224 412.216L511.123 408.301C510.004 409.419 508.886 410.352 507.581 411.098L500.682 415.013C501.987 414.267 503.106 413.335 504.224 412.216Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.745794"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M507.581 411.097L500.682 415.012C501.987 414.266 503.106 413.334 504.224 412.215L511.123 408.3C510.004 409.418 508.886 410.351 507.581 411.097Z"
      stroke="#4D5055"
      strokeWidth="0.745794"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M452.578 329.059L475.325 372.688C475.325 372.688 475.325 372.874 475.511 373.06C475.511 373.06 484.834 385.739 494.156 398.231C498.258 403.824 501.801 408.486 504.597 412.215C498.258 418.74 487.817 419.3 476.071 412.588C456.68 401.401 441.205 374.366 441.205 352.178C441.205 340.432 445.68 332.415 452.765 329.059H452.578Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.745794"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M482.224 336.329L488.936 332.414L482.224 365.415L475.325 369.517L482.224 336.329Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.745794"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M478.495 333.719C479.8 334.465 480.918 335.397 482.037 336.33L488.936 332.414C481.105 326.448 470.85 321.227 460.969 324.584L454.07 328.499C462.46 325.702 471.596 329.245 478.681 333.906L478.495 333.719Z"
      fill="#5B6474"
      stroke="#4D5055"
      strokeWidth="0.745794"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M476.071 332.228C478.122 333.347 480.173 334.838 482.224 336.33L475.511 369.518L454.256 328.499C460.223 326.448 467.867 327.38 476.257 332.228H476.071Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.745794"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M517.649 387.044C516.53 366.721 506.089 347.331 490.8 333.906L483.902 337.822C501.614 352.365 520.259 389.654 505.157 410.723L512.055 406.808C516.53 401.214 517.649 393.756 517.462 386.858L517.649 387.044Z"
      fill="#4D5055"
      stroke="#4D5055"
      strokeWidth="0.745794"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M484.088 338.008C499.563 351.059 510.937 373.619 510.937 392.637C510.937 400.468 508.886 406.807 505.53 410.909C497.699 400.468 486.139 384.62 477.189 372.501L479.8 359.636L484.274 337.821L484.088 338.008Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.745794"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M262.028 239.19C262.028 238.258 262.028 237.325 261.842 236.393C260.909 230.986 258.485 225.766 254.943 221.664C253.078 219.426 250.841 217.375 248.417 215.884L165.261 167.78C163.024 166.475 160.227 165.543 157.43 166.102C156.125 166.102 144.379 173.374 143.074 174.119C146.243 172.441 149.972 173.374 152.956 175.052L236.112 223.155C240.027 225.393 243.01 228.749 245.248 232.664C247.858 236.953 249.722 241.987 249.722 247.021L249.536 318.803C249.536 322.16 248.604 325.888 245.434 327.567L257.74 320.295C259.231 319.363 260.35 317.871 260.909 316.193C261.469 314.702 261.655 313.024 261.655 311.346C261.655 310.6 261.842 239.749 261.842 239.003L262.028 239.19Z"
      fill="#4D5055"
      stroke="#4D5055"
      strokeWidth="0.745794"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M235.925 223.156C243.57 227.631 249.722 238.258 249.722 247.021V318.804C249.536 327.567 243.383 331.11 235.739 326.635L152.583 278.531C144.938 274.056 138.786 263.429 138.786 254.666V182.883C138.972 174.12 145.125 170.577 152.769 175.052L235.925 223.156Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="1.67804"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M159.295 214.135C160.041 214.694 160.786 215.813 160.786 216.745V222.525C160.786 223.457 160.041 223.83 159.295 223.457L154.261 220.474C153.515 219.915 152.769 218.796 152.769 217.864V212.084C152.769 211.152 153.515 210.779 154.261 211.152L159.295 214.135Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M159.295 199.17C160.041 199.729 160.786 200.848 160.786 201.78V207.56C160.786 208.492 160.041 208.865 159.295 208.492L154.261 205.509C153.515 204.95 152.769 203.831 152.769 202.899V197.119C152.769 196.187 153.515 195.814 154.261 196.187L159.295 199.17Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M173.092 222.339C173.838 222.898 174.584 224.017 174.584 224.949V230.729C174.584 231.661 173.838 232.034 173.092 231.661L168.058 228.678C167.312 228.119 166.566 227 166.566 226.068V220.288C166.566 219.356 167.312 218.983 168.058 219.356L173.092 222.339Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M173.092 207.373C173.838 207.932 174.584 209.051 174.584 209.983V215.763C174.584 216.696 173.838 217.068 173.092 216.696L168.058 213.712C167.312 213.153 166.566 212.034 166.566 211.102V205.322C166.566 204.39 167.312 204.017 168.058 204.39L173.092 207.373Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M187.076 230.357C187.822 230.916 188.567 232.035 188.567 232.967V238.747C188.567 239.679 187.822 240.052 187.076 239.679L182.042 236.696C181.296 236.136 180.55 235.018 180.55 234.086V228.306C180.55 227.373 181.296 227 182.042 227.373L187.076 230.357Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M187.076 215.392C187.822 215.951 188.567 217.07 188.567 218.002V223.782C188.567 224.714 187.822 225.087 187.076 224.714L182.042 221.731C181.296 221.172 180.55 220.053 180.55 219.121V213.341C180.55 212.409 181.296 212.036 182.042 212.409L187.076 215.392Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M201.059 238.374C201.805 238.933 202.551 240.052 202.551 240.984V246.764C202.551 247.697 201.805 248.069 201.059 247.697L196.025 244.713C195.279 244.154 194.534 243.035 194.534 242.103V236.323C194.534 235.391 195.279 235.018 196.025 235.391L201.059 238.374Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M201.059 223.409C201.805 223.969 202.551 225.087 202.551 226.02V231.799C202.551 232.732 201.805 233.105 201.059 232.732L196.025 229.749C195.279 229.189 194.534 228.07 194.534 227.138V221.358C194.534 220.426 195.279 220.053 196.025 220.426L201.059 223.409Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M215.043 246.391C215.789 246.95 216.535 248.069 216.535 249.001V254.781C216.535 255.713 215.789 256.086 215.043 255.713L210.009 252.73C209.077 252.171 208.517 251.052 208.517 250.12V244.34C208.517 243.408 209.263 243.035 210.009 243.408L215.043 246.391Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M215.043 231.426C215.789 231.985 216.535 233.104 216.535 234.036V239.816C216.535 240.748 215.789 241.121 215.043 240.748L210.009 237.765C209.077 237.206 208.517 236.087 208.517 235.155V229.375C208.517 228.443 209.263 228.07 210.009 228.443L215.043 231.426Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M228.84 254.407C229.773 254.967 230.332 256.085 230.332 257.018V262.797C230.332 263.73 229.586 264.103 228.84 263.73L223.806 260.747C222.874 260.187 222.315 259.069 222.315 258.136V252.356C222.315 251.424 223.06 251.051 223.806 251.424L228.84 254.407Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M228.84 239.442C229.773 240.002 230.332 241.121 230.332 242.053V247.833C230.332 248.765 229.586 249.138 228.84 248.765L223.806 245.782C222.874 245.222 222.315 244.104 222.315 243.171V237.392C222.315 236.459 223.06 236.086 223.806 236.459L228.84 239.442Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M159.108 228.306C159.854 228.865 160.6 229.984 160.6 230.916V236.696C160.6 237.628 159.854 238.001 159.108 237.628L154.074 234.645C153.329 234.086 152.583 232.967 152.583 232.035V226.255C152.583 225.323 153.329 224.95 154.074 225.323L159.108 228.306Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M173.092 236.322C173.838 236.882 174.584 238 174.584 238.933V244.713C174.584 245.645 173.838 246.018 173.092 245.645L168.058 242.662C167.312 242.102 166.566 240.984 166.566 240.051V234.271C166.566 233.339 167.312 232.966 168.058 233.339L173.092 236.322Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M187.076 244.341C187.821 244.9 188.567 246.019 188.567 246.951V252.731C188.567 253.663 187.821 254.036 187.076 253.663L182.042 250.68C181.296 250.121 180.55 249.002 180.55 248.07V242.29C180.55 241.358 181.296 240.985 182.042 241.358L187.076 244.341Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M201.059 252.358C201.805 252.917 202.551 254.036 202.551 254.968V260.748C202.551 261.68 201.805 262.053 201.059 261.68L196.025 258.697C195.279 258.137 194.534 257.019 194.534 256.086V250.307C194.534 249.374 195.279 249.001 196.025 249.374L201.059 252.358Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M214.857 260.374C215.602 260.933 216.348 262.052 216.348 262.984V268.764C216.348 269.697 215.602 270.069 214.857 269.697L209.823 266.713C208.89 266.154 208.331 265.035 208.331 264.103V258.323C208.331 257.391 209.077 257.018 209.823 257.391L214.857 260.374Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M228.84 268.392C229.773 268.951 230.332 270.07 230.332 271.002V276.782C230.332 277.714 229.586 278.087 228.84 277.714L223.806 274.731C222.874 274.172 222.315 273.053 222.315 272.121V266.341C222.315 265.409 223.06 265.036 223.806 265.409L228.84 268.392Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M159.108 242.289C159.854 242.849 160.6 243.967 160.6 244.899V250.679C160.6 251.612 159.854 251.984 159.108 251.612L154.074 248.628C153.329 248.069 152.583 246.95 152.583 246.018V240.238C152.583 239.306 153.329 238.933 154.074 239.306L159.108 242.289Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M173.092 250.307C173.838 250.866 174.584 251.985 174.584 252.917V258.697C174.584 259.629 173.838 260.002 173.092 259.629L168.058 256.646C167.312 256.087 166.566 254.968 166.566 254.036V248.256C166.566 247.324 167.312 246.951 168.058 247.324L173.092 250.307Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M187.076 258.324C187.822 258.884 188.567 260.002 188.567 260.935V266.715C188.567 267.647 187.822 268.02 187.076 267.647L182.042 264.664C181.296 264.104 180.55 262.986 180.55 262.053V256.273C180.55 255.341 181.296 254.968 182.042 255.341L187.076 258.324Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M200.873 266.527C201.619 267.087 202.365 268.205 202.365 269.138V274.918C202.365 275.85 201.619 276.223 200.873 275.85L195.839 272.867C195.093 272.307 194.347 271.189 194.347 270.256V264.477C194.347 263.544 195.093 263.171 195.839 263.544L200.873 266.527Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M214.857 274.544C215.602 275.103 216.348 276.222 216.348 277.154V282.934C216.348 283.866 215.602 284.239 214.857 283.866L209.823 280.883C208.89 280.324 208.331 279.205 208.331 278.273V272.493C208.331 271.561 209.077 271.188 209.823 271.561L214.857 274.544Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M228.84 282.562C229.773 283.121 230.332 284.24 230.332 285.172V290.952C230.332 291.884 229.586 292.257 228.84 291.884L223.806 288.901C222.874 288.342 222.315 287.223 222.315 286.291V280.511C222.315 279.578 223.06 279.206 223.806 279.578L228.84 282.562Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M159.108 256.273C159.854 256.832 160.6 257.951 160.6 258.883V264.663C160.6 265.595 159.854 265.968 159.108 265.595L154.074 262.612C153.329 262.052 152.583 260.934 152.583 260.002V254.222C152.583 253.289 153.329 252.916 154.074 253.289L159.108 256.273Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M173.092 264.477C173.838 265.036 174.584 266.155 174.584 267.087V272.867C174.584 273.799 173.838 274.172 173.092 273.799L168.058 270.816C167.312 270.257 166.566 269.138 166.566 268.206V262.426C166.566 261.493 167.312 261.121 168.058 261.493L173.092 264.477Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M186.889 272.493C187.635 273.053 188.381 274.171 188.381 275.104V280.883C188.381 281.816 187.635 282.189 186.889 281.816L181.855 278.833C181.109 278.273 180.364 277.154 180.364 276.222V270.442C180.364 269.51 181.109 269.137 181.855 269.51L186.889 272.493Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M200.873 280.511C201.619 281.07 202.365 282.189 202.365 283.121V288.901C202.365 289.833 201.619 290.206 200.873 289.833L195.839 286.85C195.093 286.291 194.347 285.172 194.347 284.24V278.46C194.347 277.528 195.093 277.155 195.839 277.528L200.873 280.511Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M214.857 288.527C215.602 289.087 216.348 290.205 216.348 291.138V296.918C216.348 297.85 215.602 298.223 214.857 297.85L209.823 294.867C208.89 294.307 208.331 293.189 208.331 292.256V286.477C208.331 285.544 209.077 285.171 209.823 285.544L214.857 288.527Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M228.84 296.546C229.773 297.105 230.332 298.224 230.332 299.156V304.936C230.332 305.868 229.586 306.241 228.84 305.868L223.806 302.885C222.874 302.326 222.315 301.207 222.315 300.275V294.495C222.315 293.563 223.06 293.19 223.806 293.563L228.84 296.546Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M188.94 118.743C192.483 125.082 196.957 130.489 201.992 134.405L198.636 135.896C193.601 131.981 189.127 126.574 185.584 120.235C186.703 119.675 187.821 119.303 188.94 118.743Z"
      fill="white"
    />
    <mask
      id="mask10_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="185"
      y="118"
      width="17"
      height="18"
    >
      <path
        d="M188.94 118.743C192.483 125.082 196.957 130.489 201.992 134.405L198.636 135.896C193.601 131.981 189.127 126.574 185.584 120.235C186.703 119.675 187.821 119.303 188.94 118.743Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask10_918_8688)">
      <path
        d="M184.279 117.624L187.635 116.133C188.008 117.065 188.567 117.811 188.94 118.743L185.584 120.235C185.025 119.302 184.652 118.557 184.279 117.624Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M185.771 120.234L189.127 118.742C189.499 119.302 189.686 119.861 190.059 120.42L186.703 121.912C186.33 121.352 185.957 120.793 185.771 120.234Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M186.703 121.912L190.059 120.421C190.432 120.98 190.618 121.353 190.991 121.726L187.635 123.218C187.262 122.845 187.076 122.285 186.703 121.912Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M187.449 123.217L190.805 121.726C191.178 122.098 191.364 122.658 191.737 123.031L188.381 124.522C188.008 124.149 187.821 123.59 187.449 123.217Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M188.381 124.523L191.737 123.031C192.11 123.404 192.296 123.963 192.669 124.336L189.313 125.828C188.94 125.455 188.754 124.896 188.381 124.523Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M189.313 125.828L192.669 124.336C193.042 124.709 193.228 125.268 193.601 125.641L190.245 127.133C189.872 126.76 189.686 126.2 189.313 125.828Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M190.245 127.133L193.601 125.642C193.974 126.014 194.161 126.387 194.534 126.947L191.178 128.438C190.805 128.065 190.432 127.693 190.245 127.133Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M191.178 128.438L194.534 126.946C194.907 127.319 195.279 127.692 195.466 128.251L192.11 129.743C191.737 129.37 191.364 128.997 191.178 128.438Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M192.296 129.556L195.652 128.064C196.025 128.437 196.398 128.81 196.771 129.183L193.415 130.675C193.042 130.302 192.669 129.929 192.296 129.556Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.228 130.675L196.584 129.184C196.957 129.556 197.33 129.929 197.703 130.302L194.347 131.794C193.974 131.421 193.601 131.048 193.228 130.675Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M194.347 131.794L197.703 130.303C198.076 130.676 198.449 131.049 198.822 131.421L195.466 132.913C195.093 132.54 194.72 132.167 194.347 131.794Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M195.279 132.913L198.635 131.422C199.008 131.795 199.381 131.981 199.754 132.354L196.398 133.846C196.025 133.473 195.652 133.286 195.279 132.913Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M196.398 133.845L199.754 132.354C200.127 132.726 200.5 132.913 200.873 133.286L197.517 134.777C197.144 134.404 196.771 134.218 196.398 133.845Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.33 134.778L200.686 133.286C201.059 133.659 201.432 133.845 201.805 134.032L198.449 135.524C198.076 135.337 197.703 134.964 197.33 134.778Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M198.449 135.523L201.805 134.031C201.805 134.031 201.805 134.031 201.992 134.031L198.636 135.523C198.636 135.523 198.636 135.523 198.449 135.523Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M188.94 118.743C192.483 125.082 196.957 130.489 201.992 134.405L198.636 135.896C193.601 131.981 189.127 126.574 185.584 120.235C186.703 119.675 187.821 119.303 188.94 118.743Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M191.364 92.8262C190.059 102.894 195.466 115.946 203.67 122.285L200.314 123.777C192.296 117.624 186.703 104.386 188.008 94.3178C189.127 93.7584 190.245 93.3855 191.364 92.8262Z"
      fill="white"
    />
    <mask
      id="mask11_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="187"
      y="92"
      width="17"
      height="32"
    >
      <path
        d="M191.364 92.8252C190.059 102.893 195.466 115.945 203.67 122.284L200.314 123.776C192.296 117.623 186.703 104.385 188.008 94.3168C189.127 93.7574 190.245 93.3845 191.364 92.8252Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask11_918_8688)">
      <path
        d="M188.008 94.1312L191.364 92.6396C191.364 92.8261 191.364 93.199 191.364 93.3854L188.008 94.877C188.008 94.6906 188.008 94.3177 188.008 94.1312Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M188.008 94.8764L191.364 93.3848C191.364 93.5712 191.364 93.9441 191.364 94.1306L188.008 95.6221C188.008 95.4357 188.008 95.0628 188.008 94.8764Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M187.821 95.6215L191.177 94.1299C191.177 94.3163 191.177 94.6892 191.177 94.8757L187.821 96.3673C187.821 96.1808 187.821 95.8079 187.821 95.6215Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M187.821 96.5551L191.177 95.0635C191.177 95.2499 191.177 95.6228 191.177 95.8093L187.821 97.3009C187.821 97.1144 187.821 96.7415 187.821 96.5551Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M187.821 97.3012L191.177 95.8096C191.177 95.996 191.177 96.3689 191.177 96.5554L187.821 98.0469C187.821 97.8605 187.821 97.4876 187.821 97.3012Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M187.821 98.0463L191.177 96.5547C191.177 96.7411 191.177 97.114 191.177 97.3005L187.821 98.7921C187.821 98.6056 187.821 98.2327 187.821 98.0463Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M187.821 98.9789L191.177 97.4873C191.177 97.8602 191.177 98.0467 191.177 98.4195L187.821 99.9111C187.821 99.5382 187.821 99.3518 187.821 98.9789Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M188.008 99.724L191.364 98.2324C191.364 98.6053 191.364 98.7918 191.364 99.1647L188.008 100.656C188.008 100.283 188.008 100.097 188.008 99.724Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M188.008 100.658L191.364 99.166C191.364 99.5389 191.364 99.7254 191.364 100.098L188.008 101.59C188.008 101.217 188.008 101.03 188.008 100.658Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M188.194 101.403L191.55 99.9111C191.55 100.284 191.55 100.47 191.55 100.843L188.194 102.335C188.194 101.962 188.194 101.776 188.194 101.403Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M188.381 102.334L191.737 100.843C191.737 101.216 191.737 101.402 191.737 101.775L188.381 103.267C188.381 102.894 188.381 102.707 188.381 102.334Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M188.381 103.267L191.737 101.775C191.737 102.148 191.737 102.335 191.737 102.708L188.381 104.199C188.381 103.826 188.381 103.64 188.381 103.267Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M188.567 104.012L191.923 102.521C191.923 102.707 191.923 103.08 192.11 103.266L188.754 104.758C188.754 104.571 188.754 104.199 188.567 104.012Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M188.754 104.759L192.11 103.268C192.11 103.454 192.11 103.827 192.296 104.013L188.94 105.505C188.94 105.319 188.94 104.946 188.754 104.759Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M188.94 105.692L192.296 104.2C192.296 104.387 192.296 104.76 192.483 104.946L189.127 106.438C189.127 106.251 189.127 105.878 188.94 105.692Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M189.313 106.437L192.669 104.945C192.669 105.132 192.669 105.505 192.856 105.691L189.499 107.183C189.499 106.996 189.499 106.623 189.313 106.437Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M189.5 107.182L192.856 105.69C192.856 106.063 193.042 106.25 193.228 106.623L189.872 108.114C189.872 107.741 189.686 107.555 189.5 107.182Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M189.872 108.115L193.228 106.623C193.228 106.996 193.415 107.369 193.601 107.555L190.245 109.047C190.245 108.674 190.059 108.301 189.872 108.115Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M190.245 109.234L193.601 107.742C193.788 108.302 193.974 108.674 194.161 109.234L190.805 110.725C190.618 110.166 190.432 109.793 190.245 109.234Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M190.805 110.725L194.161 109.233C194.534 109.979 194.72 110.539 195.093 111.284L191.737 112.776C191.364 112.03 191.177 111.471 190.805 110.725Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M191.737 112.589L195.093 111.098C195.279 111.657 195.652 112.216 195.839 112.589L192.483 114.081C192.11 113.521 191.923 112.962 191.737 112.589Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M192.483 114.267L195.839 112.775C196.025 113.148 196.212 113.521 196.398 113.708L193.042 115.199C192.856 114.826 192.669 114.453 192.483 114.267Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.042 115.2L196.398 113.708C196.398 114.081 196.771 114.267 196.957 114.454L193.601 115.945C193.601 115.759 193.228 115.386 193.042 115.2Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.601 116.131L196.957 114.64C196.957 114.826 197.33 115.199 197.517 115.385L194.161 116.877C194.161 116.691 193.788 116.318 193.601 116.131Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M194.161 116.878L197.517 115.387C197.517 115.573 197.89 115.946 198.076 116.133L194.72 117.624C194.72 117.438 194.347 117.065 194.161 116.878Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M194.72 117.623L198.076 116.132C198.076 116.318 198.449 116.691 198.636 116.878L195.279 118.369C195.093 118.183 194.907 117.81 194.72 117.623Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M195.279 118.37L198.635 116.878C198.822 117.064 199.008 117.437 199.195 117.624L195.839 119.115C195.652 118.929 195.466 118.556 195.279 118.37Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M195.839 119.115L199.195 117.623C199.381 117.809 199.568 118.182 199.754 118.369L196.398 119.86C196.212 119.674 196.025 119.301 195.839 119.115Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M196.398 119.861L199.754 118.369C199.941 118.556 200.127 118.928 200.313 119.115L196.957 120.607C196.771 120.42 196.584 120.234 196.398 119.861Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M196.957 120.607L200.314 119.115C200.5 119.302 200.686 119.488 200.873 119.861L197.517 121.353C197.33 121.166 197.144 120.98 196.957 120.607Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.703 121.353L201.059 119.861C201.246 120.048 201.432 120.234 201.619 120.421L198.262 121.912C198.076 121.726 197.89 121.539 197.703 121.353Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M198.262 121.912L201.619 120.421C201.805 120.607 201.991 120.794 202.178 120.98L198.822 122.472C198.635 122.285 198.449 122.099 198.262 121.912Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.008 122.471L202.364 120.979C202.551 120.979 202.737 121.352 202.924 121.539L199.568 123.03C199.381 123.03 199.195 122.658 199.008 122.471Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.568 123.031L202.924 121.539C203.11 121.539 203.297 121.912 203.483 122.098L200.127 123.59C199.941 123.59 199.754 123.217 199.568 123.031Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.127 123.404L203.483 121.912"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M191.364 92.8262C190.059 102.894 195.466 115.946 203.67 122.285L200.314 123.777C192.296 117.624 186.703 104.386 188.008 94.3178C189.127 93.7584 190.245 93.3855 191.364 92.8262Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M196.212 96.5566C195.279 103.269 199.008 112.032 204.415 116.134L201.059 117.625C195.652 113.523 191.923 104.76 192.855 98.0482C193.974 97.4889 195.093 97.116 196.212 96.5566Z"
      fill="white"
    />
    <mask
      id="mask12_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="192"
      y="96"
      width="13"
      height="22"
    >
      <path
        d="M196.212 96.5557C195.279 103.268 199.008 112.031 204.415 116.133L201.059 117.624C195.652 113.522 191.923 104.759 192.855 98.0473C193.974 97.4879 195.093 97.115 196.212 96.5557Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask12_918_8688)">
      <path
        d="M192.856 97.8617L196.212 96.3701C196.212 96.3701 196.212 96.743 196.212 96.9295L192.856 98.421C192.856 98.421 192.856 98.0482 192.856 97.8617Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M192.856 98.4203L196.212 96.9287C196.212 96.9287 196.212 97.3016 196.212 97.4881L192.856 98.9796C192.856 98.9796 192.856 98.6067 192.856 98.4203Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M192.856 98.9808L196.212 97.4893C196.212 97.4893 196.212 97.8622 196.212 98.0486L192.856 99.5402C192.856 99.5402 192.856 99.1673 192.856 98.9808Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M192.856 99.3519L196.212 97.8604C196.212 97.8604 196.212 98.2332 196.212 98.4197L192.856 99.9113C192.856 99.9113 192.856 99.5384 192.856 99.3519Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M192.669 99.9125L196.025 98.4209C196.025 98.4209 196.025 98.7938 196.025 98.9802L192.669 100.472C192.669 100.472 192.669 100.099 192.669 99.9125Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M192.856 100.471L196.212 98.9795C196.212 98.9795 196.212 99.3524 196.212 99.5388L192.856 101.03C192.856 101.03 192.856 100.658 192.856 100.471Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M192.856 101.032L196.212 99.54C196.212 99.7265 196.212 99.9129 196.212 100.099L192.856 101.591C192.856 101.405 192.856 101.218 192.856 101.032Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M192.856 101.59L196.212 100.099C196.212 100.285 196.212 100.472 196.212 100.658L192.856 102.15C192.856 101.963 192.856 101.777 192.856 101.59Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M192.856 102.15L196.212 100.658C196.212 100.845 196.212 101.031 196.212 101.218L192.856 102.709C192.856 102.523 192.856 102.336 192.856 102.15Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.042 102.709L196.398 101.218C196.398 101.404 196.398 101.591 196.398 101.777L193.042 103.269C193.042 103.082 193.042 102.896 193.042 102.709Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.042 103.454L196.398 101.963C196.398 102.149 196.398 102.336 196.398 102.522L193.042 104.014C193.042 103.827 193.042 103.641 193.042 103.454Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.228 104.014L196.584 102.522C196.584 102.709 196.584 102.895 196.584 103.082L193.228 104.573C193.228 104.387 193.228 104.2 193.228 104.014Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.228 104.574L196.584 103.082C196.584 103.082 196.584 103.455 196.584 103.641L193.228 105.133C193.228 105.133 193.228 104.76 193.228 104.574Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.415 105.133L196.771 103.642C196.771 103.642 196.771 104.015 196.771 104.201L193.415 105.693C193.415 105.693 193.415 105.32 193.415 105.133Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.601 105.506L196.957 104.015C196.957 104.015 196.957 104.388 196.957 104.574L193.601 106.066C193.601 106.066 193.601 105.693 193.601 105.506Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.788 106.065L197.144 104.573C197.144 104.573 197.144 104.946 197.144 105.133L193.788 106.624C193.788 106.624 193.788 106.251 193.788 106.065Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.788 106.624L197.144 105.133C197.144 105.319 197.144 105.506 197.33 105.692L193.974 107.184C193.974 106.997 193.974 106.811 193.788 106.624Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.974 107.184L197.33 105.692C197.33 105.879 197.33 106.065 197.517 106.438L194.161 107.93C194.161 107.743 194.161 107.557 193.974 107.184Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M194.347 107.93L197.703 106.438C197.703 106.811 197.89 107.184 198.076 107.371L194.72 108.862C194.72 108.489 194.534 108.117 194.347 107.93Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M194.72 108.862L198.076 107.37C198.263 107.743 198.449 108.302 198.636 108.675L195.279 110.167C195.093 109.794 194.907 109.235 194.72 108.862Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M195.279 110.354L198.635 108.862C198.635 109.235 199.008 109.608 199.195 109.981L195.839 111.473C195.652 111.1 195.466 110.727 195.279 110.354Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M195.839 111.287L199.195 109.795C199.195 109.981 199.381 110.168 199.568 110.541L196.212 112.032C196.212 111.846 196.025 111.659 195.839 111.287Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M196.212 112.032L199.568 110.54C199.568 110.726 199.754 110.913 199.941 111.099L196.585 112.591C196.585 112.591 196.398 112.218 196.212 112.032Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M196.585 112.59L199.941 111.099C199.941 111.099 200.127 111.472 200.314 111.658L196.957 113.15C196.957 113.15 196.771 112.777 196.585 112.59Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M196.957 113.151L200.313 111.659C200.313 111.659 200.5 112.032 200.686 112.219L197.33 113.71C197.33 113.71 197.144 113.337 196.957 113.151Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.33 113.523L200.686 112.031C200.686 112.031 200.873 112.404 201.059 112.591L197.703 114.082C197.703 114.082 197.517 113.709 197.33 113.523Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.703 114.083L201.059 112.592C201.059 112.592 201.246 112.965 201.432 113.151L198.076 114.643C198.076 114.643 197.89 114.27 197.703 114.083Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M198.076 114.642L201.432 113.15C201.432 113.15 201.619 113.523 201.805 113.71L198.449 115.201C198.449 115.201 198.263 114.828 198.076 114.642Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M198.449 115.201L201.805 113.709C201.805 113.709 201.992 114.082 202.178 114.268L198.822 115.76C198.822 115.76 198.449 115.387 198.449 115.201Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M198.822 115.574L202.178 114.082C202.178 114.082 202.364 114.455 202.551 114.455L199.195 115.947L198.822 115.574Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.381 115.948L202.737 114.456C202.737 114.456 202.924 114.829 203.11 114.829L199.754 116.321C199.754 116.321 199.381 116.134 199.381 115.948Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.754 116.507L203.11 115.016C203.11 115.016 203.297 115.202 203.483 115.389L200.127 116.88C200.127 116.88 199.754 116.694 199.754 116.507Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.127 116.879L203.483 115.388C203.483 115.388 203.67 115.574 203.856 115.761L200.5 117.252C200.5 117.252 200.313 117.066 200.127 116.879Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.5 117.252L203.856 115.761C203.856 115.761 204.042 115.947 204.229 116.134L200.873 117.625C200.873 117.625 200.686 117.439 200.5 117.252Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.059 117.439L204.415 115.947"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M196.212 96.5566C195.279 103.269 199.008 112.032 204.415 116.134L201.059 117.625C195.652 113.523 191.923 104.76 192.855 98.0482C193.974 97.4889 195.093 97.116 196.212 96.5566Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M215.043 139.627L211.687 141.118C207.585 141.118 203.11 139.254 198.635 135.898L201.992 134.406C206.653 137.949 211.128 139.627 215.043 139.627Z"
      fill="white"
    />
    <mask
      id="mask13_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="198"
      y="134"
      width="18"
      height="8"
    >
      <path
        d="M215.043 139.626L211.687 141.117C207.585 141.117 203.11 139.253 198.635 135.897L201.992 134.405C206.653 137.948 211.128 139.626 215.043 139.626Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask13_918_8688)">
      <path
        d="M198.635 135.711L201.992 134.22C202.178 134.406 202.551 134.593 202.737 134.779L199.381 136.271C199.195 136.084 198.822 135.898 198.635 135.711Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.381 136.27L202.737 134.778C203.11 134.965 203.483 135.338 203.67 135.524L200.314 137.016C199.941 136.829 199.568 136.643 199.381 136.27Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.5 137.016L203.856 135.524C204.229 135.711 204.602 135.897 204.788 136.084L201.432 137.575C201.059 137.389 200.686 137.202 200.5 137.016Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.432 137.762L204.788 136.271C205.161 136.457 205.534 136.643 205.721 136.83L202.364 138.321C201.992 138.321 201.619 137.949 201.432 137.762Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.551 138.321L205.907 136.829C206.28 137.016 206.653 137.202 206.839 137.388L203.483 138.88C203.11 138.88 202.737 138.507 202.551 138.321Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.483 138.881L206.839 137.39C207.212 137.39 207.585 137.763 207.771 137.949L204.415 139.441C204.042 139.441 203.67 139.068 203.483 138.881Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.602 139.253L207.958 137.762C208.331 137.762 208.704 138.135 209.077 138.135L205.721 139.626C205.348 139.626 204.975 139.253 204.602 139.253Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M205.534 139.814L208.89 138.322C209.263 138.322 209.636 138.509 210.009 138.695L206.653 140.187C206.28 140.187 205.907 140 205.534 139.814Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M206.653 140.185L210.009 138.693C210.382 138.693 210.755 138.88 211.128 139.066L207.771 140.558C207.399 140.558 207.026 140.371 206.653 140.185Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.771 140.559L211.128 139.067C211.5 139.067 211.873 139.254 212.246 139.254L208.89 140.745C208.517 140.745 208.144 140.745 207.771 140.559Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M208.89 140.746L212.246 139.254C212.619 139.254 212.992 139.254 213.551 139.44L210.195 140.932C209.822 140.932 209.45 140.932 208.89 140.746Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M210.195 140.932L213.551 139.44C213.924 139.44 214.484 139.44 214.857 139.44L211.5 140.932C211.128 140.932 210.568 140.932 210.195 140.932Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M211.5 141.118L214.857 139.626C215.416 139.626 215.975 139.626 216.348 139.626L212.992 141.118C212.433 141.118 211.873 141.118 211.5 141.118Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M215.043 139.627L211.687 141.118C207.585 141.118 203.11 139.254 198.635 135.898L201.992 134.406C206.653 137.949 211.128 139.627 215.043 139.627Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M215.043 139.626C216.907 139.626 218.772 139.253 220.45 138.693L217.094 140.185C215.416 140.931 213.551 141.304 211.687 141.117C212.433 140.744 213.178 140.371 214.111 140.185C214.111 140.185 214.484 140.185 214.67 139.998L215.043 139.626Z"
      fill="white"
    />
    <mask
      id="mask14_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="211"
      y="138"
      width="10"
      height="4"
    >
      <path
        d="M215.043 139.625C216.907 139.625 218.772 139.252 220.45 138.692L217.094 140.184C215.416 140.93 213.551 141.303 211.687 141.116C212.433 140.743 213.178 140.37 214.111 140.184C214.111 140.184 214.484 140.184 214.67 139.998L215.043 139.625Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask14_918_8688)">
      <path
        d="M211.5 141.118L214.857 139.626C215.416 139.626 215.975 139.626 216.348 139.626L212.992 141.118C212.433 141.118 211.873 141.118 211.5 141.118Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.992 141.117L216.348 139.626C217.094 139.626 217.653 139.626 218.213 139.439L214.857 140.931C214.297 140.931 213.551 141.117 212.992 141.117Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M215.043 140.744L218.399 139.253C219.145 139.253 219.891 138.88 220.636 138.507L217.28 139.998C216.535 140.371 215.789 140.558 215.043 140.744Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M215.043 139.626C216.907 139.626 218.772 139.253 220.45 138.693L217.094 140.185C215.416 140.931 213.551 141.304 211.687 141.117C212.433 140.744 213.178 140.371 214.111 140.185C214.111 140.185 214.484 140.185 214.67 139.998L215.043 139.626Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M202.924 128.066C208.331 132.168 213.551 133.101 217.653 131.422L214.297 132.914C210.195 134.592 204.975 133.66 199.568 129.558C200.5 129.185 201.805 128.626 202.924 128.066Z"
      fill="white"
    />
    <mask
      id="mask15_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="199"
      y="128"
      width="19"
      height="6"
    >
      <path
        d="M202.924 128.067C208.331 132.169 213.551 133.101 217.653 131.423L214.297 132.915C210.195 134.593 204.975 133.661 199.568 129.559C200.5 129.186 201.805 128.627 202.924 128.067Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask15_918_8688)">
      <path
        d="M199.568 129.371L202.924 127.88C203.11 127.88 203.297 128.253 203.483 128.253L200.127 129.744C199.941 129.744 199.754 129.371 199.568 129.371Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.127 129.93L203.483 128.438C203.67 128.625 204.043 128.811 204.229 128.998L200.873 130.489C200.686 130.489 200.314 130.117 200.127 129.93Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.873 130.491L204.229 128.999C204.415 128.999 204.788 129.372 204.975 129.558L201.619 131.05C201.432 131.05 201.059 130.677 200.873 130.491Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.805 130.863L205.161 129.371C205.348 129.371 205.721 129.744 205.907 129.744L202.551 131.236C202.364 131.236 201.992 130.863 201.805 130.863Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.551 131.422L205.907 129.931C206.093 129.931 206.466 130.304 206.653 130.304L203.297 131.795C203.11 131.795 202.737 131.609 202.551 131.422Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.297 131.795L206.653 130.304C206.839 130.304 207.212 130.49 207.399 130.677L204.042 132.168C203.856 132.168 203.483 131.982 203.297 131.795Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.042 132.168L207.399 130.677C207.585 130.677 207.958 130.863 208.144 131.05L204.788 132.541C204.602 132.541 204.229 132.355 204.042 132.168Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.975 132.541L208.331 131.05C208.517 131.05 208.89 131.236 209.077 131.423L205.721 132.914C205.534 132.914 205.161 132.728 204.975 132.541Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M205.72 132.914L209.077 131.423C209.449 131.423 209.636 131.609 210.009 131.609L206.653 133.101C206.28 133.101 206.093 133.101 205.72 132.914Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M206.653 133.1L210.009 131.608C210.382 131.608 210.568 131.608 210.941 131.795L207.585 133.286C207.212 133.286 207.026 133.286 206.653 133.1Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.585 133.287L210.941 131.795C211.314 131.795 211.687 131.795 211.873 131.795L208.517 133.287C208.144 133.287 207.958 133.287 207.585 133.287Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M208.517 133.474L211.873 131.982C212.246 131.982 212.619 131.982 212.992 131.982L209.636 133.474C209.263 133.474 208.89 133.474 208.517 133.474Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M209.636 133.66L212.992 132.168C213.365 132.168 213.738 132.168 214.297 132.168L210.941 133.66C210.568 133.66 210.195 133.66 209.636 133.66Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M210.941 133.66L214.297 132.169C214.856 132.169 215.229 132.169 215.789 131.982L212.433 133.474C211.873 133.474 211.5 133.474 210.941 133.66Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.433 133.287L215.789 131.796C216.348 131.796 217.094 131.423 217.653 131.236L214.297 132.728C213.738 132.914 213.179 133.101 212.433 133.287Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M202.924 128.066C208.331 132.168 213.551 133.101 217.653 131.422L214.297 132.914C210.195 134.592 204.975 133.66 199.568 129.558C200.5 129.185 201.805 128.626 202.924 128.066Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M203.67 122.286C207.771 125.456 211.687 126.202 214.856 124.896L211.5 126.388C208.331 127.693 204.415 126.947 200.313 123.778C201.246 123.405 202.551 122.845 203.67 122.286Z"
      fill="white"
    />
    <mask
      id="mask16_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="200"
      y="122"
      width="15"
      height="5"
    >
      <path
        d="M203.67 122.286C207.771 125.456 211.687 126.202 214.856 124.896L211.5 126.388C208.331 127.693 204.415 126.947 200.313 123.778C201.246 123.405 202.551 122.845 203.67 122.286Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask16_918_8688)">
      <path
        d="M200.313 123.59L203.67 122.099C203.67 122.099 204.042 122.285 204.229 122.472L200.873 123.963C200.873 123.963 200.5 123.777 200.313 123.59Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.686 123.964L204.042 122.473C204.229 122.473 204.415 122.846 204.602 122.846L201.246 124.337C201.059 124.337 200.873 124.151 200.686 123.964Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.432 124.335L204.788 122.844C204.975 122.844 205.161 123.03 205.348 123.217L201.991 124.708C201.805 124.708 201.619 124.522 201.432 124.335Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.991 124.709L205.348 123.218C205.534 123.218 205.72 123.404 205.907 123.591L202.551 125.082C202.364 125.082 202.178 124.896 201.991 124.709Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.551 125.081L205.907 123.59C206.093 123.59 206.28 123.776 206.466 123.963L203.11 125.454C202.924 125.454 202.737 125.268 202.551 125.081Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.11 125.454L206.466 123.963C206.653 123.963 206.839 124.149 207.026 124.336L203.67 125.827C203.483 125.827 203.297 125.641 203.11 125.454Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.856 125.641L207.212 124.149C207.398 124.149 207.585 124.149 207.771 124.336L204.415 125.827C204.229 125.827 204.042 125.827 203.856 125.641Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.415 126.014L207.771 124.522C207.958 124.522 208.144 124.522 208.331 124.709L204.975 126.2C204.788 126.2 204.602 126.2 204.415 126.014Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.975 126.201L208.331 124.709C208.517 124.709 208.704 124.709 209.077 124.895L205.72 126.387C205.534 126.387 205.348 126.387 204.975 126.201Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M205.72 126.387L209.077 124.896C209.263 124.896 209.449 124.896 209.822 124.896L206.466 126.387C206.28 126.387 206.093 126.387 205.72 126.387Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M206.466 126.574L209.822 125.082C210.009 125.082 210.382 125.082 210.568 125.082L207.212 126.574C207.026 126.574 206.653 126.574 206.466 126.574Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.212 126.76L210.568 125.269C210.755 125.269 211.128 125.269 211.314 125.269L207.958 126.76C207.771 126.76 207.399 126.76 207.212 126.76Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.958 126.76L211.314 125.269C211.687 125.269 211.873 125.269 212.246 125.269L208.89 126.76C208.517 126.76 208.331 126.76 207.958 126.76Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M208.89 126.76L212.246 125.269C212.619 125.269 212.992 125.269 213.365 125.269L210.009 126.76C209.636 126.76 209.263 126.76 208.89 126.76Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M210.009 126.573L213.365 125.082C213.924 125.082 214.297 124.895 214.67 124.709L211.314 126.201C210.941 126.201 210.382 126.573 210.009 126.573Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M203.67 122.286C207.771 125.456 211.687 126.202 214.856 124.896L211.5 126.388C208.331 127.693 204.415 126.947 200.313 123.778C201.246 123.405 202.551 122.845 203.67 122.286Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M204.415 116.133C207.212 118.184 209.822 118.743 211.873 117.811L208.517 119.302C206.466 120.235 203.856 119.675 201.059 117.624C201.992 117.252 203.297 116.692 204.415 116.133Z"
      fill="white"
    />
    <mask
      id="mask17_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="201"
      y="116"
      width="11"
      height="4"
    >
      <path
        d="M204.415 116.133C207.212 118.184 209.822 118.743 211.873 117.811L208.517 119.302C206.466 120.235 203.856 119.675 201.059 117.624C201.992 117.252 203.297 116.692 204.415 116.133Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask17_918_8688)">
      <path
        d="M201.059 117.624L204.415 116.133C204.415 116.133 204.602 116.133 204.788 116.319L201.432 117.811C201.432 117.811 201.246 117.811 201.059 117.624Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.432 117.811L204.788 116.319C204.788 116.319 204.975 116.506 205.161 116.692L201.805 118.184C201.805 118.184 201.619 118.184 201.432 117.811Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.805 118.183L205.161 116.691C205.161 116.691 205.348 116.691 205.534 116.878L202.178 118.369C202.178 118.369 201.992 118.369 201.805 118.183Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.178 118.37L205.534 116.878C205.534 116.878 205.721 116.878 205.907 117.064L202.551 118.556C202.551 118.556 202.364 118.556 202.178 118.37Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.551 118.556L205.907 117.064C205.907 117.064 206.093 117.064 206.28 117.251L202.924 118.742C202.924 118.742 202.737 118.742 202.551 118.556Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.11 118.744L206.466 117.252C206.466 117.252 206.653 117.252 206.839 117.438L203.483 118.93C203.483 118.93 203.297 118.93 203.11 118.744Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.483 118.93L206.839 117.438H207.212L203.856 118.93H203.483Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.856 119.115L207.212 117.623H207.585L204.229 119.115H203.856Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.229 119.302L207.585 117.811H207.958L204.602 119.302H204.229Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.788 119.489L208.144 117.997H208.517L205.161 119.489H204.788Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M205.161 119.675L208.517 118.184C208.517 118.184 208.89 118.184 209.077 118.184L205.72 119.675C205.72 119.675 205.348 119.675 205.161 119.675Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M205.721 119.675L209.077 118.184C209.263 118.184 209.45 118.184 209.636 118.184L206.28 119.675C206.28 119.675 205.907 119.675 205.721 119.675Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M206.28 119.675L209.636 118.184C209.822 118.184 210.009 118.184 210.195 118.184L206.839 119.675C206.653 119.675 206.466 119.675 206.28 119.675Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M206.839 119.675L210.195 118.184C210.382 118.184 210.755 118.184 210.941 118.184L207.585 119.675C207.399 119.675 207.026 119.675 206.839 119.675Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.585 119.675L210.941 118.183C211.314 118.183 211.5 118.183 211.873 117.811L208.517 119.302C208.144 119.302 207.958 119.489 207.585 119.675Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M204.415 116.133C207.212 118.184 209.822 118.743 211.873 117.811L208.517 119.302C206.466 120.235 203.856 119.675 201.059 117.624C201.992 117.252 203.297 116.692 204.415 116.133Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M205.161 110.539C206.653 111.658 208.144 112.031 209.263 111.471L205.907 112.963C204.788 113.522 203.297 113.149 201.805 112.031C202.737 111.658 204.042 111.098 205.161 110.539Z"
      fill="white"
    />
    <mask
      id="mask18_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="201"
      y="110"
      width="9"
      height="4"
    >
      <path
        d="M205.161 110.538C206.653 111.657 208.144 112.03 209.263 111.47L205.907 112.962C204.788 113.521 203.297 113.148 201.805 112.03C202.737 111.657 204.042 111.097 205.161 110.538Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask18_918_8688)">
      <path
        d="M201.805 112.03L205.161 110.538"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.991 112.216L205.348 110.725C205.348 110.725 205.348 110.725 205.534 110.725L202.178 112.216C202.178 112.216 202.178 112.216 201.991 112.216Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.178 112.216L205.534 110.725C205.534 110.725 205.534 110.725 205.72 110.725L202.364 112.216C202.364 112.216 202.364 112.216 202.178 112.216Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.364 112.404L205.72 110.912C205.72 110.912 205.72 110.912 205.907 110.912L202.551 112.404C202.551 112.404 202.551 112.404 202.364 112.404Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.737 112.588L206.093 111.097C206.093 111.097 206.093 111.097 206.28 111.097L202.924 112.588C202.924 112.588 202.924 112.588 202.737 112.588Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.924 112.775L206.28 111.283C206.28 111.283 206.28 111.283 206.466 111.283L203.11 112.775C203.11 112.775 203.11 112.775 202.924 112.775Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.11 112.775L206.466 111.283C206.466 111.283 206.466 111.283 206.653 111.283L203.297 112.775C203.297 112.775 203.297 112.775 203.11 112.775Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.297 112.962L206.653 111.471C206.653 111.471 206.653 111.471 206.839 111.471L203.483 112.962C203.483 112.962 203.483 112.962 203.297 112.962Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.483 112.962L206.839 111.471C206.839 111.471 206.839 111.471 207.026 111.471L203.67 112.962C203.67 112.962 203.67 112.962 203.483 112.962Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.856 112.962L207.212 111.471C207.212 111.471 207.212 111.471 207.398 111.471L204.042 112.962C204.042 112.962 204.042 112.962 203.856 112.962Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.042 113.149L207.398 111.657C207.398 111.657 207.398 111.657 207.585 111.657L204.229 113.149C204.229 113.149 204.229 113.149 204.042 113.149Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.229 113.149L207.585 111.657C207.585 111.657 207.771 111.657 207.958 111.657L204.602 113.149C204.602 113.149 204.415 113.149 204.229 113.149Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.602 113.149L207.958 111.657C207.958 111.657 208.144 111.657 208.331 111.657L204.975 113.149C204.975 113.149 204.788 113.149 204.602 113.149Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.975 113.149L208.331 111.657H208.704L205.348 113.149C205.348 113.149 205.161 113.149 204.975 113.149Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M205.348 113.149L208.704 111.657C208.704 111.657 209.077 111.657 209.263 111.657L205.907 113.149C205.907 113.149 205.534 113.149 205.348 113.149Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M205.161 110.539C206.653 111.658 208.144 112.031 209.263 111.471L205.907 112.963C204.788 113.522 203.297 113.149 201.805 112.031C202.737 111.658 204.042 111.098 205.161 110.539Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M205.161 110.54C204.042 110.913 202.924 111.472 201.805 112.032C198.822 109.794 196.957 104.947 197.33 101.404C197.517 99.5397 198.449 98.421 199.568 97.8617L202.924 96.3701C201.805 96.9295 201.059 98.0481 200.686 99.9126C200.127 103.642 202.178 108.303 205.161 110.54Z"
      fill="white"
    />
    <mask
      id="mask19_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="197"
      y="96"
      width="9"
      height="17"
    >
      <path
        d="M205.161 110.541C204.042 110.914 202.924 111.473 201.805 112.033C198.822 109.795 196.957 104.948 197.33 101.405C197.517 99.5407 198.449 98.422 199.568 97.8627L202.924 96.3711C201.805 96.9304 201.059 98.0491 200.686 99.9136C200.127 103.643 202.178 108.304 205.161 110.541Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask19_918_8688)">
      <path
        d="M199.568 97.8627L202.924 96.3711C202.551 96.3711 202.178 96.744 201.805 97.3033L198.449 98.7949C198.822 98.422 199.195 98.0491 199.568 97.8627Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M198.449 98.7953L201.805 97.3037C201.805 97.3037 201.805 97.4902 201.619 97.6766L198.262 99.1682C198.262 99.1682 198.262 98.9817 198.449 98.7953Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M198.076 99.1674L201.432 97.6758C201.432 97.6758 201.432 97.8622 201.432 98.0487L198.076 99.5403C198.076 99.5403 198.076 99.3538 198.076 99.1674Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.89 99.3529L201.246 97.8613C201.246 97.8613 201.246 98.0478 201.246 98.2342L197.89 99.7258C197.89 99.7258 197.89 99.5394 197.89 99.3529Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.89 99.7269L201.246 98.2354C201.246 98.2354 201.246 98.4218 201.246 98.6082L197.89 100.1C197.89 100.1 197.89 99.9134 197.89 99.7269Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.703 99.9135L201.059 98.4219C201.059 98.4219 201.059 98.4219 201.059 98.6083L197.703 100.1C197.703 100.1 197.703 100.1 197.703 99.9135Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.703 100.286L201.059 98.7939C201.059 98.7939 201.059 98.7939 201.059 98.9804L197.703 100.472C197.703 100.472 197.703 100.472 197.703 100.286Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.517 100.472L200.873 98.9805C200.873 98.9805 200.873 98.9805 200.873 99.1669L197.517 100.659C197.517 100.659 197.517 100.659 197.517 100.472Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.517 100.846L200.873 99.3545C200.873 99.3545 200.873 99.3545 200.873 99.5409L197.517 101.033C197.517 101.033 197.517 101.033 197.517 100.846Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.33 101.033L200.686 99.541C200.686 99.541 200.686 99.541 200.686 99.7275L197.33 101.219V101.033Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.33 101.405L200.686 99.9131C200.686 99.9131 200.686 99.9131 200.686 100.1L197.33 101.591C197.33 101.591 197.33 101.591 197.33 101.405Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.33 101.591L200.686 100.1C200.686 100.1 200.686 100.1 200.686 100.286L197.33 101.778V101.591Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.33 101.965L200.686 100.474C200.686 100.474 200.686 100.66 200.686 100.847L197.33 102.338C197.33 102.338 197.33 102.152 197.33 101.965Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.33 102.151L200.686 100.659C200.686 100.659 200.686 100.846 200.686 101.032L197.33 102.524C197.33 102.524 197.33 102.337 197.33 102.151Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.33 102.524L200.686 101.032C200.686 101.032 200.686 101.219 200.686 101.405L197.33 102.897C197.33 102.897 197.33 102.71 197.33 102.524Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.33 102.71L200.686 101.219C200.686 101.219 200.686 101.405 200.686 101.592L197.33 103.083C197.33 103.083 197.33 102.897 197.33 102.71Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.33 103.083L200.686 101.592C200.686 101.592 200.686 101.778 200.686 101.965L197.33 103.456C197.33 103.456 197.33 103.27 197.33 103.083Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.33 103.269L200.686 101.777C200.686 101.777 200.686 101.964 200.686 102.15L197.33 103.642C197.33 103.642 197.33 103.455 197.33 103.269Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.33 103.642L200.686 102.15C200.686 102.15 200.686 102.337 200.686 102.523L197.33 104.015C197.33 104.015 197.33 103.828 197.33 103.642Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.33 104.015L200.686 102.523C200.686 102.523 200.686 102.71 200.686 102.896L197.33 104.388C197.33 104.388 197.33 104.201 197.33 104.015Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.517 104.388L200.873 102.896C200.873 102.896 200.873 103.083 200.873 103.269L197.517 104.761C197.517 104.761 197.517 104.575 197.517 104.388Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.517 104.575L200.873 103.083C200.873 103.083 200.873 103.269 200.873 103.456L197.517 104.947C197.517 104.947 197.517 104.761 197.517 104.575Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.517 104.948L200.873 103.456C200.873 103.456 200.873 103.643 200.873 103.829L197.517 105.321C197.517 105.321 197.517 105.134 197.517 104.948Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.703 105.134L201.059 103.643C201.059 103.643 201.059 103.829 201.059 104.015L197.703 105.507C197.703 105.507 197.703 105.321 197.703 105.134Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.703 105.507L201.059 104.016C201.059 104.016 201.059 104.202 201.059 104.389L197.703 105.88C197.703 105.88 197.703 105.694 197.703 105.507Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.89 105.879L201.246 104.388C201.246 104.388 201.246 104.574 201.246 104.761L197.89 106.252C197.89 106.252 197.89 106.066 197.89 105.879Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.89 106.066L201.246 104.574C201.246 104.574 201.246 104.761 201.246 104.947L197.89 106.439C197.89 106.439 197.89 106.252 197.89 106.066Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M198.076 106.439L201.432 104.947C201.432 104.947 201.432 105.134 201.432 105.32L198.076 106.812C198.076 106.812 198.076 106.625 198.076 106.439Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M198.076 106.812L201.432 105.32C201.432 105.32 201.432 105.693 201.619 105.88L198.262 107.371C198.262 107.371 198.262 106.998 198.076 106.812Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M198.449 107.371L201.805 105.88C201.805 106.066 201.991 106.439 202.178 106.626L198.822 108.117C198.822 107.931 198.635 107.558 198.449 107.371Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M198.635 108.118L201.991 106.626C201.991 106.812 202.178 106.999 202.364 107.185L199.008 108.677C199.008 108.677 198.822 108.304 198.635 108.118Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.008 108.676L202.364 107.185C202.364 107.185 202.364 107.371 202.551 107.557L199.195 109.049C199.195 109.049 199.195 108.863 199.008 108.676Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.195 109.049L202.551 107.558C202.551 107.558 202.551 107.744 202.551 107.931L199.195 109.422C199.195 109.422 199.195 109.236 199.008 109.049"
        fill="white"
      />
      <path
        d="M199.195 109.049L202.551 107.558C202.551 107.558 202.551 107.744 202.551 107.931L199.195 109.422C199.195 109.422 199.195 109.236 199.008 109.049"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.381 109.237L202.737 107.745C202.737 107.745 202.737 107.932 202.924 108.118L199.568 109.61C199.568 109.61 199.568 109.423 199.381 109.237Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.568 109.608L202.924 108.116C202.924 108.116 202.924 108.116 203.11 108.303L199.754 109.794C199.754 109.794 199.754 109.794 199.568 109.608Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.754 109.795L203.11 108.304C203.11 108.304 203.11 108.304 203.297 108.49L199.94 109.982C199.94 109.982 199.94 109.982 199.754 109.795Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.941 110.168L203.297 108.677C203.297 108.677 203.297 108.677 203.483 108.863L200.127 110.355C200.127 110.355 200.127 110.355 199.941 110.168Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.127 110.355L203.483 108.863C203.483 108.863 203.483 108.863 203.669 109.05L200.313 110.541C200.313 110.541 200.313 110.541 200.127 110.355Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.5 110.727L203.856 109.235C203.856 109.235 203.856 109.235 204.042 109.422L200.686 110.913C200.686 110.913 200.686 110.913 200.5 110.727Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.686 110.913L204.042 109.422C204.042 109.422 204.042 109.422 204.229 109.608L200.873 111.1C200.873 111.1 200.873 111.1 200.686 110.913Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.873 111.101L204.229 109.609C204.229 109.609 204.229 109.609 204.415 109.796L201.059 111.287C201.059 111.287 201.059 111.287 200.873 111.101Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.059 111.472L204.415 109.98C204.415 109.98 204.415 109.98 204.602 110.167L201.246 111.659C201.246 111.659 201.246 111.659 201.059 111.472Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.246 111.66L204.602 110.168C204.602 110.168 204.602 110.168 204.788 110.354L201.432 111.846C201.432 111.846 201.432 111.846 201.246 111.66Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.618 111.846L204.975 110.354C204.975 110.354 204.975 110.354 205.161 110.354L201.805 111.846C201.805 111.846 201.805 111.846 201.618 111.846Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.805 112.033L205.161 110.541"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M205.161 110.54C204.042 110.913 202.924 111.472 201.805 112.032C198.822 109.794 196.957 104.947 197.33 101.404C197.517 99.5397 198.449 98.421 199.568 97.8617L202.924 96.3701C201.805 96.9295 201.059 98.0481 200.686 99.9126C200.127 103.642 202.178 108.303 205.161 110.54Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M200.127 90.2178C198.076 91.15 196.584 93.2009 196.212 96.557C195.093 97.1164 193.974 97.4893 192.855 98.0486C193.228 94.6925 194.72 92.4552 196.771 91.7094C197.703 91.3365 199.008 90.7771 200.127 90.2178Z"
      fill="white"
    />
    <mask
      id="mask20_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="192"
      y="90"
      width="9"
      height="9"
    >
      <path
        d="M200.127 90.2188C198.076 91.151 196.584 93.2019 196.212 96.558C195.093 97.1173 193.974 97.4902 192.855 98.0496C193.228 94.6935 194.72 92.4561 196.771 91.7103C197.703 91.3374 199.008 90.7781 200.127 90.2188Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask20_918_8688)">
      <path
        d="M196.771 91.5228L200.127 90.0312C199.381 90.4041 198.635 90.9635 198.076 91.5228L194.72 93.0144C195.279 92.2686 196.025 91.7093 196.771 91.5228Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M194.72 93.0141L198.076 91.5225C198.076 91.7089 197.703 91.8954 197.517 92.2683L194.161 93.7598C194.161 93.5734 194.534 93.387 194.72 93.0141Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M194.347 93.7611L197.703 92.2695C197.703 92.2695 197.517 92.6424 197.33 92.8289L193.974 94.3205C193.974 94.134 194.161 93.9476 194.347 93.7611Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.974 94.3197L197.33 92.8281C197.33 92.8281 197.33 93.201 197.144 93.3875L193.788 94.8791C193.788 94.8791 193.788 94.5062 193.974 94.3197Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.788 94.8793L197.144 93.3877C197.144 93.3877 197.144 93.7606 196.957 93.947L193.601 95.4386C193.601 95.4386 193.601 95.0657 193.788 94.8793Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.415 95.4379L196.771 93.9463C196.771 93.9463 196.771 94.3192 196.771 94.5056L193.415 95.9972C193.415 95.9972 193.415 95.6243 193.415 95.4379Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.415 95.8109L196.771 94.3193C196.771 94.3193 196.771 94.6922 196.771 94.8787L193.415 96.3703C193.415 96.3703 193.415 95.9974 193.415 95.8109Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.228 96.3705L196.585 94.8789C196.585 94.8789 196.585 95.2518 196.585 95.4383L193.228 96.9298C193.228 96.9298 193.228 96.5569 193.228 96.3705Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.042 96.9301L196.398 95.4385C196.398 95.4385 196.398 95.8114 196.398 95.9978L193.042 97.4894C193.042 97.4894 193.042 97.1165 193.042 96.9301Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.042 97.3021L196.398 95.8105C196.398 95.8105 196.398 96.1834 196.398 96.3699L193.042 97.8615C193.042 97.8615 193.042 97.4886 193.042 97.3021Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M192.856 97.8617L196.212 96.3701C196.212 96.3701 196.212 96.743 196.212 96.9295L192.856 98.421C192.856 98.421 192.856 98.0482 192.856 97.8617Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M200.127 90.2178C198.076 91.15 196.584 93.2009 196.212 96.557C195.093 97.1164 193.974 97.4893 192.855 98.0486C193.228 94.6925 194.72 92.4552 196.771 91.7094C197.703 91.3365 199.008 90.7771 200.127 90.2178Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M197.33 83.3184C194.347 84.6235 192.11 87.9796 191.364 92.8272C190.245 93.3866 189.127 93.7595 188.008 94.3188C188.754 89.2847 190.805 86.1151 193.974 84.8099C194.906 84.437 196.212 83.8777 197.33 83.3184Z"
      fill="white"
    />
    <mask
      id="mask21_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="188"
      y="83"
      width="10"
      height="12"
    >
      <path
        d="M197.33 83.3184C194.347 84.6235 192.11 87.9796 191.364 92.8272C190.245 93.3866 189.127 93.7595 188.008 94.3188C188.754 89.2847 190.805 86.1151 193.974 84.8099C194.906 84.437 196.212 83.8777 197.33 83.3184Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask21_918_8688)">
      <path
        d="M193.974 84.6225L197.33 83.1309C196.212 83.6902 195.093 84.436 194.161 85.3682L190.805 86.8598C191.737 85.7411 192.669 84.9954 193.974 84.6225Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M190.805 87.0463L194.161 85.5547C193.974 85.9276 193.601 86.114 193.415 86.4869L190.059 87.9785C190.245 87.6056 190.618 87.2327 190.805 87.0463Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M190.245 87.9789L193.601 86.4873C193.601 86.6738 193.228 87.0467 193.042 87.4195L189.686 88.9111C189.686 88.5382 190.059 88.3518 190.245 87.9789Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M189.686 88.9105L193.042 87.4189C193.042 87.6054 192.856 87.9783 192.669 88.1647L189.313 89.6563C189.313 89.4699 189.499 89.097 189.686 88.9105Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M189.313 89.6566L192.669 88.165C192.669 88.3515 192.483 88.7244 192.296 88.9108L188.94 90.4024C188.94 90.216 189.127 89.8431 189.313 89.6566Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M188.94 90.4027L192.296 88.9111C192.296 89.0976 192.296 89.4705 192.11 89.6569L188.754 91.1485C188.754 90.9621 188.754 90.5892 188.94 90.4027Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M188.754 91.1488L192.11 89.6572C192.11 89.8437 192.11 90.2166 191.923 90.403L188.567 91.8946C188.567 91.7082 188.567 91.3353 188.754 91.1488Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M188.567 91.8939L191.923 90.4023C191.923 90.5888 191.923 90.9617 191.923 91.1481L188.567 92.6397C188.567 92.4533 188.567 92.0804 188.567 91.8939Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M188.381 92.639L191.737 91.1475C191.737 91.3339 191.737 91.7068 191.737 91.8933L188.381 93.3848C188.381 93.1984 188.381 92.8255 188.381 92.639Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M188.194 93.3861L191.55 91.8945C191.55 92.081 191.55 92.4539 191.55 92.6403L188.194 94.1319C188.194 93.9455 188.194 93.5726 188.194 93.3861Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M188.008 94.1322L191.364 92.6406C191.364 92.8271 191.364 93.2 191.364 93.3864L188.008 94.878C188.008 94.6916 188.008 94.3187 188.008 94.1322Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M197.33 83.3184C194.347 84.6235 192.11 87.9796 191.364 92.8272C190.245 93.3866 189.127 93.7595 188.008 94.3188C188.754 89.2847 190.805 86.1151 193.974 84.8099C194.906 84.437 196.212 83.8777 197.33 83.3184Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M186.703 89.2849C185.025 102.523 192.11 119.862 202.924 128.066L199.568 129.558C188.94 121.354 181.669 104.014 183.347 90.7765C184.279 84.2508 187.076 79.7761 191.178 78.098L194.534 76.6064C190.432 78.2845 187.635 82.5728 186.703 89.2849Z"
      fill="white"
    />
    <mask
      id="mask22_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="183"
      y="76"
      width="20"
      height="54"
    >
      <path
        d="M186.703 89.2849C185.025 102.523 192.11 119.862 202.924 128.066L199.568 129.558C188.94 121.354 181.669 104.014 183.347 90.7765C184.279 84.2508 187.076 79.7761 191.178 78.098L194.534 76.6064C190.432 78.2845 187.635 82.5728 186.703 89.2849Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask22_918_8688)">
      <path
        d="M191.178 78.098L194.534 76.6064C193.042 77.1658 191.55 78.2845 190.432 79.5896L187.076 81.0812C188.194 79.7761 189.686 78.6574 191.178 78.098Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M187.076 81.0814L190.432 79.5898C190.059 79.9627 189.686 80.5221 189.5 80.895L186.143 82.3866C186.516 81.8272 186.703 81.4543 187.076 81.0814Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M186.143 82.3861L189.5 80.8945C189.313 81.2674 189.127 81.6403 188.754 82.0132L185.398 83.5048C185.584 83.1319 185.771 82.759 186.143 82.3861Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M185.398 83.5053L188.754 82.0137C188.754 82.3866 188.381 82.7595 188.194 83.1324L184.838 84.624C184.838 84.2511 185.211 83.8782 185.398 83.5053Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M185.025 84.6244L188.381 83.1328C188.381 83.5057 188.008 83.8786 188.008 84.2515L184.652 85.7431C184.652 85.3702 184.838 84.9973 185.025 84.6244Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M184.465 85.556L187.821 84.0645C187.821 84.4374 187.635 84.8102 187.449 84.9967L184.093 86.4883C184.093 86.1154 184.279 85.7425 184.465 85.556Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M184.279 86.6752L187.635 85.1836C187.635 85.5565 187.449 85.7429 187.449 86.1158L184.093 87.6074C184.093 87.2345 184.093 86.8616 184.279 86.6752Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M183.906 87.6078L187.262 86.1162C187.262 86.4891 187.262 86.862 187.076 87.0485L183.72 88.54C183.72 88.1671 183.72 87.7942 183.906 87.6078Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M183.72 88.5394L187.076 87.0479C187.076 87.4207 187.076 87.6072 186.889 87.9801L183.533 89.4717C183.533 89.0988 183.533 88.7259 183.72 88.5394Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M183.533 89.6586L186.889 88.167C186.889 88.5399 186.889 88.9128 186.889 89.0992L183.533 90.5908C183.533 90.2179 183.533 89.845 183.533 89.6586Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M183.347 90.5902L186.703 89.0986C186.703 89.4715 186.703 89.658 186.703 90.0309L183.347 91.5225C183.347 91.1496 183.347 90.9631 183.347 90.5902Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M183.16 91.5228L186.516 90.0312C186.516 90.4041 186.516 90.777 186.516 90.9635L183.16 92.4551C183.16 92.0822 183.16 91.7093 183.16 91.5228Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M183.16 92.641L186.516 91.1494C186.516 91.5223 186.516 91.8952 186.516 92.2681L183.16 93.7597C183.16 93.3868 183.16 93.0139 183.16 92.641Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M183.16 93.5726L186.516 92.0811C186.516 92.454 186.516 92.8268 186.516 93.1997L183.16 94.6913C183.16 94.3184 183.16 93.9455 183.16 93.5726Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M183.16 94.6918L186.516 93.2002C186.516 93.5731 186.516 93.946 186.516 94.3189L183.16 95.8105C183.16 95.4376 183.16 95.0647 183.16 94.6918Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M183.16 95.8109L186.516 94.3193C186.516 94.6922 186.516 95.0651 186.516 95.438L183.16 96.9296C183.16 96.5567 183.16 96.1838 183.16 95.8109Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M183.16 96.7435L186.516 95.252C186.516 95.6249 186.516 95.9978 186.516 96.3706L183.16 97.8622C183.16 97.4893 183.16 97.1164 183.16 96.7435Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M183.16 97.8617L186.516 96.3701C186.516 96.743 186.516 97.1159 186.516 97.4888L183.16 98.9804C183.16 98.6075 183.16 98.2346 183.16 97.8617Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M183.347 98.9808L186.703 97.4893C186.703 97.8622 186.703 98.2351 186.703 98.608L183.347 100.1C183.347 99.7266 183.347 99.3537 183.347 98.9808Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M183.533 100.285L186.889 98.793C186.889 99.1659 186.889 99.5388 186.889 99.9117L183.533 101.403C183.533 101.03 183.533 100.657 183.533 100.285Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M183.72 101.404L187.076 99.9121C187.076 100.285 187.076 100.658 187.262 101.031L183.906 102.522C183.906 102.149 183.906 101.777 183.72 101.404Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M183.906 102.523L187.262 101.031C187.262 101.404 187.262 101.777 187.449 102.15L184.093 103.642C184.093 103.269 184.093 102.896 183.906 102.523Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M184.093 103.642L187.449 102.15C187.449 102.523 187.449 102.896 187.635 103.269L184.279 104.761C184.279 104.388 184.279 104.015 184.093 103.642Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M184.279 104.76L187.635 103.269C187.635 103.641 187.635 104.014 187.821 104.387L184.465 105.879C184.465 105.506 184.279 105.133 184.279 104.76Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M184.652 105.692L188.008 104.2C188.008 104.573 188.194 104.946 188.381 105.319L185.025 106.81C185.025 106.438 184.838 106.065 184.652 105.692Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M185.025 106.811L188.381 105.319C188.381 105.692 188.567 106.065 188.754 106.438L185.398 107.93C185.398 107.557 185.211 107.184 185.025 106.811Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M185.211 107.93L188.567 106.438C188.567 106.811 188.754 107.184 188.94 107.557L185.584 109.049C185.584 108.676 185.398 108.303 185.211 107.93Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M185.584 109.049L188.94 107.558C188.94 107.931 189.313 108.49 189.5 108.863L186.143 110.354C186.143 109.981 185.771 109.422 185.584 109.049Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M186.143 110.354L189.5 108.862C189.686 109.608 190.059 110.167 190.245 110.913L186.889 112.405C186.703 111.845 186.33 111.1 186.143 110.354Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M186.889 112.405L190.245 110.913C190.618 111.845 190.991 112.778 191.55 113.523L188.194 115.015C187.822 114.083 187.262 113.337 186.889 112.405Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M188.194 115.014L191.551 113.522C191.923 114.268 192.296 114.828 192.669 115.573L189.313 117.065C188.94 116.319 188.567 115.76 188.194 115.014Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M189.313 117.066L192.669 115.574C192.856 115.947 193.228 116.506 193.415 116.879L190.059 118.371C189.872 117.998 189.499 117.439 189.313 117.066Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M190.059 118.371L193.415 116.88C193.601 117.253 193.788 117.626 194.161 117.999L190.805 119.49C190.618 119.117 190.432 118.744 190.059 118.371Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M190.618 119.491L193.974 117.999C194.161 118.372 194.347 118.745 194.72 119.118L191.364 120.609C191.178 120.236 190.991 119.864 190.618 119.491Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M191.364 120.609L194.72 119.117C194.907 119.49 195.093 119.863 195.466 120.049L192.11 121.541C191.923 121.168 191.551 120.795 191.364 120.609Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M192.11 121.54L195.466 120.049C195.652 120.422 196.025 120.795 196.212 120.981L192.856 122.473C192.669 122.1 192.296 121.727 192.11 121.54Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M192.856 122.66L196.212 121.168C196.398 121.541 196.771 121.914 196.958 122.1L193.601 123.592C193.415 123.219 193.042 123.032 192.856 122.66Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.601 123.592L196.957 122.101C197.144 122.473 197.517 122.846 197.703 123.033L194.347 124.524C194.161 124.152 193.788 123.965 193.601 123.592Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M194.347 124.524L197.703 123.032C197.89 123.405 198.263 123.592 198.449 123.964L195.093 125.456C194.907 125.083 194.534 124.897 194.347 124.524Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M195.279 125.456L198.635 123.965C198.822 124.338 199.195 124.524 199.381 124.897L196.025 126.389C195.652 126.016 195.466 125.829 195.279 125.456Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M196.025 126.388L199.381 124.896C199.568 125.083 199.941 125.456 200.127 125.642L196.771 127.134C196.585 126.947 196.212 126.575 196.025 126.388Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M196.958 127.133L200.314 125.642C200.5 125.828 200.873 126.201 201.059 126.387L197.703 127.879C197.517 127.693 197.144 127.32 196.958 127.133Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.703 127.88L201.059 126.389C201.246 126.575 201.619 126.948 201.805 127.134L198.449 128.626C198.263 128.44 197.89 128.253 197.703 127.88Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M198.449 128.626L201.805 127.135C201.992 127.321 202.365 127.508 202.551 127.881L199.195 129.372C199.008 129.186 198.636 128.999 198.449 128.626Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.381 129.371L202.737 127.88C202.737 127.88 202.737 127.88 202.924 127.88L199.568 129.371C199.568 129.371 199.568 129.371 199.381 129.371Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M186.703 89.2849C185.025 102.523 192.11 119.862 202.924 128.066L199.568 129.558C188.94 121.354 181.669 104.014 183.347 90.7765C184.279 84.2508 187.076 79.7761 191.178 78.098L194.534 76.6064C190.432 78.2845 187.635 82.5728 186.703 89.2849Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M181.482 85.3686C180.177 95.8097 183.16 108.302 188.94 118.743C187.821 119.302 186.703 119.675 185.584 120.234C179.804 109.793 176.821 97.3013 178.126 86.8601C179.245 78.47 182.974 73.063 188.008 70.8256L191.364 69.334C186.33 71.3849 182.601 76.9784 181.482 85.3686Z"
      fill="white"
    />
    <mask
      id="mask23_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="177"
      y="69"
      width="15"
      height="52"
    >
      <path
        d="M181.482 85.3686C180.177 95.8097 183.16 108.302 188.94 118.743C187.821 119.302 186.703 119.675 185.584 120.234C179.804 109.793 176.821 97.3013 178.126 86.8601C179.245 78.47 182.974 73.063 188.008 70.8256L191.364 69.334C186.33 71.3849 182.601 76.9784 181.482 85.3686Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask23_918_8688)">
      <path
        d="M188.194 70.8256L191.55 69.334C189.686 70.0798 187.821 71.3849 186.33 73.2494L182.974 74.741C184.465 73.063 186.143 71.7578 188.194 70.8256Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M182.974 74.7416L186.33 73.25C185.957 73.8093 185.398 74.3687 185.025 74.928L181.669 76.4196C182.042 75.8603 182.414 75.3009 182.974 74.7416Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M181.669 76.4193L185.025 74.9277C184.652 75.3006 184.465 75.86 184.279 76.4193L180.923 77.9109C181.109 77.3516 181.482 76.9787 181.669 76.4193Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M180.923 77.724L184.279 76.2324C184.092 76.6053 183.906 77.1647 183.72 77.5376L180.364 79.0291C180.55 78.6563 180.736 78.0969 180.923 77.724Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M180.364 79.0297L183.72 77.5381C183.72 77.911 183.347 78.4703 183.16 78.8432L179.804 80.3348C179.804 79.9619 180.177 79.4026 180.364 79.0297Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M179.804 80.3353L183.16 78.8438C183.16 79.2166 182.787 79.5895 182.787 80.1489L179.431 81.6405C179.431 81.2676 179.618 80.7082 179.804 80.3353Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M179.245 81.64L182.601 80.1484C182.601 80.5213 182.414 80.8942 182.228 81.4536L178.872 82.9452C178.872 82.5723 179.058 82.1994 179.245 81.64Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M179.058 82.9447L182.415 81.4531C182.415 81.826 182.228 82.1989 182.042 82.7583L178.686 84.2499C178.686 83.877 178.872 83.3176 179.058 82.9447Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M178.685 84.0639L182.042 82.5723C182.042 82.9452 182.042 83.3181 181.855 83.8774L178.499 85.369C178.499 84.9961 178.499 84.6232 178.685 84.0639Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M178.499 85.3685L181.855 83.877C181.855 84.2499 181.855 84.8092 181.669 85.1821L178.313 86.6737C178.313 86.3008 178.313 85.7414 178.499 85.3685Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M178.313 86.6742L181.669 85.1826C181.669 85.5555 181.669 85.9284 181.669 86.3013L178.313 87.7929C178.313 87.42 178.313 87.0471 178.313 86.6742Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M178.126 87.9789L181.482 86.4873C181.482 86.8602 181.482 87.4195 181.482 87.7924L178.126 89.284C178.126 88.9111 178.126 88.3518 178.126 87.9789Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M177.94 89.2836L181.296 87.792C181.296 88.1649 181.296 88.7242 181.296 89.0971L177.94 90.5887C177.94 90.2158 177.94 89.6565 177.94 89.2836Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M177.94 90.5892L181.296 89.0977C181.296 89.4706 181.296 90.0299 181.296 90.4028L177.94 91.8944C177.94 91.5215 177.94 90.9621 177.94 90.5892Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M177.94 91.8949L181.296 90.4033C181.296 90.7762 181.296 91.3356 181.296 91.7085L177.94 93.2C177.94 92.8272 177.94 92.2678 177.94 91.8949Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M177.94 93.1996L181.296 91.708C181.296 92.0809 181.296 92.6403 181.296 93.0131L177.94 94.5047C177.94 94.1318 177.94 93.5725 177.94 93.1996Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M177.94 94.5053L181.296 93.0137C181.296 93.573 181.296 93.9459 181.296 94.5053L177.94 95.9968C177.94 95.4375 177.94 95.0646 177.94 94.5053Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M178.126 95.9965L181.482 94.5049C181.482 95.0642 181.482 95.4371 181.482 95.9965L178.126 97.4881C178.126 96.9287 178.126 96.5558 178.126 95.9965Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M178.313 97.3012L181.669 95.8096C181.669 96.3689 181.669 96.7418 181.855 97.3012L178.499 98.7927C178.499 98.2334 178.499 97.8605 178.313 97.3012Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M178.499 98.7933L181.855 97.3018C181.855 97.8611 181.855 98.234 182.042 98.7933L178.685 100.285C178.685 99.7256 178.685 99.3527 178.499 98.7933Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M178.686 100.284L182.042 98.792C182.042 99.3513 182.042 99.7242 182.228 100.284L178.872 101.775C178.872 101.216 178.872 100.843 178.686 100.284Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M178.872 101.777L182.228 100.285C182.228 100.845 182.414 101.217 182.601 101.777L179.245 103.268C179.245 102.709 179.058 102.336 178.872 101.777Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M179.245 103.081L182.601 101.59C182.601 101.963 182.787 102.522 182.974 102.895L179.618 104.387C179.618 104.014 179.431 103.454 179.245 103.081Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M179.431 104.386L182.787 102.895C182.787 103.267 182.974 103.827 183.16 104.2L179.804 105.691C179.804 105.318 179.618 104.759 179.431 104.386Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M179.804 105.878L183.16 104.387C183.16 104.76 183.347 105.319 183.533 105.692L180.177 107.183C180.177 106.811 179.991 106.251 179.804 105.878Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M180.177 107.184L183.533 105.692C183.533 106.065 183.72 106.625 183.906 106.998L180.55 108.489C180.55 108.116 180.177 107.557 180.177 107.184Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M180.736 108.489L184.093 106.997C184.093 107.556 184.465 107.929 184.652 108.489L181.296 109.98C181.296 109.421 180.923 109.048 180.736 108.489Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M181.109 109.98L184.465 108.488C184.652 109.048 184.838 109.607 185.025 110.166L181.669 111.658C181.482 111.099 181.296 110.539 181.109 109.98Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M181.855 111.658L185.211 110.166C185.584 110.912 185.771 111.844 186.143 112.59L182.787 114.081C182.414 113.336 182.042 112.403 181.855 111.658Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M182.787 114.082L186.143 112.591C186.703 113.71 187.076 114.828 187.635 115.947L184.279 117.438C183.72 116.32 183.16 115.201 182.787 114.082Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M184.279 117.624L187.635 116.133C188.008 117.065 188.567 117.811 188.94 118.743L185.584 120.235C185.025 119.302 184.652 118.557 184.279 117.624Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M181.482 85.3686C180.177 95.8097 183.16 108.302 188.94 118.743C187.821 119.302 186.703 119.675 185.584 120.234C179.804 109.793 176.821 97.3013 178.126 86.8601C179.245 78.47 182.974 73.063 188.008 70.8256L191.364 69.334C186.33 71.3849 182.601 76.9784 181.482 85.3686Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M199.568 97.8609L202.924 96.3693C204.042 95.8099 205.534 96.1828 207.026 97.3015L203.67 98.7931C202.178 97.6744 200.686 97.3015 199.568 97.8609Z"
      fill="white"
    />
    <mask
      id="mask24_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="199"
      y="96"
      width="9"
      height="3"
    >
      <path
        d="M199.568 97.8609L202.924 96.3693C204.042 95.8099 205.534 96.1828 207.026 97.3015L203.67 98.7931C202.178 97.6744 200.686 97.3015 199.568 97.8609Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask24_918_8688)">
      <path
        d="M199.568 97.8598L202.924 96.3682C202.924 96.3682 203.297 96.3682 203.483 96.3682L200.127 97.8598C200.127 97.8598 199.754 97.8598 199.568 97.8598Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.941 97.6732L203.297 96.1816C203.297 96.1816 203.483 96.1816 203.67 96.1816L200.313 97.6732H199.941Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.5 97.6732L203.856 96.1816C203.856 96.1816 204.042 96.1816 204.229 96.1816L200.873 97.6732C200.873 97.6732 200.686 97.6732 200.5 97.6732Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.686 97.6732L204.042 96.1816C204.042 96.1816 204.229 96.1816 204.415 96.1816L201.059 97.6732C201.059 97.6732 200.873 97.6732 200.686 97.6732Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.059 97.6732L204.415 96.1816C204.415 96.1816 204.415 96.1816 204.602 96.1816L201.246 97.6732C201.246 97.6732 201.246 97.6732 201.059 97.6732Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.432 97.6732L204.788 96.1816C204.788 96.1816 204.788 96.1816 204.975 96.1816L201.619 97.6732C201.619 97.6732 201.619 97.6732 201.432 97.6732Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.619 97.8598L204.975 96.3682C204.975 96.3682 204.975 96.3682 205.161 96.3682L201.805 97.8598C201.805 97.8598 201.805 97.8598 201.619 97.8598Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.805 97.8598L205.161 96.3682C205.161 96.3682 205.161 96.3682 205.348 96.3682L201.991 97.8598C201.991 97.8598 201.992 97.8598 201.805 97.8598Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.991 97.8598L205.348 96.3682C205.348 96.3682 205.348 96.3682 205.534 96.3682L202.178 97.8598C202.178 97.8598 202.178 97.8598 201.991 97.8598Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.364 98.0473L205.72 96.5557C205.72 96.5557 205.72 96.5557 205.907 96.5557L202.551 98.0473C202.551 98.0473 202.551 98.0473 202.364 98.0473Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.551 98.2318L205.907 96.7402C205.907 96.7402 205.907 96.7402 206.093 96.7402L202.737 98.2318C202.737 98.2318 202.737 98.2318 202.551 98.2318Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.737 98.2318L206.093 96.7402C206.093 96.7402 206.093 96.7402 206.28 96.7402L202.924 98.2318C202.924 98.2318 202.924 98.2318 202.737 98.2318Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.924 98.4183L206.28 96.9268C206.28 96.9268 206.28 96.9268 206.466 96.9268L203.11 98.4183C203.11 98.4183 203.11 98.4183 202.924 98.4183Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.11 98.6059L206.466 97.1143C206.466 97.1143 206.466 97.1143 206.653 97.1143L203.297 98.6059C203.297 98.6059 203.297 98.6059 203.11 98.6059Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.483 98.6059L206.839 97.1143"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M199.568 97.8609L202.924 96.3693C204.042 95.8099 205.534 96.1828 207.026 97.3015L203.67 98.7931C202.178 97.6744 200.686 97.3015 199.568 97.8609Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M209.263 111.472L205.907 112.963C207.026 112.404 207.771 111.285 208.144 109.421C208.704 105.692 206.653 101.031 203.669 98.7933L207.026 97.3018C210.009 99.5391 211.873 104.387 211.5 107.929C211.314 109.794 210.382 110.912 209.263 111.472Z"
      fill="white"
    />
    <mask
      id="mask25_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="203"
      y="97"
      width="9"
      height="16"
    >
      <path
        d="M209.263 111.472L205.907 112.963C207.026 112.404 207.771 111.285 208.144 109.421C208.704 105.692 206.653 101.031 203.669 98.7933L207.026 97.3018C210.009 99.5391 211.873 104.387 211.5 107.929C211.314 109.794 210.382 110.912 209.263 111.472Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask25_918_8688)">
      <path
        d="M203.483 98.7933L206.839 97.3018"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.67 98.7933L207.026 97.3018C207.026 97.3018 207.026 97.3018 207.212 97.3018L203.856 98.7933C203.856 98.7933 203.856 98.7933 203.67 98.7933Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.856 98.9799L207.212 97.4883C207.212 97.4883 207.212 97.4883 207.399 97.6747L204.043 99.1663C204.043 99.1663 204.043 99.1663 203.856 98.9799Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.042 99.1664L207.399 97.6748C207.399 97.6748 207.399 97.6748 207.585 97.8613L204.229 99.3528C204.229 99.3528 204.229 99.3528 204.042 99.1664Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.229 99.3519L207.585 97.8604C207.585 97.8604 207.585 97.8603 207.772 98.0468L204.415 99.5384C204.415 99.5384 204.415 99.5384 204.229 99.3519Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.602 99.725L207.958 98.2334C207.958 98.2334 207.958 98.2334 208.144 98.4198L204.788 99.9114C204.788 99.9114 204.788 99.9114 204.602 99.725Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.788 99.9125L208.144 98.4209C208.144 98.4209 208.144 98.4209 208.331 98.6074L204.975 100.099C204.975 100.099 204.975 100.099 204.788 99.9125Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.975 100.099L208.331 98.6074C208.331 98.6074 208.331 98.6074 208.517 98.7939L205.161 100.285C205.161 100.285 205.161 100.285 204.975 100.099Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M205.161 100.471L208.517 98.9795C208.517 98.9795 208.517 98.9795 208.704 99.1659L205.348 100.658C205.348 100.658 205.348 100.658 205.161 100.471Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M205.348 100.658L208.704 99.166C208.704 99.166 208.704 99.166 208.89 99.3525L205.534 100.844C205.534 100.844 205.534 100.844 205.348 100.658Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M205.534 101.032L208.89 99.54C208.89 99.54 208.89 99.54 209.077 99.7265L205.721 101.218C205.721 101.218 205.721 101.218 205.534 101.032Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M205.721 101.216L209.077 99.7246C209.077 99.7246 209.077 99.9111 209.263 100.098L205.907 101.589C205.907 101.589 205.907 101.403 205.721 101.216Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M206.094 101.59L209.45 100.099C209.45 100.099 209.45 100.285 209.45 100.472L206.094 101.963C206.094 101.963 206.094 101.777 206.094 101.59Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M206.094 101.777L209.45 100.285C209.45 100.285 209.45 100.472 209.636 100.658L206.28 102.15C206.28 102.15 206.28 101.963 206.094 101.777Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M206.466 102.149L209.822 100.657C209.822 100.657 210.009 101.03 210.195 101.217L206.839 102.708C206.839 102.522 206.653 102.335 206.466 102.149Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M206.653 102.708L210.009 101.217C210.009 101.403 210.195 101.776 210.382 101.963L207.026 103.454C207.026 103.268 206.839 102.895 206.653 102.708Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.026 103.454L210.382 101.963C210.382 101.963 210.382 102.336 210.568 102.522L207.212 104.014C207.212 104.014 207.212 103.641 207.026 103.454Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.212 104.013L210.568 102.521C210.568 102.521 210.568 102.708 210.568 102.894L207.212 104.386C207.212 104.386 207.212 104.2 207.212 104.013Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.399 104.386L210.755 102.895C210.755 102.895 210.755 103.081 210.755 103.267L207.399 104.759C207.399 104.759 207.399 104.573 207.399 104.386Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.585 104.76L210.941 103.269C210.941 103.269 210.941 103.455 210.941 103.641L207.585 105.133C207.585 105.133 207.585 104.947 207.585 104.76Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.585 104.946L210.941 103.454C210.941 103.454 210.941 103.641 210.941 103.827L207.585 105.319C207.585 105.319 207.585 105.132 207.585 104.946Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.585 105.319L210.941 103.827C210.941 103.827 210.941 104.014 210.941 104.2L207.585 105.692C207.585 105.692 207.585 105.505 207.585 105.319Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.771 105.692L211.128 104.2C211.128 104.2 211.128 104.387 211.128 104.573L207.771 106.065C207.771 106.065 207.771 105.878 207.771 105.692Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.771 105.878L211.128 104.387C211.128 104.387 211.128 104.573 211.128 104.76L207.771 106.251C207.771 106.251 207.771 106.065 207.771 105.878Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.958 106.251L211.314 104.76C211.314 104.76 211.314 104.946 211.314 105.133L207.958 106.624C207.958 106.624 207.958 106.438 207.958 106.251Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.958 106.437L211.314 104.945C211.314 104.945 211.314 105.132 211.314 105.318L207.958 106.81C207.958 106.81 207.958 106.623 207.958 106.437Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.958 106.81L211.314 105.318C211.314 105.318 211.314 105.505 211.314 105.691L207.958 107.183C207.958 107.183 207.958 106.996 207.958 106.81Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.958 107.184L211.314 105.692C211.314 105.692 211.314 105.879 211.314 106.065L207.958 107.557C207.958 107.557 207.958 107.37 207.958 107.184Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M208.144 107.556L211.5 106.064C211.5 106.064 211.5 106.251 211.5 106.437L208.144 107.929C208.144 107.929 208.144 107.742 208.144 107.556Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M208.144 107.743L211.5 106.251C211.5 106.251 211.5 106.437 211.5 106.624L208.144 108.115C208.144 108.115 208.144 107.929 208.144 107.743Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M208.144 108.116L211.5 106.624C211.5 106.624 211.5 106.81 211.5 106.997L208.144 108.489C208.144 108.489 208.144 108.302 208.144 108.116Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M208.144 108.302L211.5 106.811C211.5 106.811 211.5 106.997 211.5 107.183L208.144 108.675C208.144 108.675 208.144 108.489 208.144 108.302Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M208.144 108.674L211.5 107.183C211.5 107.183 211.5 107.369 211.5 107.556L208.144 109.047C208.144 109.047 208.144 108.861 208.144 108.674Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M208.144 108.861L211.5 107.369C211.5 107.369 211.5 107.556 211.5 107.742L208.144 109.234C208.144 109.234 208.144 109.234 208.144 108.861Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M208.144 109.235L211.5 107.743C211.5 107.743 211.5 107.743 211.5 107.93L208.144 109.421C208.144 109.421 208.144 109.421 208.144 109.235Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.958 109.42L211.314 107.929C211.314 107.929 211.314 107.929 211.314 108.115L207.958 109.607C207.958 109.607 207.958 109.607 207.958 109.42Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.958 109.793L211.314 108.302C211.314 108.302 211.314 108.302 211.314 108.488L207.958 109.98C207.958 109.98 207.958 109.98 207.958 109.793Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.958 109.98L211.314 108.488C211.314 108.488 211.314 108.488 211.314 108.675L207.958 110.166C207.958 110.166 207.958 110.166 207.958 109.98Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.771 110.354L211.128 108.862C211.128 108.862 211.128 108.862 211.128 109.049L207.771 110.54C207.771 110.54 207.771 110.54 207.771 110.354Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.771 110.538L211.128 109.047C211.128 109.047 211.128 109.047 211.128 109.233L207.771 110.725C207.771 110.725 207.771 110.725 207.771 110.538Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.771 110.912L211.128 109.421C211.128 109.421 211.128 109.607 211.128 109.794L207.771 111.285C207.771 111.285 207.771 111.285 207.771 110.912Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.585 111.099L210.941 109.607C210.941 109.607 210.941 109.794 210.941 109.98L207.585 111.472C207.585 111.472 207.585 111.285 207.585 111.099Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.399 111.471L210.755 109.979C210.755 109.979 210.755 110.166 210.755 110.352L207.399 111.844C207.399 111.844 207.399 111.658 207.399 111.471Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.212 111.658L210.568 110.166C210.568 110.166 210.568 110.352 210.382 110.539L207.026 112.031C207.026 112.031 207.026 111.844 207.212 111.658Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.026 112.032L210.382 110.54C210.009 110.913 209.636 111.286 209.263 111.472L205.907 112.964C206.28 112.964 206.653 112.591 207.026 112.032Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M209.263 111.472L205.907 112.963C207.026 112.404 207.771 111.285 208.144 109.421C208.704 105.692 206.653 101.031 203.669 98.7933L207.026 97.3018C210.009 99.5391 211.873 104.387 211.5 107.929C211.314 109.794 210.382 110.912 209.263 111.472Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M196.771 91.5213L200.127 90.0298C202.178 89.0975 204.788 89.6569 207.585 91.7078L204.229 93.1994C201.432 91.1485 198.822 90.5891 196.771 91.5213Z"
      fill="white"
    />
    <mask
      id="mask26_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="196"
      y="89"
      width="12"
      height="5"
    >
      <path
        d="M196.771 91.5213L200.127 90.0298C202.178 89.0975 204.788 89.6569 207.585 91.7078L204.229 93.1994C201.432 91.1485 198.822 90.5891 196.771 91.5213Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask26_918_8688)">
      <path
        d="M196.771 91.5217L200.127 90.0301C200.5 90.0301 200.686 89.8437 201.059 89.6572L197.703 91.1488C197.33 91.1488 197.144 91.1488 196.771 91.5217Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.703 91.3353L201.059 89.8438C201.246 89.8438 201.619 89.8438 201.805 89.8438L198.449 91.3353C198.263 91.3353 197.89 91.3353 197.703 91.3353Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M198.449 91.1488L201.805 89.6572C201.992 89.6572 202.178 89.6572 202.365 89.6572L199.008 91.1488C198.822 91.1488 198.636 91.1488 198.449 91.1488Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.195 91.1488L202.551 89.6572C202.551 89.6572 202.924 89.6572 203.11 89.6572L199.754 91.1488C199.568 91.1488 199.381 91.1488 199.195 91.1488Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.754 91.1488L203.11 89.6572C203.11 89.6572 203.483 89.6572 203.67 89.6572L200.314 91.1488C200.314 91.1488 199.941 91.1488 199.754 91.1488Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.127 91.3353L203.483 89.8438H203.856L200.5 91.3353H200.127Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.686 91.3353L204.042 89.8438H204.415L201.059 91.3353H200.686Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.059 91.5219L204.415 90.0303H204.788L201.432 91.5219H201.059Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.619 91.7074L204.975 90.2158H205.348L201.992 91.7074H201.619Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.992 91.8939L205.348 90.4023C205.348 90.4023 205.534 90.4023 205.72 90.5888L202.364 92.0804C202.364 92.0804 202.178 92.0804 201.992 91.8939Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.365 92.0814L205.721 90.5898C205.721 90.5898 205.907 90.5898 206.093 90.7763L202.737 92.2679C202.737 92.2679 202.551 92.2679 202.365 92.0814Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.737 92.268L206.093 90.7764C206.093 90.7764 206.28 90.7764 206.466 90.9628L203.11 92.4544C203.11 92.4544 202.924 92.4544 202.737 92.268Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.11 92.4545L206.466 90.9629C206.466 90.9629 206.653 90.9629 206.839 91.1493L203.483 92.6409C203.483 92.6409 203.297 92.6409 203.11 92.4545Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.67 92.639L207.026 91.1475C207.026 91.1475 207.212 91.1475 207.399 91.5204L204.043 93.0119C204.043 93.0119 203.856 92.8255 203.67 92.639Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.043 93.0131L207.399 91.5215C207.399 91.5215 207.585 91.5215 207.772 91.7079L204.415 93.1995C204.415 93.1995 204.229 93.1995 204.043 93.0131Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M196.771 91.5213L200.127 90.0298C202.178 89.0975 204.788 89.6569 207.585 91.7078L204.229 93.1994C201.432 91.1485 198.822 90.5891 196.771 91.5213Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M204.229 93.1997C209.636 97.3015 213.365 106.065 212.433 112.777C211.5 119.489 206.466 121.54 201.059 117.438C195.652 113.336 191.923 104.573 192.856 97.8609C193.788 91.1487 198.822 89.0978 204.229 93.1997ZM201.805 112.031C204.788 114.268 207.585 113.15 207.958 109.421C208.517 105.692 206.466 101.031 203.483 98.7931C200.5 96.5557 197.703 97.6744 197.33 101.403C196.771 105.132 198.822 109.794 201.805 112.031Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M193.974 84.6235L197.33 83.1319C200.5 81.8268 204.415 82.5726 208.517 85.7422L205.161 87.2338C201.059 84.0641 197.144 83.3183 193.974 84.6235Z"
      fill="white"
    />
    <mask
      id="mask27_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="193"
      y="82"
      width="16"
      height="6"
    >
      <path
        d="M193.974 84.6235L197.33 83.1319C200.5 81.8268 204.415 82.5726 208.517 85.7422L205.161 87.2338C201.059 84.0641 197.144 83.3183 193.974 84.6235Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask27_918_8688)">
      <path
        d="M193.974 84.6233L197.33 83.1317C197.703 83.1317 198.263 82.7588 198.635 82.7588L195.279 84.2504C194.72 84.2504 194.347 84.4368 193.974 84.6233Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M195.279 84.2504L198.635 82.7588C199.008 82.7588 199.381 82.7588 199.754 82.7588L196.398 84.2504C196.025 84.2504 195.652 84.2504 195.279 84.2504Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M196.398 84.0639L199.754 82.5723C200.127 82.5723 200.313 82.5723 200.686 82.5723L197.33 84.0639C196.957 84.0639 196.771 84.0639 196.398 84.0639Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.33 84.0639L200.686 82.5723C200.873 82.5723 201.246 82.5723 201.432 82.5723L198.076 84.0639C197.89 84.0639 197.517 84.0639 197.33 84.0639Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M198.263 84.0639L201.619 82.5723C201.805 82.5723 202.178 82.5723 202.364 82.5723L199.008 84.0639C198.822 84.0639 198.449 84.0639 198.263 84.0639Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.008 84.2504L202.364 82.7588C202.551 82.7588 202.737 82.7588 203.11 82.7588L199.754 84.2504C199.568 84.2504 199.381 84.2504 199.008 84.2504Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.754 84.4369L203.11 82.9453C203.297 82.9453 203.483 82.9453 203.856 83.1318L200.5 84.6234C200.313 84.6234 200.127 84.6233 199.754 84.4369Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.314 84.6234L203.67 83.1318C203.856 83.1318 204.043 83.1318 204.229 83.3183L200.873 84.8099C200.686 84.8099 200.5 84.8099 200.314 84.6234Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.059 84.8099L204.415 83.3184C204.602 83.3184 204.788 83.3184 204.975 83.5048L201.619 84.9964C201.432 84.9964 201.246 84.9964 201.059 84.8099Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.619 85.183L204.975 83.6914C205.161 83.6914 205.348 83.8778 205.534 84.0643L202.178 85.5559C201.991 85.5559 201.805 85.3694 201.619 85.183Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.178 85.3695L205.534 83.8779C205.721 83.8779 205.907 84.0644 206.093 84.2508L202.737 85.7424C202.551 85.7424 202.364 85.556 202.178 85.3695Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.737 85.7426L206.093 84.251C206.28 84.251 206.466 84.4374 206.653 84.6239L203.297 86.1155C203.11 86.1155 202.924 85.929 202.737 85.7426Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.483 86.1146L206.839 84.623C207.026 84.623 207.212 84.8095 207.399 84.9959L204.042 86.4875C203.856 86.4875 203.67 86.3011 203.483 86.1146Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.042 86.4877L207.399 84.9961C207.585 84.9961 207.771 85.1825 207.958 85.369L204.602 86.8606C204.415 86.8606 204.229 86.4877 204.042 86.4877Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.602 86.8598L207.958 85.3682C207.958 85.3682 208.331 85.5546 208.517 85.7411L205.161 87.2326C205.161 87.2326 204.788 87.0462 204.602 86.8598Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M193.974 84.6235L197.33 83.1319C200.5 81.8268 204.415 82.5726 208.517 85.7422L205.161 87.2338C201.059 84.0641 197.144 83.3183 193.974 84.6235Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M211.873 117.998L208.517 119.49C210.568 118.558 212.06 116.507 212.433 113.151C213.365 106.439 209.636 97.6755 204.229 93.5736L207.585 92.082C212.992 96.1839 216.721 104.947 215.789 111.659C215.416 115.015 213.924 117.253 211.873 117.998Z"
      fill="white"
    />
    <mask
      id="mask28_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="204"
      y="92"
      width="12"
      height="28"
    >
      <path
        d="M211.873 117.999L208.517 119.491C210.568 118.559 212.06 116.508 212.433 113.152C213.365 106.44 209.636 97.6765 204.229 93.5746L207.585 92.083C212.992 96.1849 216.721 104.948 215.789 111.66C215.416 115.016 213.924 117.254 211.873 117.999Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask28_918_8688)">
      <path
        d="M204.229 93.2006L207.585 91.709"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.415 93.3871L207.771 91.8955C207.771 91.8955 207.958 92.082 208.144 92.2684L204.788 93.76C204.788 93.76 204.602 93.5735 204.415 93.3871Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.788 93.5726L208.144 92.0811C208.144 92.0811 208.331 92.2675 208.517 92.4539L205.161 93.9455C205.161 93.9455 204.975 93.7591 204.788 93.5726Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M205.161 93.9457L208.517 92.4541C208.517 92.4541 208.89 92.6406 208.89 92.827L205.534 94.3186C205.534 94.3186 205.348 94.1321 205.161 93.9457Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M205.72 94.3197L209.076 92.8281C209.076 92.8281 209.449 93.0146 209.449 93.201L206.093 94.6926C206.093 94.6926 205.907 94.5062 205.72 94.3197Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M206.093 94.8783L209.449 93.3867L209.822 93.7596L206.466 95.2512C206.466 95.2512 206.28 94.8783 206.093 94.8783Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M206.466 95.2514L209.822 93.7598C209.822 93.7598 210.195 94.1327 210.195 94.3191L206.839 95.8107C206.839 95.8107 206.653 95.4378 206.466 95.2514Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M206.839 95.81L210.195 94.3184C210.195 94.3184 210.382 94.6913 210.568 94.8777L207.212 96.3693C207.212 96.3693 207.026 95.9964 206.839 95.81Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.398 96.184L210.755 94.6924C210.755 94.6924 210.941 95.0653 211.127 95.2517L207.771 96.7433C207.771 96.7433 207.585 96.3704 207.398 96.184Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.771 96.7426L211.128 95.251C211.128 95.251 211.314 95.6239 211.5 95.8103L208.144 97.3019C208.144 97.3019 207.958 96.929 207.771 96.7426Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M208.144 97.3021L211.5 95.8105C211.5 95.8105 211.687 96.1834 211.873 96.3699L208.517 97.8615C208.517 97.8615 208.331 97.4886 208.144 97.3021Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M208.517 97.6742L211.873 96.1826C211.873 96.1826 212.06 96.5555 212.246 96.742L208.89 98.2336C208.89 98.2336 208.704 97.8607 208.517 97.6742Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M208.704 98.2348L212.06 96.7432C212.06 96.7432 212.246 97.1161 212.433 97.3025L209.077 98.7941C209.077 98.6076 208.89 98.4212 208.704 98.2348Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M209.076 98.7933L212.433 97.3018C212.433 97.4882 212.619 97.6747 212.805 98.0475L209.449 99.5391C209.449 99.3527 209.263 99.1662 209.076 98.7933Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M209.449 99.5394L212.805 98.0479C212.992 98.4207 213.178 98.7936 213.365 99.1665L210.009 100.658C210.009 100.285 209.636 99.9123 209.449 99.5394Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M210.009 100.472L213.365 98.9805C213.551 99.3534 213.738 99.9127 213.924 100.286L210.568 101.777C210.382 101.404 210.195 100.845 210.009 100.472Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M210.755 101.963L214.111 100.472C214.111 100.845 214.297 101.217 214.484 101.404L211.127 102.896C211.127 102.523 210.941 102.15 210.755 101.963Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M211.128 102.896L214.484 101.404C214.484 101.591 214.484 101.777 214.67 102.15L211.314 103.642C211.314 103.455 211.314 103.269 211.128 102.896Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M211.314 103.642L214.67 102.15C214.67 102.337 214.67 102.523 214.856 102.71L211.5 104.201C211.5 104.015 211.5 103.828 211.314 103.642Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M211.5 104.201L214.856 102.709C214.856 102.709 214.856 103.082 214.856 103.268L211.5 104.76C211.5 104.76 211.5 104.387 211.5 104.201Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M211.687 104.761L215.043 103.27C215.043 103.27 215.043 103.642 215.043 103.829L211.687 105.32C211.687 105.32 211.687 104.948 211.687 104.761Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M211.873 105.32L215.229 103.828C215.229 103.828 215.229 104.201 215.229 104.387L211.873 105.879C211.873 105.879 211.873 105.506 211.873 105.32Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.06 105.878L215.416 104.387C215.416 104.387 215.416 104.76 215.416 104.946L212.06 106.438C212.06 106.438 212.06 106.065 212.06 105.878Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.06 106.251L215.416 104.76C215.416 104.946 215.416 105.133 215.416 105.319L212.06 106.811C212.06 106.624 212.06 106.438 212.06 106.251Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.246 106.811L215.602 105.319C215.602 105.506 215.602 105.692 215.602 105.879L212.246 107.37C212.246 107.184 212.246 106.997 212.246 106.811Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.433 107.557L215.789 106.065C215.789 106.252 215.789 106.438 215.789 106.625L212.433 108.116C212.433 107.93 212.433 107.743 212.433 107.557Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.433 108.116L215.789 106.624C215.789 106.81 215.789 106.997 215.789 107.183L212.433 108.675C212.433 108.489 212.433 108.302 212.433 108.116Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.433 108.675L215.789 107.184C215.789 107.37 215.789 107.556 215.789 107.743L212.433 109.235C212.433 109.048 212.433 108.862 212.433 108.675Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.619 109.235L215.975 107.743C215.975 107.93 215.975 108.116 215.975 108.303L212.619 109.794C212.619 109.608 212.619 109.421 212.619 109.235Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.619 109.794L215.975 108.303C215.975 108.303 215.975 108.676 215.975 108.862L212.619 110.354C212.619 110.354 212.619 109.981 212.619 109.794Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.619 110.354L215.975 108.862C215.975 108.862 215.975 109.235 215.975 109.422L212.619 110.913C212.619 110.913 212.619 110.54 212.619 110.354Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.619 110.913L215.975 109.422C215.975 109.422 215.975 109.795 215.975 109.981L212.619 111.473C212.619 111.473 212.619 111.1 212.619 110.913Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.619 111.472L215.975 109.98C215.975 109.98 215.975 110.353 215.975 110.54L212.619 112.031C212.619 112.031 212.619 111.659 212.619 111.472Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.619 111.845L215.975 110.354C215.975 110.354 215.975 110.726 215.975 110.913L212.619 112.404C212.619 112.404 212.619 112.032 212.619 111.845Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.619 112.404L215.975 110.912C215.975 110.912 215.975 111.285 215.975 111.471L212.619 112.963C212.619 112.963 212.619 112.59 212.619 112.404Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.433 112.963L215.789 111.472C215.789 111.472 215.789 111.845 215.789 112.031L212.433 113.523C212.433 113.523 212.433 113.15 212.433 112.963Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.433 113.523L215.789 112.031C215.789 112.031 215.789 112.404 215.789 112.591L212.433 114.082C212.433 114.082 212.433 113.709 212.433 113.523Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.246 113.897L215.602 112.405C215.602 112.405 215.602 112.778 215.602 112.965L212.246 114.456C212.246 114.456 212.246 114.083 212.246 113.897Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.246 114.455L215.602 112.964C215.602 112.964 215.602 113.337 215.602 113.523L212.246 115.015C212.246 115.015 212.246 114.642 212.246 114.455Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.06 115.015L215.416 113.523C215.416 113.523 215.416 113.896 215.416 114.083L212.06 115.574C212.06 115.574 212.06 115.201 212.06 115.015Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M211.873 115.387L215.229 113.896C215.229 113.896 215.229 114.268 215.043 114.455L211.687 115.946C211.687 115.946 211.687 115.574 211.873 115.387Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M211.687 115.948L215.043 114.456C215.043 114.456 215.043 114.829 214.856 115.015L211.5 116.507C211.5 116.507 211.5 116.134 211.687 115.948Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M211.5 116.506L214.856 115.015C214.856 115.201 214.67 115.388 214.484 115.574L211.128 117.066C211.128 117.066 211.314 116.693 211.5 116.506Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M211.128 117.066L214.484 115.574C214.484 115.761 214.111 115.947 213.924 116.32L210.568 117.812C210.568 117.625 210.941 117.439 211.128 117.066Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M210.568 117.812L213.924 116.32C213.365 117.066 212.619 117.625 211.873 117.812L208.517 119.303C209.263 118.931 210.009 118.371 210.568 117.812Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M211.873 117.998L208.517 119.49C210.568 118.558 212.06 116.507 212.433 113.151C213.365 106.439 209.636 97.6755 204.229 93.5736L207.585 92.082C212.992 96.1839 216.721 104.947 215.789 111.659C215.416 115.015 213.924 117.253 211.873 117.998Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M214.67 124.71L211.314 126.202C214.297 124.896 216.534 121.727 217.28 116.693C218.585 106.624 213.178 93.573 204.975 87.2338L208.331 85.7422C216.348 91.895 221.941 105.133 220.636 115.201C219.891 120.235 217.84 123.405 214.67 124.71Z"
      fill="white"
    />
    <mask
      id="mask29_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="204"
      y="85"
      width="17"
      height="42"
    >
      <path
        d="M214.67 124.71L211.314 126.202C214.297 124.896 216.534 121.727 217.28 116.693C218.585 106.624 213.178 93.573 204.975 87.2338L208.331 85.7422C216.348 91.895 221.941 105.133 220.636 115.201C219.891 120.235 217.84 123.405 214.67 124.71Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask29_918_8688)">
      <path
        d="M205.161 87.2338L208.517 85.7422"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M205.161 87.4203L208.517 85.9287C208.704 85.9287 208.89 86.3016 209.076 86.4881L205.72 87.9796C205.534 87.9796 205.348 87.6068 205.161 87.4203Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M205.907 87.7933L209.263 86.3018C209.449 86.3018 209.636 86.6747 209.822 86.8611L206.466 88.3527C206.28 88.3527 206.093 87.9798 205.907 87.7933Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M206.466 88.3529L209.822 86.8613C210.009 87.0478 210.195 87.2342 210.382 87.4207L207.026 88.9123C206.839 88.7258 206.653 88.5394 206.466 88.3529Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.026 88.9115L210.382 87.4199C210.568 87.6064 210.755 87.7928 210.941 87.9793L207.585 89.4709C207.398 89.2844 207.212 89.098 207.026 88.9115Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.771 89.6576L211.127 88.166C211.314 88.3525 211.5 88.5389 211.687 88.9118L208.331 90.4034C208.144 90.217 207.958 90.0305 207.771 89.6576Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M208.331 90.2172L211.687 88.7256C211.873 88.912 212.06 89.0985 212.246 89.4714L208.89 90.963C208.704 90.7765 208.517 90.4036 208.331 90.2172Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M209.076 90.9623L212.433 89.4707C212.619 89.6572 212.805 90.0301 212.992 90.2165L209.636 91.7081C209.449 91.5216 209.263 91.1487 209.076 90.9623Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M209.636 91.7084L212.992 90.2168C213.178 90.4032 213.365 90.7761 213.551 90.9626L210.195 92.4542C210.009 92.2677 209.822 91.8948 209.636 91.7084Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M210.195 92.4545L213.551 90.9629C213.738 91.1493 213.924 91.5222 214.111 91.7087L210.755 93.2003C210.755 93.0138 210.382 92.6409 210.195 92.4545Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M210.755 93.2006L214.111 91.709C214.111 91.8954 214.484 92.2683 214.67 92.4548L211.314 93.9464C211.314 93.7599 210.941 93.387 210.755 93.2006Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M211.314 93.9467L214.67 92.4551C214.67 92.6415 215.043 93.0144 215.229 93.2009L211.873 94.6925C211.873 94.506 211.5 94.1331 211.314 93.9467Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M211.873 94.6918L215.229 93.2002C215.229 93.3866 215.602 93.7595 215.789 93.946L212.433 95.4376C212.433 95.0647 212.06 94.8782 211.873 94.6918Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.246 95.6244L215.602 94.1328C215.789 94.5057 215.975 94.8786 216.162 95.0651L212.805 96.5566C212.619 96.1837 212.433 95.8108 212.246 95.6244Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.805 96.556L216.161 95.0645C216.534 95.6238 216.721 96.1831 216.907 96.556L213.551 98.0476C213.365 97.4883 212.992 96.9289 212.805 96.556Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M213.738 98.2338L217.094 96.7422C217.467 97.488 217.653 98.0473 218.026 98.7931L214.67 100.285C214.297 99.5389 214.111 98.9796 213.738 98.2338Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M214.67 100.099L218.026 98.6074C218.212 99.1668 218.399 99.5397 218.585 100.099L215.229 101.591C215.043 101.031 214.856 100.658 214.67 100.099Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M215.229 101.59L218.585 100.099C218.585 100.472 218.772 100.844 218.958 101.031L215.602 102.522C215.602 102.15 215.416 101.777 215.229 101.59Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M215.602 102.708L218.958 101.217C218.958 101.59 219.145 101.776 219.331 102.149L215.975 103.641C215.975 103.268 215.789 103.081 215.602 102.708Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M215.975 103.641L219.331 102.149C219.331 102.336 219.331 102.709 219.518 102.895L216.162 104.387C216.162 104.2 216.162 103.827 215.975 103.641Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M216.162 104.387L219.518 102.896C219.518 103.082 219.518 103.455 219.704 103.641L216.348 105.133C216.348 104.946 216.348 104.574 216.162 104.387Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M216.348 105.133L219.704 103.642C219.704 103.828 219.704 104.201 219.891 104.387L216.534 105.879C216.534 105.693 216.534 105.32 216.348 105.133Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M216.534 106.066L219.891 104.574C219.891 104.761 219.89 105.134 220.077 105.32L216.721 106.812C216.721 106.625 216.721 106.252 216.534 106.066Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M216.721 106.811L220.077 105.319C220.077 105.692 220.077 105.879 220.077 106.252L216.721 107.743C216.721 107.37 216.721 107.184 216.721 106.811Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M216.907 107.556L220.263 106.064C220.263 106.437 220.263 106.624 220.263 106.997L216.907 108.488C216.907 108.115 216.907 107.929 216.907 107.556Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M217.094 108.489L220.45 106.997C220.45 107.37 220.45 107.556 220.45 107.929L217.094 109.421C217.094 109.048 217.094 108.862 217.094 108.489Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M217.28 109.42L220.636 107.929C220.636 108.302 220.636 108.488 220.636 108.861L217.28 110.353C217.28 109.98 217.28 109.793 217.28 109.42Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M217.28 110.167L220.636 108.676C220.636 109.049 220.636 109.235 220.636 109.608L217.28 111.1C217.28 110.727 217.28 110.54 217.28 110.167Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M217.467 111.099L220.823 109.607C220.823 109.98 220.823 110.167 220.823 110.54L217.467 112.031C217.467 111.658 217.467 111.472 217.467 111.099Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M217.467 111.845L220.823 110.354C220.823 110.54 220.823 110.913 220.823 111.099L217.467 112.591C217.467 112.404 217.467 112.032 217.467 111.845Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M217.467 112.778L220.823 111.286C220.823 111.473 220.823 111.845 220.823 112.032L217.467 113.524C217.467 113.337 217.467 112.964 217.467 112.778Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M217.467 113.523L220.823 112.031C220.823 112.218 220.823 112.591 220.823 112.777L217.467 114.269C217.467 114.082 217.467 113.709 217.467 113.523Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M217.467 114.269L220.823 112.777C220.823 112.964 220.823 113.337 220.823 113.523L217.467 115.015C217.467 114.828 217.467 114.455 217.467 114.269Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M217.467 115.202L220.823 113.71C220.823 113.896 220.823 114.269 220.823 114.456L217.467 115.947C217.467 115.761 217.467 115.388 217.467 115.202Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M217.467 115.947L220.823 114.455C220.823 114.642 220.823 115.014 220.823 115.201L217.467 116.692C217.467 116.506 217.467 116.133 217.467 115.947Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M217.28 116.692L220.636 115.2C220.636 115.387 220.636 115.76 220.636 115.946L217.28 117.438C217.28 117.251 217.28 116.878 217.28 116.692Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M217.28 117.439L220.636 115.947C220.636 116.134 220.636 116.507 220.636 116.693L217.28 118.185C217.28 117.998 217.28 117.625 217.28 117.439Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M217.094 118.185L220.45 116.693C220.45 116.88 220.45 117.253 220.45 117.439L217.094 118.931C217.094 118.744 217.094 118.371 217.094 118.185Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M216.907 118.93L220.263 117.438C220.263 117.625 220.263 117.998 220.077 118.184L216.721 119.676C216.721 119.489 216.721 119.117 216.907 118.93Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M216.721 119.675L220.077 118.184C220.077 118.37 220.077 118.743 219.891 118.929L216.534 120.421C216.534 120.235 216.534 119.862 216.721 119.675Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M216.535 120.421L219.891 118.93C219.891 119.116 219.704 119.489 219.518 119.675L216.162 121.167C216.162 120.981 216.348 120.608 216.535 120.421Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M216.162 121.168L219.518 119.677C219.518 119.863 219.331 120.236 219.145 120.423L215.789 121.914C215.789 121.728 215.975 121.355 216.162 121.168Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M215.789 121.913L219.145 120.422C219.145 120.795 218.772 120.981 218.585 121.354L215.229 122.846C215.229 122.659 215.602 122.286 215.789 121.913Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M215.229 122.845L218.585 121.354C218.399 121.726 218.026 122.099 217.84 122.286L214.484 123.777C214.67 123.404 215.043 123.218 215.229 122.845Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M214.483 123.778L217.84 122.286C216.907 123.405 215.975 124.151 214.67 124.524L211.314 126.015C212.433 125.456 213.551 124.71 214.483 123.778Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M214.67 124.71L211.314 126.202C214.297 124.896 216.534 121.727 217.28 116.693C218.585 106.624 213.178 93.573 204.975 87.2338L208.331 85.7422C216.348 91.895 221.941 105.133 220.636 115.201C219.891 120.235 217.84 123.405 214.67 124.71Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M191.178 78.0974L194.534 76.6058C198.635 74.9278 203.856 75.86 209.263 79.9619L205.907 81.4535C200.5 77.3516 195.279 76.4194 191.178 78.0974Z"
      fill="white"
    />
    <mask
      id="mask30_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="191"
      y="75"
      width="19"
      height="7"
    >
      <path
        d="M191.178 78.0964L194.534 76.6049C198.635 74.9268 203.856 75.8591 209.263 79.9609L205.907 81.4525C200.5 77.3506 195.279 76.4184 191.178 78.0964Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask30_918_8688)">
      <path
        d="M191.177 78.0959L194.534 76.6043C195.093 76.4178 195.652 76.2314 196.398 76.0449L193.042 77.5365C192.483 77.5365 191.737 77.9094 191.177 78.0959Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.042 77.5355L196.398 76.0439C196.957 76.0439 197.33 76.0439 197.89 75.8574L194.534 77.349C193.974 77.349 193.601 77.349 193.042 77.5355Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M194.534 77.1625L197.89 75.6709C198.262 75.6709 198.635 75.6709 199.195 75.6709L195.839 77.1625C195.466 77.1625 195.093 77.1625 194.534 77.1625Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M195.652 77.1625L199.008 75.6709C199.381 75.6709 199.754 75.6709 200.127 75.6709L196.771 77.1625C196.398 77.1625 196.025 77.1625 195.652 77.1625Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M196.771 77.349L200.127 75.8574C200.5 75.8574 200.686 75.8574 201.059 75.8574L197.703 77.349C197.33 77.349 196.957 77.349 196.771 77.349Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.703 77.5365L201.059 76.0449C201.432 76.0449 201.619 76.0449 201.991 76.2314L198.635 77.723C198.263 77.723 198.076 77.723 197.703 77.5365Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M198.635 77.7211L201.991 76.2295C202.364 76.2295 202.551 76.2295 202.924 76.4159L199.568 77.9075C199.195 77.9075 199.008 77.7211 198.635 77.7211Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.568 77.9076L202.924 76.416C203.11 76.416 203.483 76.6025 203.67 76.7889L200.313 78.2805C200.127 78.2805 199.754 78.0941 199.568 77.9076Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.5 78.2816L203.856 76.79C204.042 76.79 204.415 76.9765 204.602 77.1629L201.246 78.6545C201.059 78.6545 200.686 78.4681 200.5 78.2816Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.246 78.6537L204.602 77.1621C204.788 77.1621 205.161 77.3486 205.348 77.535L201.992 79.0266C201.805 79.0266 201.432 78.8401 201.246 78.6537Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.991 79.0267L205.348 77.5352C205.534 77.5352 205.907 77.7216 206.093 77.9081L202.737 79.3996C202.551 79.3996 202.178 79.0267 201.991 79.0267Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.924 79.4008L206.28 77.9092C206.466 77.9092 206.839 78.2821 207.026 78.2821L203.67 79.7737C203.483 79.7737 203.11 79.4008 202.924 79.4008Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.67 79.9594L207.026 78.4678C207.212 78.4678 207.585 78.8407 207.771 79.0271L204.415 80.5187C204.229 80.5187 203.856 80.1458 203.67 79.9594Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.415 80.3324L207.771 78.8408C207.958 78.8408 208.331 79.2137 208.517 79.4002L205.161 80.8918C204.975 80.7053 204.602 80.5189 204.415 80.3324Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M205.348 80.891L208.704 79.3994C208.89 79.3994 209.077 79.7723 209.263 79.7723L205.907 81.2639C205.72 81.2639 205.534 80.891 205.348 80.891Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M191.178 78.0974L194.534 76.6058C198.635 74.9278 203.856 75.86 209.263 79.9619L205.907 81.4535C200.5 77.3516 195.279 76.4194 191.178 78.0974Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M217.467 131.422L214.111 132.913C218.213 131.235 221.009 126.947 221.942 120.235C223.62 106.997 216.535 89.6572 205.721 81.4535L209.077 79.9619C219.704 88.1656 226.976 105.505 225.298 118.743C224.365 125.269 221.569 129.744 217.467 131.422Z"
      fill="white"
    />
    <mask
      id="mask31_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="205"
      y="79"
      width="21"
      height="54"
    >
      <path
        d="M217.467 131.421L214.111 132.912C218.213 131.234 221.009 126.946 221.942 120.234C223.62 106.996 216.535 89.6563 205.721 81.4525L209.077 79.9609C219.704 88.1647 226.976 105.504 225.298 118.742C224.365 125.268 221.569 129.743 217.467 131.421Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask31_918_8688)">
      <path
        d="M205.907 81.4525L209.263 79.9609C209.263 79.9609 209.263 79.9609 209.45 79.9609L206.093 81.4525C206.093 81.4525 206.093 81.4525 205.907 81.4525Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M206.094 81.639L209.45 80.1475C209.636 80.3339 210.009 80.5204 210.195 80.8933L206.839 82.3848C206.653 82.1984 206.28 82.0119 206.094 81.639Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M206.839 82.1976L210.195 80.7061C210.382 80.8925 210.755 81.079 210.941 81.4519L207.585 82.9434C207.399 82.757 207.026 82.3841 206.839 82.1976Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.772 82.9428L211.128 81.4512C211.314 81.6376 211.687 82.0105 211.873 82.197L208.517 83.6886C208.331 83.5021 207.958 83.1292 207.772 82.9428Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M208.517 83.6908L211.873 82.1992C212.06 82.3857 212.433 82.7586 212.619 82.945L209.263 84.4366C209.077 84.2502 208.704 83.8773 208.517 83.6908Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M209.263 84.4359L212.619 82.9443C212.992 83.3172 213.179 83.5037 213.365 83.8766L210.009 85.3682C209.822 84.9953 209.45 84.8088 209.263 84.4359Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M210.195 85.3676L213.551 83.876C213.738 84.2489 214.111 84.4353 214.297 84.8082L210.941 86.2998C210.755 85.9269 210.382 85.7405 210.195 85.3676Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M210.941 86.3002L214.297 84.8086C214.484 85.1815 214.857 85.3679 215.043 85.7408L211.687 87.2324C211.501 86.8595 211.128 86.4866 210.941 86.3002Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M211.873 87.2318L215.23 85.7402C215.416 86.1131 215.789 86.2996 215.975 86.6725L212.619 88.1641C212.433 87.7912 212.06 87.4183 211.873 87.2318Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.619 88.1644L215.975 86.6729C216.162 87.0457 216.535 87.4186 216.721 87.6051L213.365 89.0967C213.178 88.7238 212.806 88.3509 212.619 88.1644Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M213.365 89.2836L216.721 87.792C216.908 88.1649 217.28 88.5378 217.467 88.7242L214.111 90.2158C213.924 89.8429 213.738 89.47 213.365 89.2836Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M213.924 90.2152L217.28 88.7236C217.467 89.0965 217.653 89.4694 218.026 89.8423L214.67 91.3339C214.484 90.961 214.297 90.5881 213.924 90.2152Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M214.67 91.3334L218.026 89.8418C218.213 90.2147 218.399 90.5876 218.772 90.9605L215.416 92.4521C215.23 92.0792 215.043 91.7063 214.67 91.3334Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M215.416 92.4525L218.772 90.9609C218.958 91.3338 219.331 91.8932 219.518 92.2661L216.162 93.7577C215.975 93.3848 215.602 92.8254 215.416 92.4525Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M216.162 93.7582L219.518 92.2666C219.891 93.0124 220.264 93.5717 220.636 94.3175L217.28 95.8091C216.908 95.0633 216.535 94.504 216.162 93.7582Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M217.28 95.81L220.636 94.3184C221.009 95.2506 221.569 95.9964 221.942 96.9286L218.586 98.4202C218.213 97.488 217.84 96.5557 217.28 95.81Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M218.399 98.4193L221.755 96.9277C221.942 97.4871 222.315 98.2329 222.501 98.9787L219.145 100.47C218.958 99.7245 218.586 99.1651 218.399 98.4193Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M219.331 100.47L222.687 98.9785C222.687 99.3514 223.06 99.9108 223.247 100.284L219.891 101.775C219.891 101.402 219.518 100.843 219.331 100.47Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M219.704 101.775L223.06 100.283C223.06 100.656 223.247 101.029 223.433 101.402L220.077 102.893C220.077 102.521 219.891 102.148 219.704 101.775Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M220.077 102.894L223.433 101.402C223.433 101.775 223.62 102.148 223.806 102.521L220.45 104.013C220.45 103.64 220.264 103.267 220.077 102.894Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M220.45 104.013L223.806 102.521C223.806 102.894 223.993 103.267 224.179 103.64L220.823 105.132C220.823 104.759 220.636 104.386 220.45 104.013Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M220.823 105.132L224.179 103.641C224.179 104.014 224.365 104.386 224.365 104.759L221.009 106.251C221.009 105.878 221.009 105.505 220.823 105.132Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M221.009 106.064L224.365 104.572C224.365 104.945 224.365 105.318 224.552 105.691L221.196 107.183C221.196 106.81 221.196 106.437 221.009 106.064Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M221.196 107.182L224.552 105.69C224.552 106.063 224.552 106.436 224.738 106.809L221.382 108.301C221.382 107.928 221.382 107.555 221.196 107.182Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M221.569 108.301L224.925 106.81C224.925 107.182 224.925 107.555 225.111 107.928L221.755 109.42C221.755 109.047 221.755 108.674 221.569 108.301Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M221.755 109.419L225.111 107.928C225.111 108.301 225.111 108.674 225.111 109.046L221.755 110.538C221.755 110.165 221.755 109.792 221.755 109.419Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M221.942 110.538L225.298 109.047C225.298 109.42 225.298 109.793 225.298 110.166L221.942 111.657C221.942 111.284 221.942 110.911 221.942 110.538Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M222.128 111.843L225.484 110.352C225.484 110.724 225.484 111.097 225.484 111.47L222.128 112.962C222.128 112.589 222.128 112.216 222.128 111.843Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M222.128 112.962L225.484 111.471C225.484 111.844 225.484 112.217 225.484 112.589L222.128 114.081C222.128 113.708 222.128 113.335 222.128 112.962Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M222.315 114.08L225.671 112.589C225.671 112.962 225.671 113.335 225.671 113.708L222.315 115.199C222.315 114.826 222.315 114.453 222.315 114.08Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M222.315 115.013L225.671 113.521C225.671 113.894 225.671 114.267 225.671 114.64L222.315 116.132C222.315 115.759 222.315 115.386 222.315 115.013Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M222.315 116.132L225.671 114.641C225.671 115.014 225.671 115.386 225.671 115.759L222.315 117.251C222.315 116.878 222.315 116.505 222.315 116.132Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M222.315 117.251L225.671 115.76C225.671 116.133 225.671 116.506 225.671 116.878L222.315 118.37C222.315 117.997 222.315 117.624 222.315 117.251Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M222.315 118.183L225.671 116.691C225.671 117.064 225.671 117.437 225.671 117.624L222.315 119.115C222.315 118.742 222.315 118.369 222.315 118.183Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M222.128 119.301L225.484 117.81C225.484 118.182 225.484 118.369 225.484 118.742L222.128 120.233C222.128 119.861 222.128 119.674 222.128 119.301Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M222.128 120.234L225.484 118.742C225.484 119.115 225.484 119.488 225.484 119.674L222.128 121.166C222.128 120.793 222.128 120.42 222.128 120.234Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M221.942 121.165L225.298 119.674C225.298 120.047 225.298 120.42 225.111 120.606L221.755 122.098C221.755 121.725 221.755 121.538 221.942 121.165Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M221.755 122.285L225.111 120.793C225.111 121.166 225.111 121.539 224.925 121.725L221.569 123.217C221.569 122.844 221.569 122.471 221.755 122.285Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M221.382 123.216L224.738 121.725C224.738 122.098 224.738 122.47 224.552 122.657L221.196 124.148C221.196 123.776 221.382 123.589 221.382 123.216Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M221.196 124.149L224.552 122.657C224.552 123.03 224.365 123.403 224.179 123.589L220.823 125.081C220.823 124.708 221.009 124.335 221.196 124.149Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M220.823 125.268L224.179 123.776C224.179 124.149 223.993 124.522 223.806 124.895L220.45 126.387C220.45 126.014 220.823 125.641 220.823 125.268Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M220.45 126.2L223.806 124.708C223.806 125.081 223.433 125.454 223.247 125.827L219.891 127.318C219.891 126.945 220.264 126.572 220.45 126.2Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M219.891 127.319L223.247 125.827C223.06 126.2 222.874 126.573 222.501 126.946L219.145 128.437C219.331 128.065 219.518 127.692 219.891 127.319Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M219.331 128.438L222.687 126.946C222.315 127.506 222.128 127.879 221.755 128.251L218.399 129.743C218.772 129.37 219.145 128.811 219.331 128.438Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M218.213 129.743L221.569 128.251C220.45 129.556 218.959 130.675 217.467 131.234L214.111 132.726C215.602 132.166 217.094 131.048 218.213 129.743Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M217.467 131.422L214.111 132.913C218.213 131.235 221.009 126.947 221.942 120.235C223.62 106.997 216.535 89.6572 205.721 81.4535L209.077 79.9619C219.704 88.1656 226.976 105.505 225.298 118.743C224.365 125.269 221.569 129.744 217.467 131.422Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M188.194 70.827L191.55 69.3355C196.771 67.0981 203.297 68.4032 210.195 73.6238L206.839 75.1154C200.127 69.8948 193.415 68.5897 188.194 70.827Z"
      fill="white"
    />
    <mask
      id="mask32_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="188"
      y="68"
      width="23"
      height="8"
    >
      <path
        d="M188.194 70.828L191.55 69.3364C196.771 67.0991 203.297 68.4042 210.195 73.6248L206.839 75.1163C200.127 69.8958 193.415 68.5906 188.194 70.828Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask32_918_8688)">
      <path
        d="M188.194 70.8292L191.55 69.3376C192.296 68.9647 193.042 68.7782 193.788 68.5918L190.432 70.0834C189.686 70.0834 188.94 70.4563 188.194 70.8292Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M190.432 70.0823L193.788 68.5907C194.347 68.5907 195.093 68.4043 195.652 68.4043L192.296 69.8959C191.737 69.8959 190.991 69.8959 190.432 70.0823Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M192.296 69.7094L195.652 68.2178C196.212 68.2178 196.771 68.2178 197.144 68.2178L193.788 69.7094C193.228 69.7094 192.669 69.7094 192.296 69.7094Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.788 69.7094L197.144 68.2178C197.517 68.2178 198.076 68.2178 198.449 68.2178L195.093 69.7094C194.72 69.7094 194.161 69.7094 193.788 69.7094Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M195.279 69.8959L198.635 68.4043C199.008 68.4043 199.381 68.4043 199.941 68.5907L196.584 70.0823C196.212 70.0823 195.839 70.0823 195.279 69.8959Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M196.398 70.0834L199.754 68.5918C200.127 68.5918 200.5 68.5918 200.873 68.7782L197.517 70.2698C197.144 70.2698 196.771 70.0834 196.398 70.0834Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.703 70.2689L201.059 68.7773C201.432 68.7773 201.805 68.9638 202.178 69.1502L198.822 70.6418C198.449 70.6418 198.076 70.4554 197.703 70.2689Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M198.822 70.642L202.178 69.1504C202.551 69.1504 202.924 69.3368 203.297 69.5233L199.941 71.0149C199.568 71.0149 199.195 70.8284 198.822 70.642Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.754 71.015L203.11 69.5234C203.483 69.5234 203.856 69.8963 204.229 69.8963L200.873 71.3879C200.5 71.3879 200.127 71.015 199.754 71.015Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.873 71.5736L204.229 70.082C204.602 70.082 204.975 70.4549 205.161 70.6414L201.805 72.133C201.432 72.133 201.059 71.7601 200.873 71.5736Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.991 71.9476L205.347 70.4561C205.72 70.4561 206.093 70.829 206.28 71.0154L202.924 72.507C202.551 72.3205 202.178 72.1341 201.991 71.9476Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.924 72.5072L206.28 71.0156C206.653 71.0156 207.026 71.3885 207.212 71.575L203.856 73.0666C203.483 72.8801 203.11 72.6937 202.924 72.5072Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.856 73.0658L207.212 71.5742C207.585 71.7607 207.958 71.9471 208.144 72.1336L204.788 73.6251C204.415 73.4387 204.042 73.2523 203.856 73.0658Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.975 73.8119L208.331 72.3203C208.704 72.5068 209.076 72.6932 209.263 73.0661L205.907 74.5577C205.534 74.3712 205.161 73.9983 204.975 73.8119Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M205.907 74.557L209.263 73.0654C209.449 73.2519 209.822 73.4383 210.009 73.6248L206.653 75.1164C206.466 74.9299 206.093 74.7435 205.907 74.557Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M188.194 70.827L191.55 69.3355C196.771 67.0981 203.297 68.4032 210.195 73.6238L206.839 75.1154C200.127 69.8948 193.415 68.5897 188.194 70.827Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M220.636 138.694L217.28 140.185C222.314 137.948 226.043 132.541 227.162 124.151C229.399 107.37 220.264 85.3693 206.653 75.1146L210.009 73.623C223.433 83.8777 232.756 105.879 230.518 122.659C229.399 131.049 225.671 136.456 220.636 138.694Z"
      fill="white"
    />
    <mask
      id="mask33_918_8688"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="206"
      y="73"
      width="25"
      height="68"
    >
      <path
        d="M220.636 138.694L217.28 140.185C222.314 137.948 226.043 132.541 227.162 124.151C229.399 107.37 220.264 85.3693 206.653 75.1146L210.009 73.623C223.433 83.8777 232.756 105.879 230.518 122.659C229.399 131.049 225.671 136.456 220.636 138.694Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask33_918_8688)">
      <path
        d="M206.653 75.1146L210.009 73.623C210.009 73.623 210.009 73.623 210.195 73.623L206.839 75.1146C206.839 75.1146 206.839 75.1146 206.653 75.1146Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.026 75.3012L210.382 73.8096C210.755 73.996 211.128 74.3689 211.5 74.5554L208.144 76.047C207.771 75.6741 207.399 75.4876 207.026 75.3012Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.958 76.0473L211.314 74.5557C211.687 74.9286 212.06 75.115 212.433 75.4879L209.077 76.9795C208.704 76.6066 208.331 76.4201 207.958 76.0473Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M209.077 76.9789L212.433 75.4873C212.806 75.8602 213.178 76.0467 213.551 76.4195L210.195 77.9111C209.822 77.5382 209.449 77.3518 209.077 76.9789Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M210.009 77.9115L213.365 76.4199C213.738 76.7928 214.111 77.1657 214.484 77.5386L211.127 79.0302C210.755 78.6573 210.382 78.2844 210.009 77.9115Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M211.128 79.0307L214.484 77.5391C214.857 77.912 215.229 78.2849 215.602 78.6578L212.246 80.1493C211.873 79.7764 211.5 79.4036 211.128 79.0307Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.06 80.1488L215.416 78.6572C215.789 79.0301 216.162 79.403 216.535 79.7759L213.179 81.2675C212.806 80.8946 212.433 80.5217 212.06 80.1488Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M213.178 81.267L216.535 79.7754C216.907 80.1483 217.28 80.5212 217.467 81.0805L214.111 82.5721C213.738 82.1992 213.365 81.8263 213.178 81.267Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M214.297 82.3861L217.653 80.8945C218.026 81.2674 218.399 81.6403 218.586 82.1997L215.229 83.6913C214.857 83.3184 214.67 82.9455 214.297 82.3861Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M215.229 83.6918L218.585 82.2002C218.958 82.5731 219.145 83.1324 219.518 83.5053L216.162 84.9969C215.789 84.624 215.602 84.0647 215.229 83.6918Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M216.162 84.9955L219.518 83.5039C219.891 83.8768 220.077 84.4362 220.45 84.809L217.094 86.3006C216.721 85.9277 216.535 85.3684 216.162 84.9955Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M217.094 86.3012L220.45 84.8096C220.823 85.1825 221.009 85.7418 221.382 86.1147L218.026 87.6063C217.653 87.2334 217.467 86.6741 217.094 86.3012Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M217.84 87.6078L221.196 86.1162C221.569 86.4891 221.755 87.0485 222.128 87.4214L218.772 88.9129C218.399 88.3536 218.213 87.9807 217.84 87.6078Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M218.772 88.9115L222.128 87.4199C222.501 87.9793 222.874 88.5386 223.06 89.098L219.704 90.5895C219.331 90.0302 219.145 89.4709 218.772 88.9115Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M219.704 90.5892L223.06 89.0977C223.62 90.0299 223.992 90.7757 224.365 91.7079L221.009 93.1995C220.636 92.2673 220.077 91.5215 219.704 90.5892Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M221.009 93.2006L224.365 91.709C224.925 92.8277 225.484 93.9464 225.857 95.0651L222.501 96.5566C221.942 95.438 221.569 94.3193 221.009 93.2006Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M222.687 96.7435L226.043 95.252C226.416 95.9977 226.789 96.93 226.976 97.6758L223.62 99.1674C223.247 98.4216 223.06 97.4893 222.687 96.7435Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M223.62 99.1664L226.976 97.6748C227.162 98.2342 227.349 98.7935 227.535 99.3528L224.179 100.844C223.993 100.285 223.806 99.7257 223.62 99.1664Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M224.179 100.844L227.535 99.3525C227.535 99.9119 227.908 100.285 228.094 100.844L224.738 102.336C224.738 101.776 224.365 101.403 224.179 100.844Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M224.738 102.336L228.094 100.845C228.094 101.218 228.467 101.777 228.467 102.15L225.111 103.641C225.111 103.269 224.925 102.709 224.738 102.336Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M225.111 103.641L228.467 102.149C228.467 102.522 228.654 103.082 228.84 103.455L225.484 104.946C225.484 104.573 225.298 104.014 225.111 103.641Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M225.484 104.947L228.84 103.455C228.84 103.828 229.027 104.387 229.213 104.76L225.857 106.252C225.857 105.879 225.671 105.32 225.484 104.947Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M225.857 106.437L229.213 104.945C229.213 105.318 229.399 105.878 229.586 106.25L226.23 107.742C226.23 107.369 226.043 106.81 225.857 106.437Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M226.23 107.744L229.586 106.252C229.586 106.811 229.772 107.184 229.959 107.744L226.603 109.235C226.603 108.676 226.416 108.303 226.23 107.744Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M226.416 109.049L229.772 107.558C229.772 108.117 229.772 108.49 229.959 109.049L226.603 110.541C226.603 109.981 226.603 109.609 226.416 109.049Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M226.789 110.539L230.145 109.048C230.145 109.607 230.145 109.98 230.332 110.539L226.976 112.031C226.976 111.472 226.976 111.099 226.789 110.539Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M226.976 112.032L230.332 110.54C230.332 111.099 230.332 111.472 230.518 112.032L227.162 113.523C227.162 112.964 227.162 112.591 226.976 112.032Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M227.162 113.523L230.518 112.031C230.518 112.591 230.518 112.963 230.518 113.523L227.162 115.014C227.162 114.455 227.162 114.082 227.162 113.523Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M227.349 114.828L230.705 113.336C230.705 113.895 230.705 114.268 230.705 114.828L227.349 116.319C227.349 115.76 227.349 115.387 227.349 114.828Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M227.349 116.321L230.705 114.829C230.705 115.202 230.705 115.761 230.705 116.134L227.349 117.626C227.349 117.253 227.349 116.694 227.349 116.321Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M227.535 117.624L230.891 116.133C230.891 116.506 230.891 117.065 230.891 117.438L227.535 118.93C227.535 118.557 227.535 117.997 227.535 117.624Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M227.535 118.93L230.891 117.438C230.891 117.811 230.891 118.371 230.891 118.744L227.535 120.235C227.535 119.862 227.535 119.303 227.535 118.93Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M227.535 120.236L230.891 118.744C230.891 119.117 230.891 119.676 230.891 120.049L227.535 121.541C227.535 121.168 227.535 120.609 227.535 120.236Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M227.349 121.54L230.705 120.049C230.705 120.422 230.705 120.981 230.705 121.354L227.349 122.846C227.349 122.473 227.349 121.913 227.349 121.54Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M227.349 122.845L230.705 121.354C230.705 121.726 230.705 122.099 230.705 122.472L227.349 123.964C227.349 123.591 227.349 123.218 227.349 122.845Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M227.162 124.15L230.518 122.658C230.518 123.031 230.518 123.59 230.332 123.963L226.976 125.455C226.976 125.082 226.976 124.523 227.162 124.15Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M226.976 125.456L230.332 123.965C230.332 124.338 230.332 124.711 230.145 125.27L226.789 126.762C226.789 126.389 226.789 126.016 226.976 125.456Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M226.789 126.761L230.145 125.27C230.145 125.642 229.959 126.202 229.772 126.575L226.416 128.066C226.416 127.693 226.603 127.32 226.789 126.761Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M226.416 127.879L229.772 126.388C229.772 126.761 229.586 127.133 229.4 127.693L226.043 129.184C226.043 128.812 226.23 128.439 226.416 127.879Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M226.043 129.185L229.4 127.693C229.4 128.066 229.213 128.626 229.027 128.998L225.671 130.49C225.671 130.117 226.043 129.744 226.043 129.185Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M225.671 130.491L229.027 128.999C229.027 129.372 228.654 129.931 228.467 130.304L225.111 131.796C225.111 131.423 225.484 130.864 225.671 130.491Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M225.111 131.795L228.467 130.304C228.281 130.677 228.094 131.236 227.908 131.609L224.552 133.1C224.738 132.728 224.925 132.168 225.111 131.795Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M224.552 133.1L227.908 131.608C227.721 132.168 227.349 132.541 227.162 133.1L223.806 134.592C224.179 134.219 224.365 133.659 224.552 133.1Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M223.62 134.405L226.976 132.913C226.603 133.472 226.23 134.032 225.671 134.591L222.314 136.083C222.687 135.523 223.247 134.964 223.62 134.405Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M222.501 136.083L225.857 134.592C224.365 136.27 222.687 137.575 220.636 138.507L217.28 139.999C219.145 139.253 221.009 137.948 222.501 136.083Z"
        fill="white"
        stroke="#4D5055"
        strokeWidth="0.372897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M220.636 138.694L217.28 140.185C222.314 137.948 226.043 132.541 227.162 124.151C229.399 107.37 220.264 85.3693 206.653 75.1146L210.009 73.623C223.433 83.8777 232.756 105.879 230.518 122.659C229.399 131.049 225.671 136.456 220.636 138.694Z"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M206.653 75.1149C220.077 85.3695 229.399 107.37 227.162 124.151C224.925 140.931 212.246 146.152 198.635 135.897C185.211 125.642 175.889 103.641 178.126 86.8611C180.363 70.0807 193.042 64.8602 206.653 75.1149ZM199.568 129.371C210.195 137.575 220.263 133.473 222.128 120.049C223.806 106.811 216.721 89.4714 205.907 81.2677C195.279 73.0639 185.211 77.1658 183.347 90.5901C181.669 103.828 188.754 121.168 199.568 129.371Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M205.907 81.4543C216.535 89.658 223.806 106.998 222.128 120.236C220.45 133.473 210.382 137.575 199.568 129.558C188.94 121.354 181.669 104.015 183.347 90.7767C185.025 77.5389 195.093 73.437 205.907 81.4543ZM200.314 123.592C208.331 129.744 215.975 126.575 217.28 116.507C218.585 106.438 213.178 93.387 204.975 87.0477C196.957 80.8949 189.313 84.0646 188.008 94.1328C186.703 104.201 192.11 117.252 200.314 123.592Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M217.28 116.692C218.585 106.624 213.178 93.5729 204.975 87.2336C196.957 81.0808 189.313 84.2504 188.008 94.3187C186.703 104.387 192.11 117.438 200.313 123.778C208.331 129.93 215.975 126.761 217.28 116.692ZM201.059 117.625C195.652 113.523 191.923 104.76 192.856 98.0476C193.788 91.3355 198.822 89.2845 204.229 93.3864C209.636 97.4883 213.365 106.251 212.433 112.964C211.5 119.676 206.466 121.727 201.059 117.625Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M235.552 124.896C235.739 122.845 235.739 120.608 235.739 118.557C235.739 115.201 235.179 111.659 234.62 108.302C233.128 100.658 230.332 93.2001 226.416 86.3015C225.67 84.9964 224.925 83.8777 224.179 82.5726C220.823 77.352 216.907 72.6908 212.246 68.7754C205.907 63.3684 196.771 59.08 188.381 62.4361L185.025 63.9277C203.11 57.5885 219.891 79.7758 226.043 94.3188C232.755 109.235 237.79 138.134 219.891 147.084C223.806 145.592 227.721 143.541 230.145 139.999C233.315 135.71 234.993 130.567 235.552 125.347V124.896Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M207.585 68.9613C223.806 81.2669 234.806 107.743 232.01 127.693C229.399 147.829 214.111 153.982 197.89 141.676C181.669 129.371 170.668 102.895 173.278 82.9449C175.889 62.8085 191.178 56.6557 207.399 68.9613H207.585ZM198.635 135.71C212.06 145.965 224.925 140.744 227.162 123.964C229.399 107.183 220.263 85.1823 206.653 74.9277C193.228 64.673 180.364 69.8936 178.126 86.6739C175.889 103.454 185.025 125.455 198.635 135.71Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M203.483 98.7935C206.466 101.031 208.331 105.879 207.958 109.421C207.398 113.15 204.788 114.269 201.805 112.031C198.822 109.794 196.957 104.946 197.33 101.404C197.89 97.6748 200.5 96.5561 203.483 98.7935Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M202.551 105.318C202.178 104.758 201.619 104.385 201.059 104.572L144.938 137.014L146.243 139.251L202.364 106.809C202.737 106.623 202.737 105.877 202.364 105.131L202.551 105.318Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M144.938 138.693C145.311 139.252 145.87 139.625 146.43 139.438C146.989 139.252 146.803 138.506 146.43 137.76C146.057 137.015 145.498 136.828 144.938 137.015C144.565 137.201 144.565 137.947 144.938 138.693Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M147.176 136.268L138.972 138.691L127.785 145.031L133.006 145.59L134.87 148.946L146.057 142.42L147.176 136.268Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.372897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M450.527 471.132H425.73L427.035 487.539C427.035 487.539 427.035 487.539 427.035 487.726C427.035 492.76 432.069 496.675 438.035 496.675C444.002 496.675 449.036 492.573 449.036 487.726C449.036 482.878 449.036 487.726 449.036 487.539L450.341 471.132H450.527Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M450.527 471.132C450.527 476.166 444.934 480.082 438.222 480.082C431.51 480.082 425.916 475.98 425.916 471.132C425.916 466.284 431.51 462.183 438.222 462.183C444.934 462.183 450.527 466.284 450.527 471.132Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M445.307 459.386C445.307 458.827 444.934 458.454 444.561 458.454C444.002 458.454 443.629 458.827 443.629 459.2C443.442 461.437 441.391 462.369 439.9 462.929C439.9 462.183 439.9 461.624 440.273 460.878C440.273 460.318 440.459 459.759 440.646 459.2C441.205 457.335 441.951 454.538 441.951 452.488C441.951 450.437 441.391 443.165 441.391 442.979C441.391 442.233 440.646 441.487 439.713 441.674C438.967 441.674 438.222 442.419 438.408 443.352C438.408 443.352 438.967 449.877 438.967 452.488C438.967 455.098 438.222 456.776 437.662 458.454C437.476 459.386 437.289 459.945 437.103 460.318C436.171 466.285 436.357 470.387 437.103 472.997C437.289 473.556 437.849 473.929 438.595 473.929C439.34 473.929 438.967 473.929 439.154 473.929C439.9 473.743 440.273 472.81 440.086 472.065C439.713 470.946 439.34 468.709 439.713 464.98C441.578 464.42 444.934 463.115 445.493 459.573L445.307 459.386Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M459.29 446.335C459.29 443.911 457.426 441.86 455.189 441.3C455.561 440.368 455.748 439.25 455.748 438.131C455.748 432.724 451.46 428.436 446.053 428.436C440.646 428.436 436.917 432.164 436.544 437.012C435.798 436.639 435.052 436.453 434.306 436.453C432.628 436.453 431.323 437.199 430.391 438.317C426.103 439.25 422.933 443.165 422.933 447.826C422.933 452.487 425.73 455.657 429.459 456.962C430.204 459.013 432.069 460.505 434.306 460.505C436.544 460.505 438.035 459.2 438.968 457.521C440.459 460.878 443.815 463.115 447.731 463.115C451.646 463.115 457.426 458.827 457.426 453.42C457.426 448.013 457.239 451.555 457.053 450.623C458.545 449.691 459.477 448.199 459.477 446.335H459.29Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M68.3079 263.055H43.5103L44.8154 279.462C44.8154 279.462 44.8154 279.462 44.8154 279.649C44.8154 284.683 49.8495 288.598 55.8159 288.598C61.7822 288.598 66.8163 284.496 66.8163 279.649C66.8163 274.801 66.8163 279.649 66.8163 279.462L68.1215 263.055H68.3079Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M68.3078 263.055C68.3078 268.089 62.7144 272.005 56.0022 272.005C49.2901 272.005 43.6966 267.903 43.6966 263.055C43.6966 258.207 49.2901 254.105 56.0022 254.105C62.7144 254.105 68.3078 258.207 68.3078 263.055Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M63.2737 251.495C63.2737 250.936 62.9008 250.563 62.528 250.563C61.9686 250.563 61.5957 250.936 61.5957 251.309C61.4093 253.546 59.3583 254.479 57.8667 255.038C57.8667 254.292 57.8667 253.733 58.2396 252.987C58.2396 252.428 58.4261 251.868 58.6125 251.309C59.1719 249.445 59.9177 246.648 59.9177 244.597C59.9177 242.546 59.3583 235.274 59.3583 235.088C59.3583 234.342 58.6125 233.596 57.6803 233.783C56.9345 233.783 56.1887 234.529 56.3751 235.461C56.3751 235.461 56.9345 241.987 56.9345 244.597C56.9345 247.207 56.1887 248.885 55.6294 250.563C55.4429 251.495 55.2565 252.055 55.07 252.428C54.1378 258.394 54.3242 262.496 55.07 265.106C55.2565 265.666 55.8158 266.038 56.5616 266.038C57.3074 266.038 56.9345 266.038 57.1209 266.038C57.8667 265.852 58.2396 264.92 58.0532 264.174C57.6803 263.055 57.3074 260.818 57.6803 257.089C59.5448 256.53 62.9008 255.224 63.4602 251.682L63.2737 251.495Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M77.071 238.444C77.071 236.02 75.2065 233.969 72.9691 233.41C73.342 232.478 73.5285 231.359 73.5285 230.24C73.5285 224.833 69.2402 220.545 63.8331 220.545C58.4261 220.545 54.6972 224.274 54.3243 229.122C53.5785 228.749 52.8327 228.562 52.0869 228.562C50.4089 228.562 49.1037 229.308 48.1715 230.427C43.8832 231.359 40.7135 235.274 40.7135 239.936C40.7135 244.597 43.5103 247.766 47.2392 249.072C47.985 251.122 49.8495 252.614 52.0869 252.614C54.3243 252.614 55.8159 251.309 56.7481 249.631C58.2397 252.987 61.5958 255.224 65.5112 255.224C69.4266 255.224 75.2065 250.936 75.2065 245.529C75.2065 240.122 75.0201 243.665 74.8336 242.732C76.3252 241.8 77.2574 240.308 77.2574 238.444H77.071Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="0.559346"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M844.814 241.946L844.916 224.896L846.234 224.118V241.144L844.814 241.946Z"
      fill="#8D9ABC"
      stroke="#4D5055"
      strokeWidth="1.09617"
    />
    <path
      d="M849.415 226.655L838.733 205.5L840.201 204.632L850.994 225.694L849.415 226.655Z"
      fill="#8D9ABC"
      stroke="#4D5055"
      strokeWidth="1.09617"
    />
    <path
      d="M838.012 205.289L849.193 227.432L844.37 224.582L844.26 242.888L831.435 235.543L831.545 217.237L826.722 214.387L838.012 205.289Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.876938"
      strokeMiterlimit="10"
    />
    <path
      d="M765.407 84.2323L765.517 65.9212L766.932 65.0853V83.3707L765.407 84.2323Z"
      fill="#8D9ABC"
      stroke="#4D5055"
      strokeWidth="1.17727"
    />
    <path
      d="M770.348 67.8112L758.876 45.0909L760.453 44.1588L772.045 66.7788L770.348 67.8112Z"
      fill="#8D9ABC"
      stroke="#4D5055"
      strokeWidth="1.17727"
    />
    <path
      d="M758.102 44.8643L770.11 68.6452L764.93 65.5843L764.812 85.2447L751.038 77.357L751.156 57.6965L745.976 54.6356L758.102 44.8643Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.941818"
      strokeMiterlimit="10"
    />
    <path
      d="M707.841 110.074L707.964 89.4978L709.75 88.4423V108.995L707.841 110.074Z"
      fill="#8D9ABC"
      stroke="#4D5055"
      strokeWidth="1.09096"
    />
    <path
      d="M713.392 91.8094L700.557 66.3914L702.494 65.2468L715.46 90.5502L713.392 91.8094Z"
      fill="#8D9ABC"
      stroke="#4D5055"
      strokeWidth="1.09096"
    />
    <path
      d="M699.84 66.1816L713.171 92.5825L707.42 89.1844L707.29 111.011L691.998 102.254L692.129 80.4277L686.378 77.0295L699.84 66.1816Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="0.87277"
      strokeMiterlimit="10"
    />
    <path
      d="M730.726 104.997L733.46 103.305V107.21L730.726 108.773V104.997Z"
      fill="#F97D8C"
    />
    <path
      d="M809.359 154.208V200.554C809.228 201.726 808.838 202.507 808.187 202.767L810.921 201.205C811.572 200.814 811.962 200.033 811.962 198.992V152.646C812.092 152.646 809.359 154.208 809.359 154.208Z"
      fill="#4D5055"
    />
    <path
      d="M730.726 104.997V108.772L809.489 154.207V200.554C809.359 202.767 807.796 203.678 805.844 202.507L734.111 161.238C732.158 160.066 730.596 157.332 730.596 155.119V104.997H730.726Z"
      fill="white"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeMiterlimit="10"
    />
    <path
      d="M730.726 108.772L733.46 107.21L812.223 152.645L809.359 154.207L730.726 108.772Z"
      fill="#F97D8C"
    />
    <path
      d="M802.198 137.804C806.234 140.147 809.489 145.745 809.489 150.432V154.208L730.726 108.773V104.997C730.726 100.31 733.981 98.4878 738.017 100.831L802.068 137.804H802.198Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M804.932 136.242L740.881 99.1391C738.798 97.9674 736.975 97.8372 735.673 98.6183L732.939 100.181C734.241 99.3994 736.064 99.5296 738.147 100.701L802.198 137.674C806.234 140.018 809.489 145.616 809.489 150.302V154.078L812.223 152.515V148.74C812.223 144.053 808.968 138.455 804.932 136.112V136.242Z"
      fill="#C2ECDF"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M784.753 145.876V149.131L774.859 143.533V140.278L784.753 145.876Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeMiterlimit="10"
    />
    <path
      d="M774.859 140.278V143.533L764.965 137.804L765.095 134.55L774.859 140.278Z"
      fill="#D7E4F9"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeMiterlimit="10"
    />
    <path
      d="M759.758 141.841L759.627 145.095L749.864 139.367V136.112L759.758 141.841Z"
      fill="#D7E4F9"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeMiterlimit="10"
    />
    <path
      d="M765.095 134.55L764.965 137.804L749.864 129.082V125.827L765.095 134.55Z"
      fill="#57F7B6"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M745.698 123.355V126.61L735.673 120.882V117.627L745.698 123.355Z"
      fill="#4D5055"
    />
    <path
      d="M745.698 133.769V137.023L735.673 131.165V127.91L745.698 133.769Z"
      fill="#4D5055"
    />
    <path
      d="M745.698 143.403L745.567 146.658L735.673 140.929V137.675L745.698 143.403Z"
      fill="#4D5055"
    />
    <path
      d="M745.567 153.557V156.812L735.673 151.084V147.829L745.567 153.557Z"
      fill="#4D5055"
    />
    <path
      d="M785.795 166.576V169.831L775.901 164.102V160.848L785.795 166.576Z"
      fill="#D7E4F9"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeMiterlimit="10"
    />
    <path
      d="M775.901 160.848V164.103L766.137 158.505V155.25L775.901 160.848Z"
      fill="#FFAF36"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M784.753 156.292L784.623 159.546L774.859 153.818V150.563L784.753 156.292Z"
      fill="#D7E4F9"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeMiterlimit="10"
    />
    <path
      d="M774.859 150.564V153.819L759.628 145.096L759.758 141.842L774.859 150.564Z"
      fill="#F97D8C"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeLinejoin="round"
    />
    <path
      d="M801.027 155.251V158.505L794.517 154.86V151.605L801.027 155.251Z"
      fill="#FFAF36"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M794.517 151.604V154.859L784.753 149.131V145.876L794.517 151.604Z"
      fill="#D7E4F9"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeMiterlimit="10"
    />
    <path
      d="M801.027 165.665L800.896 168.92L794.517 165.144V161.89L801.027 165.665Z"
      fill="#F7907F"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeLinejoin="round"
    />
    <path
      d="M794.517 161.889V165.144L784.623 159.546L784.753 156.291L794.517 161.889Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeMiterlimit="10"
    />
    <path
      d="M756.243 159.676V162.931L749.733 159.286V156.031L756.243 159.676Z"
      fill="#D7E4F9"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeMiterlimit="10"
    />
    <path
      d="M766.007 165.404V168.659L756.243 162.93V159.676L766.007 165.404Z"
      fill="#57F7B6"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M775.901 171.132V174.387L766.007 168.659V165.404L775.901 171.132Z"
      fill="#D7E4F9"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeMiterlimit="10"
    />
    <path
      d="M791.002 179.856V183.111L775.901 174.388V171.134L791.002 179.856Z"
      fill="#FFAF36"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M800.897 175.3V178.554L785.795 169.832V166.577L800.897 175.3Z"
      fill="#F97D8C"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeLinejoin="round"
    />
    <path
      d="M756.243 149.521V152.776L749.864 149.001V145.746L756.243 149.521Z"
      fill="#F7907F"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeLinejoin="round"
    />
    <path
      d="M766.137 155.251V158.505L756.243 152.777V149.522L766.137 155.251Z"
      fill="#D7E4F9"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeMiterlimit="10"
    />
    <path
      d="M800.897 185.584V188.838L791.002 183.11V179.855L800.897 185.584Z"
      fill="#D7E4F9"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeMiterlimit="10"
    />
    <path
      d="M791.133 135.462V139.758L749.864 115.934V111.638L791.133 135.462Z"
      fill="#57C9A7"
      stroke="#4D5055"
      strokeWidth="1.04149"
      strokeMiterlimit="10"
    />
  </svg>
)
